/**
 @typedef {Object} ScannedCode
 @property {string} prefix
 @property {string} barcode
 */
/**
 @typedef {Object.<any>} Property_Generic
 @property {string} value
 @property {string} error
 @property {string} type
 @property {bool} required
 @property {bool} update
 @property {string} label
 @property {string} helper
 @property {array} set
 @property {bool} searchable
 @property {bool} queryable
 @property {bool} visible
 @property {?string} override
 @property {?string} reference
 @property {Object} range
 @property {name} pkey
 */
/**
 @typedef {Object.<any>} Accounts
 @property {Accounts_Properties} properties
 @property {Accounts_Has} has
 @property {Accounts_Is} is
 @property {Accounts_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Properties
 @property {text|string} _id
 @property {text|string} ammoready_apikey
 @property {text|string} ammoready_password
 @property {text|string} ammoready_username
 @property {text|string} authy
 @property {boolean} authy_enabled
 @property {text|string} binary_id
 @property {boolean} bypass_auto_upgrade
 @property {text|string} c_id
 @property {text|string} city
 @property {text|string} city_limits
 @property {date|string} created
 @property {text|string} davidsons_account_number
 @property {text|string} ein
 @property {email} email
 @property {boolean} failed_billing
 @property {text|string} gunbroker_password
 @property {text|string} gunbroker_username
 @property {boolean} has_billing
 @property {date|string} last_logged_in
 @property {date|string} last_stripe_sync
 @property {text|string} leep_password
 @property {text|string} leep_username
 @property {number|int} locked_kiosk
 @property {text|string} locked_kiosk_binary_id
 @property {number|int} locked_location
 @property {text|string} locked_location_binary_id
 @property {tel|string} mobile
 @property {text|string} name_company
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_legal
 @property {tel|string} number
 @property {string} password
 @property {boolean} password_expired
 @property {string} password_new
 @property {date|string} password_set
 @property {string} password_temp
 @property {text|string} pin
 @property {number|int} pkey
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {number|int} system_locked
 @property {text|string} title
 @property {text|string} website
 @property {text|string} zip
 @property {text|string} archive_signature
 @property {text|string} end_pkey
 @property {text|string} g_recaptcha_response
 @property {number|int} kiosk
 @property {text|string} kiosk_binary_id
 @property {number|int} kiosk_mode
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {string} password_repeat
 @property {text|string} pin
 @property {text|string} start_pkey
 @property {boolean} system_lock_down
 */
/**
 @typedef {Object.<any>} Accounts_Has
 */
/**
 @typedef {Object.<any>} Accounts_Is
 @property {Kiosks_Object} kiosks
 @property {Locations_Object} locations
 */
/**
 @typedef {Object.<any>} Accounts_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} ammoready_apikey
 @property {string} ammoready_apikey_error
 @property {?text|string} ammoready_password
 @property {string} ammoready_password_error
 @property {?text|string} ammoready_username
 @property {string} ammoready_username_error
 @property {?text|string} authy
 @property {string} authy_error
 @property {?boolean} authy_enabled
 @property {string} authy_enabled_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?boolean} bypass_auto_upgrade
 @property {string} bypass_auto_upgrade_error
 @property {?text|string} c_id
 @property {string} c_id_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?date|string} created
 @property {string} created_error
 @property {?text|string} davidsons_account_number
 @property {string} davidsons_account_number_error
 @property {?text|string} ein
 @property {string} ein_error
 @property {?email} email
 @property {string} email_error
 @property {?boolean} failed_billing
 @property {string} failed_billing_error
 @property {?text|string} gunbroker_password
 @property {string} gunbroker_password_error
 @property {?text|string} gunbroker_username
 @property {string} gunbroker_username_error
 @property {?boolean} has_billing
 @property {string} has_billing_error
 @property {?date|string} last_logged_in
 @property {string} last_logged_in_error
 @property {?date|string} last_stripe_sync
 @property {string} last_stripe_sync_error
 @property {?text|string} leep_password
 @property {string} leep_password_error
 @property {?text|string} leep_username
 @property {string} leep_username_error
 @property {?number|int} locked_kiosk
 @property {string} locked_kiosk_error
 @property {?text|string} locked_kiosk_binary_id
 @property {string} locked_kiosk_binary_id_error
 @property {?number|int} locked_location
 @property {string} locked_location_error
 @property {?text|string} locked_location_binary_id
 @property {string} locked_location_binary_id_error
 @property {?tel|string} mobile
 @property {string} mobile_error
 @property {?text|string} name_company
 @property {string} name_company_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_legal
 @property {string} name_legal_error
 @property {?tel|string} number
 @property {string} number_error
 @property {?string} password
 @property {string} password_error
 @property {?boolean} password_expired
 @property {string} password_expired_error
 @property {?string} password_new
 @property {string} password_new_error
 @property {?date|string} password_set
 @property {string} password_set_error
 @property {?string} password_temp
 @property {string} password_temp_error
 @property {?text|string} pin
 @property {string} pin_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?number|int} system_locked
 @property {string} system_locked_error
 @property {?text|string} title
 @property {string} title_error
 @property {?text|string} website
 @property {string} website_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} archive_signature
 @property {string} archive_signature_error
 @property {?text|string} end_pkey
 @property {string} end_pkey_error
 @property {?text|string} g_recaptcha_response
 @property {string} g_recaptcha_response_error
 @property {?number|int} kiosk
 @property {string} kiosk_error
 @property {?text|string} kiosk_binary_id
 @property {string} kiosk_binary_id_error
 @property {?number|int} kiosk_mode
 @property {string} kiosk_mode_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?string} password_repeat
 @property {string} password_repeat_error
 @property {?text|string} pin
 @property {string} pin_error
 @property {?text|string} start_pkey
 @property {string} start_pkey_error
 @property {?boolean} system_lock_down
 @property {string} system_lock_down_error
 @property {Kiosks_Object} kiosks
 @property {Locations_Object} locations
 */
/**
 @typedef {Object.<any>} Cypress_Acquisitions
 @property {Cypress_Acquisitions_Properties} properties
 @property {Cypress_Acquisitions_Has} has
 @property {Cypress_Acquisitions_Is} is
 @property {Cypress_Acquisitions_Object} object
 */
/**
 @typedef {Object.<any>} Cypress_Acquisitions_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Cypress_Acquisitions_Has
 */
/**
 @typedef {Object.<any>} Cypress_Acquisitions_Is
 */
/**
 @typedef {Object.<any>} Cypress_Acquisitions_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Accounts_Billings
 @property {Accounts_Billings_Properties} properties
 @property {Accounts_Billings_Has} has
 @property {Accounts_Billings_Is} is
 @property {Accounts_Billings_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Billings_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 @property {text|string} city
 @property {text|string} coupon
 @property {text|string} month
 @property {text|string} name
 @property {text|string} number
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} verification_value
 @property {text|string} year
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Accounts_Billings_Has
 */
/**
 @typedef {Object.<any>} Accounts_Billings_Is
 */
/**
 @typedef {Object.<any>} Accounts_Billings_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} coupon
 @property {string} coupon_error
 @property {?text|string} month
 @property {string} month_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} number
 @property {string} number_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} verification_value
 @property {string} verification_value_error
 @property {?text|string} year
 @property {string} year_error
 @property {?text|string} zip
 @property {string} zip_error
 */
/**
 @typedef {Object.<any>} Accounts_Create
 @property {Accounts_Create_Properties} properties
 @property {Accounts_Create_Has} has
 @property {Accounts_Create_Is} is
 @property {Accounts_Create_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Create_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 @property {text|string} city
 @property {email} email
 @property {text|string} ffl
 @property {text|string} name_company
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_legal
 @property {string} password
 @property {string} password_repeat
 @property {text|string} phone
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {boolean} tos
 @property {number|int} type
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Accounts_Create_Has
 */
/**
 @typedef {Object.<any>} Accounts_Create_Is
 @property {Subscriptions_Object} subscriptions
 */
/**
 @typedef {Object.<any>} Accounts_Create_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} city
 @property {string} city_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} ffl
 @property {string} ffl_error
 @property {?text|string} name_company
 @property {string} name_company_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_legal
 @property {string} name_legal_error
 @property {?string} password
 @property {string} password_error
 @property {?string} password_repeat
 @property {string} password_repeat_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?boolean} tos
 @property {string} tos_error
 @property {?number|int} type
 @property {string} type_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Subscriptions_Object} subscriptions
 */
/**
 @typedef {Object.<any>} Cypress_Customers
 @property {Cypress_Customers_Properties} properties
 @property {Cypress_Customers_Has} has
 @property {Cypress_Customers_Is} is
 @property {Cypress_Customers_Object} object
 */
/**
 @typedef {Object.<any>} Cypress_Customers_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Cypress_Customers_Has
 */
/**
 @typedef {Object.<any>} Cypress_Customers_Is
 */
/**
 @typedef {Object.<any>} Cypress_Customers_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Accounts_Customizations
 @property {Accounts_Customizations_Properties} properties
 @property {Accounts_Customizations_Has} has
 @property {Accounts_Customizations_Is} is
 @property {Accounts_Customizations_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Customizations_Properties
 @property {text|string} _id
 @property {boolean} arrow_setting
 @property {text|string} binary_id
 @property {text|string} dropbox_email
 @property {text|string} dropbox_refresh_token
 @property {text|string} inventory
 @property {boolean} password_expiration
 @property {number|int} password_expiration_length
 @property {number|int} password_max_length
 @property {number|int} password_min_length
 @property {boolean} password_no_common_words
 @property {boolean} password_no_repeats
 @property {boolean} password_numeric
 @property {boolean} password_special
 @property {boolean} password_upper_and_lower
 @property {number|int} pkey
 @property {text|string} product_prefix
 @property {boolean} screen_lock
 @property {number|int} screen_lock_length
 @property {text|string} signature
 @property {text|string} ticket
 @property {string} account_signature
 */
/**
 @typedef {Object.<any>} Accounts_Customizations_Has
 */
/**
 @typedef {Object.<any>} Accounts_Customizations_Is
 */
/**
 @typedef {Object.<any>} Accounts_Customizations_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?boolean} arrow_setting
 @property {string} arrow_setting_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} dropbox_email
 @property {string} dropbox_email_error
 @property {?text|string} dropbox_refresh_token
 @property {string} dropbox_refresh_token_error
 @property {?text|string} inventory
 @property {string} inventory_error
 @property {?boolean} password_expiration
 @property {string} password_expiration_error
 @property {?number|int} password_expiration_length
 @property {string} password_expiration_length_error
 @property {?number|int} password_max_length
 @property {string} password_max_length_error
 @property {?number|int} password_min_length
 @property {string} password_min_length_error
 @property {?boolean} password_no_common_words
 @property {string} password_no_common_words_error
 @property {?boolean} password_no_repeats
 @property {string} password_no_repeats_error
 @property {?boolean} password_numeric
 @property {string} password_numeric_error
 @property {?boolean} password_special
 @property {string} password_special_error
 @property {?boolean} password_upper_and_lower
 @property {string} password_upper_and_lower_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} product_prefix
 @property {string} product_prefix_error
 @property {?boolean} screen_lock
 @property {string} screen_lock_error
 @property {?number|int} screen_lock_length
 @property {string} screen_lock_length_error
 @property {?text|string} signature
 @property {string} signature_error
 @property {?text|string} ticket
 @property {string} ticket_error
 @property {?string} account_signature
 @property {string} account_signature_error
 */
/**
 @typedef {Object.<any>} Cypress_Dealers
 @property {Cypress_Dealers_Properties} properties
 @property {Cypress_Dealers_Has} has
 @property {Cypress_Dealers_Is} is
 @property {Cypress_Dealers_Object} object
 */
/**
 @typedef {Object.<any>} Cypress_Dealers_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Cypress_Dealers_Has
 */
/**
 @typedef {Object.<any>} Cypress_Dealers_Is
 */
/**
 @typedef {Object.<any>} Cypress_Dealers_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Cypress_Events
 @property {Cypress_Events_Properties} properties
 @property {Cypress_Events_Has} has
 @property {Cypress_Events_Is} is
 @property {Cypress_Events_Object} object
 */
/**
 @typedef {Object.<any>} Cypress_Events_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Cypress_Events_Has
 */
/**
 @typedef {Object.<any>} Cypress_Events_Is
 */
/**
 @typedef {Object.<any>} Cypress_Events_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Accounts_Integrations
 @property {Accounts_Integrations_Properties} properties
 @property {Accounts_Integrations_Has} has
 @property {Accounts_Integrations_Is} is
 @property {Accounts_Integrations_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Integrations_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 @property {text|string} silencer_shop_vendor_id
 */
/**
 @typedef {Object.<any>} Accounts_Integrations_Has
 */
/**
 @typedef {Object.<any>} Accounts_Integrations_Is
 */
/**
 @typedef {Object.<any>} Accounts_Integrations_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} silencer_shop_vendor_id
 @property {string} silencer_shop_vendor_id_error
 */
/**
 @typedef {Object.<any>} Accounts_Ip_Bans
 @property {Accounts_Ip_Bans_Properties} properties
 @property {Accounts_Ip_Bans_Has} has
 @property {Accounts_Ip_Bans_Is} is
 @property {Accounts_Ip_Bans_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Ip_Bans_Properties
 @property {text|string} _id
 @property {boolean} banned
 @property {text|string} binary_id
 @property {date|string} date
 @property {text|string} ip_address
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Accounts_Ip_Bans_Has
 */
/**
 @typedef {Object.<any>} Accounts_Ip_Bans_Is
 */
/**
 @typedef {Object.<any>} Accounts_Ip_Bans_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?boolean} banned
 @property {string} banned_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} ip_address
 @property {string} ip_address_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Accounts_Ip_Whitelists
 @property {Accounts_Ip_Whitelists_Properties} properties
 @property {Accounts_Ip_Whitelists_Has} has
 @property {Accounts_Ip_Whitelists_Is} is
 @property {Accounts_Ip_Whitelists_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Ip_Whitelists_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} date
 @property {boolean} enabled
 @property {text|string} ip_address
 @property {boolean} manual
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Accounts_Ip_Whitelists_Has
 */
/**
 @typedef {Object.<any>} Accounts_Ip_Whitelists_Is
 */
/**
 @typedef {Object.<any>} Accounts_Ip_Whitelists_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?boolean} enabled
 @property {string} enabled_error
 @property {?text|string} ip_address
 @property {string} ip_address_error
 @property {?boolean} manual
 @property {string} manual_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Admins_Locations
 @property {Admins_Locations_Properties} properties
 @property {Admins_Locations_Has} has
 @property {Admins_Locations_Is} is
 @property {Admins_Locations_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Locations_Properties
 @property {text|string} _id
 @property {text|string} archive_signature
 @property {date|string} archive_signature_date
 @property {boolean} archived
 @property {text|string} binary_id
 @property {text|string} bound_book
 @property {boolean} bound_book_07
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} cleo_address
 @property {text|string} cleo_agency
 @property {boolean} cleo_auto_send
 @property {text|string} cleo_email
 @property {text|string} cleo_name
 @property {text|string} county
 @property {date|string} created
 @property {number|int} data_usage
 @property {text|string} data_usage_limit
 @property {text|string} days_open
 @property {text|string} ein
 @property {text|string} email
 @property {text|string} fax
 @property {text|string} ffl
 @property {number|int} ffl_class
 @property {string} ffl_license
 @property {number|int} ffl_type
 @property {number|int} gb_count_1
 @property {number|int} gb_count_5
 @property {boolean} has_ammoready_module
 @property {boolean} has_bound_book_07_module
 @property {boolean} has_gunbroker_module
 @property {boolean} has_manufacturing_module
 @property {boolean} has_michigan_module
 @property {boolean} has_ny_module
 @property {boolean} has_trialed
 @property {text|string} ip_address
 @property {number|int} mb_count_100
 @property {boolean} multisale_rifles_opt_out
 @property {text|string} name
 @property {text|string} name_display
 @property {boolean} on_cloud
 @property {boolean} pdf_save_server
 @property {text|string} phone
 @property {number|int} pkey
 @property {number|int} previous_day_data_usage
 @property {text|string} product_prefix
 @property {date|string} renews
 @property {number|int} sent
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} subscription
 @property {text|string} subscription_old
 @property {date|string} trialing
 @property {number|int} type
 @property {text|string} zip
 @property {number|int} additional_data
 @property {string} previewHtml
 @property {boolean} resubscribe
 @property {text|string} send_email_to
 @property {text|string} send_message
 @property {text|string} serial_trace
 @property {number|int} subscriptions_special
 */
/**
 @typedef {Object.<any>} Admins_Locations_Has
 @property {Locations_Bound_Books_Object[]} location_bound_bookss
 @property {Locations_Modules_Object[]} location_moduless
 */
/**
 @typedef {Object.<any>} Admins_Locations_Is
 @property {Ffls_Classes_Object} ffl_classes
 @property {Ffls_Types_Object} ffl_types
 @property {Subscriptions_Object} subscriptions
 @property {Subscriptions_Special_Object} subscriptions_special
 */
/**
 @typedef {Object.<any>} Admins_Locations_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} archive_signature
 @property {string} archive_signature_error
 @property {?date|string} archive_signature_date
 @property {string} archive_signature_date_error
 @property {?boolean} archived
 @property {string} archived_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} bound_book
 @property {string} bound_book_error
 @property {?boolean} bound_book_07
 @property {string} bound_book_07_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} cleo_address
 @property {string} cleo_address_error
 @property {?text|string} cleo_agency
 @property {string} cleo_agency_error
 @property {?boolean} cleo_auto_send
 @property {string} cleo_auto_send_error
 @property {?text|string} cleo_email
 @property {string} cleo_email_error
 @property {?text|string} cleo_name
 @property {string} cleo_name_error
 @property {?text|string} county
 @property {string} county_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} data_usage
 @property {string} data_usage_error
 @property {?text|string} data_usage_limit
 @property {string} data_usage_limit_error
 @property {?text|string} days_open
 @property {string} days_open_error
 @property {?text|string} ein
 @property {string} ein_error
 @property {?text|string} email
 @property {string} email_error
 @property {?text|string} fax
 @property {string} fax_error
 @property {?text|string} ffl
 @property {string} ffl_error
 @property {?number|int} ffl_class
 @property {string} ffl_class_error
 @property {?string} ffl_license
 @property {string} ffl_license_error
 @property {?number|int} ffl_type
 @property {string} ffl_type_error
 @property {?number|int} gb_count_1
 @property {string} gb_count_1_error
 @property {?number|int} gb_count_5
 @property {string} gb_count_5_error
 @property {?boolean} has_ammoready_module
 @property {string} has_ammoready_module_error
 @property {?boolean} has_bound_book_07_module
 @property {string} has_bound_book_07_module_error
 @property {?boolean} has_gunbroker_module
 @property {string} has_gunbroker_module_error
 @property {?boolean} has_manufacturing_module
 @property {string} has_manufacturing_module_error
 @property {?boolean} has_michigan_module
 @property {string} has_michigan_module_error
 @property {?boolean} has_ny_module
 @property {string} has_ny_module_error
 @property {?boolean} has_trialed
 @property {string} has_trialed_error
 @property {?text|string} ip_address
 @property {string} ip_address_error
 @property {?number|int} mb_count_100
 @property {string} mb_count_100_error
 @property {?boolean} multisale_rifles_opt_out
 @property {string} multisale_rifles_opt_out_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} name_display
 @property {string} name_display_error
 @property {?boolean} on_cloud
 @property {string} on_cloud_error
 @property {?boolean} pdf_save_server
 @property {string} pdf_save_server_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} previous_day_data_usage
 @property {string} previous_day_data_usage_error
 @property {?text|string} product_prefix
 @property {string} product_prefix_error
 @property {?date|string} renews
 @property {string} renews_error
 @property {?number|int} sent
 @property {string} sent_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} subscription
 @property {string} subscription_error
 @property {?text|string} subscription_old
 @property {string} subscription_old_error
 @property {?date|string} trialing
 @property {string} trialing_error
 @property {?number|int} type
 @property {string} type_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?number|int} additional_data
 @property {string} additional_data_error
 @property {?string} previewHtml
 @property {string} previewHtml_error
 @property {?boolean} resubscribe
 @property {string} resubscribe_error
 @property {?text|string} send_email_to
 @property {string} send_email_to_error
 @property {?text|string} send_message
 @property {string} send_message_error
 @property {?text|string} serial_trace
 @property {string} serial_trace_error
 @property {?number|int} subscriptions_special
 @property {string} subscriptions_special_error
 @property {Locations_Bound_Books_Object[]} location_bound_bookss
 @property {Locations_Modules_Object[]} location_moduless
 @property {Ffls_Classes_Object} ffl_classes
 @property {Ffls_Types_Object} ffl_types
 @property {Subscriptions_Object} subscriptions
 @property {Subscriptions_Special_Object} subscriptions_special
 */
/**
 @typedef {Object.<any>} Admins_Logins
 @property {Admins_Logins_Properties} properties
 @property {Admins_Logins_Has} has
 @property {Admins_Logins_Is} is
 @property {Admins_Logins_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Logins_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} date
 @property {text|string} email
 @property {text|string} geo
 @property {text|string} ip
 @property {text|string} location
 @property {number|int} pkey
 @property {boolean} successful
 */
/**
 @typedef {Object.<any>} Admins_Logins_Has
 */
/**
 @typedef {Object.<any>} Admins_Logins_Is
 */
/**
 @typedef {Object.<any>} Admins_Logins_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} email
 @property {string} email_error
 @property {?text|string} geo
 @property {string} geo_error
 @property {?text|string} ip
 @property {string} ip_error
 @property {?text|string} location
 @property {string} location_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} successful
 @property {string} successful_error
 */
/**
 @typedef {Object.<any>} Accounts_Logins
 @property {Accounts_Logins_Properties} properties
 @property {Accounts_Logins_Has} has
 @property {Accounts_Logins_Is} is
 @property {Accounts_Logins_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Logins_Properties
 @property {text|string} _id
 @property {number|int} account
 @property {text|string} binary_id
 @property {date|string} date
 @property {text|string} email
 @property {text|string} geo
 @property {text|string} ip
 @property {text|string} location
 @property {number|int} pkey
 @property {boolean} success
 @property {number|int} user
 @property {text|string} user_binary_id
 */
/**
 @typedef {Object.<any>} Accounts_Logins_Has
 */
/**
 @typedef {Object.<any>} Accounts_Logins_Is
 @property {Accounts_Object} accounts
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Accounts_Logins_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} email
 @property {string} email_error
 @property {?text|string} geo
 @property {string} geo_error
 @property {?text|string} ip
 @property {string} ip_error
 @property {?text|string} location
 @property {string} location_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} success
 @property {string} success_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {Accounts_Object} accounts
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Accounts_Modules
 @property {Accounts_Modules_Properties} properties
 @property {Accounts_Modules_Has} has
 @property {Accounts_Modules_Is} is
 @property {Accounts_Modules_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Modules_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} module
 @property {number|int} pkey
 @property {text|string} subscription
 */
/**
 @typedef {Object.<any>} Accounts_Modules_Has
 */
/**
 @typedef {Object.<any>} Accounts_Modules_Is
 @property {Modules_Object} modules
 */
/**
 @typedef {Object.<any>} Accounts_Modules_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} module
 @property {string} module_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} subscription
 @property {string} subscription_error
 @property {Modules_Object} modules
 */
/**
 @typedef {Object.<any>} Accounts_Notifications
 @property {Accounts_Notifications_Properties} properties
 @property {Accounts_Notifications_Has} has
 @property {Accounts_Notifications_Is} is
 @property {Accounts_Notifications_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Notifications_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} name
 @property {boolean} notify
 @property {number|int} pkey
 @property {array} items
 @property {number|int} pending_acquisitions
 */
/**
 @typedef {Object.<any>} Accounts_Notifications_Has
 */
/**
 @typedef {Object.<any>} Accounts_Notifications_Is
 */
/**
 @typedef {Object.<any>} Accounts_Notifications_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?boolean} notify
 @property {string} notify_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?array} items
 @property {string} items_error
 @property {?number|int} pending_acquisitions
 @property {string} pending_acquisitions_error
 */
/**
 @typedef {Object.<any>} Admins_Securities
 @property {Admins_Securities_Properties} properties
 @property {Admins_Securities_Has} has
 @property {Admins_Securities_Is} is
 @property {Admins_Securities_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Securities_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} date
 @property {boolean} enabled
 @property {text|string} ip_address
 @property {boolean} manual
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Admins_Securities_Has
 */
/**
 @typedef {Object.<any>} Admins_Securities_Is
 */
/**
 @typedef {Object.<any>} Admins_Securities_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?boolean} enabled
 @property {string} enabled_error
 @property {?text|string} ip_address
 @property {string} ip_address_error
 @property {?boolean} manual
 @property {string} manual_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Accounts_Subscriptions
 @property {Accounts_Subscriptions_Properties} properties
 @property {Accounts_Subscriptions_Has} has
 @property {Accounts_Subscriptions_Is} is
 @property {Accounts_Subscriptions_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Subscriptions_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} ffl
 @property {text|string} id
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} price
 @property {text|string} type
 */
/**
 @typedef {Object.<any>} Accounts_Subscriptions_Has
 */
/**
 @typedef {Object.<any>} Accounts_Subscriptions_Is
 @property {Locations_Object} locations
 */
/**
 @typedef {Object.<any>} Accounts_Subscriptions_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} ffl
 @property {string} ffl_error
 @property {?text|string} id
 @property {string} id_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} price
 @property {string} price_error
 @property {?text|string} type
 @property {string} type_error
 @property {Locations_Object} locations
 */
/**
 @typedef {Object.<any>} Accounts_Trainings
 @property {Accounts_Trainings_Properties} properties
 @property {Accounts_Trainings_Has} has
 @property {Accounts_Trainings_Is} is
 @property {Accounts_Trainings_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Trainings_Properties
 @property {text|string} _id
 @property {text|string} ammoready_apikey
 @property {text|string} ammoready_password
 @property {text|string} ammoready_username
 @property {text|string} authy
 @property {boolean} authy_enabled
 @property {text|string} binary_id
 @property {boolean} bypass_auto_upgrade
 @property {text|string} c_id
 @property {text|string} city
 @property {text|string} city_limits
 @property {date|string} created
 @property {text|string} davidsons_account_number
 @property {text|string} ein
 @property {email} email
 @property {boolean} failed_billing
 @property {text|string} gunbroker_password
 @property {text|string} gunbroker_username
 @property {boolean} has_billing
 @property {date|string} last_logged_in
 @property {date|string} last_stripe_sync
 @property {text|string} leep_password
 @property {text|string} leep_username
 @property {number|int} locked_kiosk
 @property {text|string} locked_kiosk_binary_id
 @property {number|int} locked_location
 @property {text|string} locked_location_binary_id
 @property {tel|string} mobile
 @property {text|string} name_company
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_legal
 @property {tel|string} number
 @property {string} password
 @property {boolean} password_expired
 @property {string} password_new
 @property {date|string} password_set
 @property {string} password_temp
 @property {text|string} pin
 @property {number|int} pkey
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {number|int} system_locked
 @property {text|string} title
 @property {text|string} website
 @property {text|string} zip
 @property {text|string} archive_signature
 @property {text|string} end_pkey
 @property {text|string} g_recaptcha_response
 @property {number|int} kiosk
 @property {text|string} kiosk_binary_id
 @property {number|int} kiosk_mode
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {string} password_repeat
 @property {text|string} pin
 @property {text|string} start_pkey
 @property {boolean} system_lock_down
 */
/**
 @typedef {Object.<any>} Accounts_Trainings_Has
 */
/**
 @typedef {Object.<any>} Accounts_Trainings_Is
 @property {Kiosks_Object} kiosks
 @property {Locations_Object} locations
 */
/**
 @typedef {Object.<any>} Accounts_Trainings_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} ammoready_apikey
 @property {string} ammoready_apikey_error
 @property {?text|string} ammoready_password
 @property {string} ammoready_password_error
 @property {?text|string} ammoready_username
 @property {string} ammoready_username_error
 @property {?text|string} authy
 @property {string} authy_error
 @property {?boolean} authy_enabled
 @property {string} authy_enabled_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?boolean} bypass_auto_upgrade
 @property {string} bypass_auto_upgrade_error
 @property {?text|string} c_id
 @property {string} c_id_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?date|string} created
 @property {string} created_error
 @property {?text|string} davidsons_account_number
 @property {string} davidsons_account_number_error
 @property {?text|string} ein
 @property {string} ein_error
 @property {?email} email
 @property {string} email_error
 @property {?boolean} failed_billing
 @property {string} failed_billing_error
 @property {?text|string} gunbroker_password
 @property {string} gunbroker_password_error
 @property {?text|string} gunbroker_username
 @property {string} gunbroker_username_error
 @property {?boolean} has_billing
 @property {string} has_billing_error
 @property {?date|string} last_logged_in
 @property {string} last_logged_in_error
 @property {?date|string} last_stripe_sync
 @property {string} last_stripe_sync_error
 @property {?text|string} leep_password
 @property {string} leep_password_error
 @property {?text|string} leep_username
 @property {string} leep_username_error
 @property {?number|int} locked_kiosk
 @property {string} locked_kiosk_error
 @property {?text|string} locked_kiosk_binary_id
 @property {string} locked_kiosk_binary_id_error
 @property {?number|int} locked_location
 @property {string} locked_location_error
 @property {?text|string} locked_location_binary_id
 @property {string} locked_location_binary_id_error
 @property {?tel|string} mobile
 @property {string} mobile_error
 @property {?text|string} name_company
 @property {string} name_company_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_legal
 @property {string} name_legal_error
 @property {?tel|string} number
 @property {string} number_error
 @property {?string} password
 @property {string} password_error
 @property {?boolean} password_expired
 @property {string} password_expired_error
 @property {?string} password_new
 @property {string} password_new_error
 @property {?date|string} password_set
 @property {string} password_set_error
 @property {?string} password_temp
 @property {string} password_temp_error
 @property {?text|string} pin
 @property {string} pin_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?number|int} system_locked
 @property {string} system_locked_error
 @property {?text|string} title
 @property {string} title_error
 @property {?text|string} website
 @property {string} website_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} archive_signature
 @property {string} archive_signature_error
 @property {?text|string} end_pkey
 @property {string} end_pkey_error
 @property {?text|string} g_recaptcha_response
 @property {string} g_recaptcha_response_error
 @property {?number|int} kiosk
 @property {string} kiosk_error
 @property {?text|string} kiosk_binary_id
 @property {string} kiosk_binary_id_error
 @property {?number|int} kiosk_mode
 @property {string} kiosk_mode_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?string} password_repeat
 @property {string} password_repeat_error
 @property {?text|string} pin
 @property {string} pin_error
 @property {?text|string} start_pkey
 @property {string} start_pkey_error
 @property {?boolean} system_lock_down
 @property {string} system_lock_down_error
 @property {Kiosks_Object} kiosks
 @property {Locations_Object} locations
 */
/**
 @typedef {Object.<any>} Accounts_Two_Step_Auth
 @property {Accounts_Two_Step_Auth_Properties} properties
 @property {Accounts_Two_Step_Auth_Has} has
 @property {Accounts_Two_Step_Auth_Is} is
 @property {Accounts_Two_Step_Auth_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Two_Step_Auth_Properties
 @property {text|string} _id
 @property {boolean} authy_enabled
 @property {text|string} binary_id
 @property {text|string} email
 @property {text|string} name_first
 @property {text|string} name_last
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} user_binary_id
 */
/**
 @typedef {Object.<any>} Accounts_Two_Step_Auth_Has
 */
/**
 @typedef {Object.<any>} Accounts_Two_Step_Auth_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Accounts_Two_Step_Auth_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?boolean} authy_enabled
 @property {string} authy_enabled_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} email
 @property {string} email_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Accounts_Upgraded_Logs
 @property {Accounts_Upgraded_Logs_Properties} properties
 @property {Accounts_Upgraded_Logs_Has} has
 @property {Accounts_Upgraded_Logs_Is} is
 @property {Accounts_Upgraded_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Upgraded_Logs_Properties
 @property {text|string} _id
 @property {number|int} account
 @property {text|string} binary_id
 @property {date|string} created
 @property {date|string} date
 @property {text|string} display_new
 @property {text|string} display_old
 @property {text|string} field
 @property {number|int} location
 @property {text|string} new_plan
 @property {text|string} note
 @property {text|string} old_plan
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} user_binary_id
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Accounts_Upgraded_Logs_Has
 */
/**
 @typedef {Object.<any>} Accounts_Upgraded_Logs_Is
 @property {Accounts_Object} accounts
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Accounts_Upgraded_Logs_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} display_new
 @property {string} display_new_error
 @property {?text|string} display_old
 @property {string} display_old_error
 @property {?text|string} field
 @property {string} field_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} new_plan
 @property {string} new_plan_error
 @property {?text|string} note
 @property {string} note_error
 @property {?text|string} old_plan
 @property {string} old_plan_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Accounts_Object} accounts
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Admins_Users
 @property {Admins_Users_Properties} properties
 @property {Admins_Users_Has} has
 @property {Admins_Users_Is} is
 @property {Admins_Users_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Users_Properties
 @property {text|string} _id
 @property {number|int} access
 @property {text|string} authy
 @property {boolean} authy_enabled
 @property {text|string} binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {email} email
 @property {boolean} enabled
 @property {date|string} last_logged_in
 @property {text|string} leep_password
 @property {text|string} leep_username
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {number|int} locked_kiosk
 @property {text|string} locked_kiosk_binary_id
 @property {number|int} locked_location
 @property {text|string} locked_location_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name_first
 @property {text|string} name_last
 @property {string} password
 @property {boolean} password_expired
 @property {string} password_new
 @property {date|string} password_set
 @property {string} password_temp
 @property {text|string} pin
 @property {number|int} pkey
 @property {number|int} system_locked
 @property {text|string} title
 @property {string} password_repeat
 */
/**
 @typedef {Object.<any>} Admins_Users_Has
 */
/**
 @typedef {Object.<any>} Admins_Users_Is
 @property {Kiosks_Object} kiosks
 @property {Locations_Object} locations
 @property {Users_Accesses_Object} user_accesses
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Admins_Users_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int} access
 @property {string} access_error
 @property {?text|string} authy
 @property {string} authy_error
 @property {?boolean} authy_enabled
 @property {string} authy_enabled_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?email} email
 @property {string} email_error
 @property {?boolean} enabled
 @property {string} enabled_error
 @property {?date|string} last_logged_in
 @property {string} last_logged_in_error
 @property {?text|string} leep_password
 @property {string} leep_password_error
 @property {?text|string} leep_username
 @property {string} leep_username_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?number|int} locked_kiosk
 @property {string} locked_kiosk_error
 @property {?text|string} locked_kiosk_binary_id
 @property {string} locked_kiosk_binary_id_error
 @property {?number|int} locked_location
 @property {string} locked_location_error
 @property {?text|string} locked_location_binary_id
 @property {string} locked_location_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?string} password
 @property {string} password_error
 @property {?boolean} password_expired
 @property {string} password_expired_error
 @property {?string} password_new
 @property {string} password_new_error
 @property {?date|string} password_set
 @property {string} password_set_error
 @property {?string} password_temp
 @property {string} password_temp_error
 @property {?text|string} pin
 @property {string} pin_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} system_locked
 @property {string} system_locked_error
 @property {?text|string} title
 @property {string} title_error
 @property {?string} password_repeat
 @property {string} password_repeat_error
 @property {Kiosks_Object} kiosks
 @property {Locations_Object} locations
 @property {Users_Accesses_Object} user_accesses
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Admins
 @property {Admins_Properties} properties
 @property {Admins_Has} has
 @property {Admins_Is} is
 @property {Admins_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Properties
 @property {text|string} _id
 @property {text|string} authy
 @property {boolean} authy_enabled
 @property {text|string} binary_id
 @property {email} email
 @property {text|string} last_ip
 @property {date|string} last_logged_in
 @property {text|string} name_first
 @property {text|string} name_last
 @property {string} password
 @property {string} password_new
 @property {number|int} pkey
 @property {text|string} g_recaptcha_response
 */
/**
 @typedef {Object.<any>} Admins_Has
 */
/**
 @typedef {Object.<any>} Admins_Is
 */
/**
 @typedef {Object.<any>} Admins_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} authy
 @property {string} authy_error
 @property {?boolean} authy_enabled
 @property {string} authy_enabled_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} last_ip
 @property {string} last_ip_error
 @property {?date|string} last_logged_in
 @property {string} last_logged_in_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?string} password
 @property {string} password_error
 @property {?string} password_new
 @property {string} password_new_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} g_recaptcha_response
 @property {string} g_recaptcha_response_error
 */
/**
 @typedef {Object.<any>} Admins_Charges
 @property {Admins_Charges_Properties} properties
 @property {Admins_Charges_Has} has
 @property {Admins_Charges_Is} is
 @property {Admins_Charges_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Charges_Properties
 @property {text|string} _id
 @property {number|int|float} amount
 @property {text|string} binary_id
 @property {date|string} created
 @property {date|string} date
 @property {text|string} location_binary_id
 @property {text|string} outcome_message
 @property {text|string} outcome_reason
 @property {text|string} outcome_status
 @property {text|string} outcome_type
 @property {number|int} pkey
 @property {boolean} refunded
 @property {text|string} statement_descriptor
 @property {text|string} status
 @property {text|string} stripe_customer
 @property {text|string} stripe_event
 @property {text|string} stripe_invoice
 @property {text|string} stripe_subscription
 @property {text|string} type
 */
/**
 @typedef {Object.<any>} Admins_Charges_Has
 */
/**
 @typedef {Object.<any>} Admins_Charges_Is
 */
/**
 @typedef {Object.<any>} Admins_Charges_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} outcome_message
 @property {string} outcome_message_error
 @property {?text|string} outcome_reason
 @property {string} outcome_reason_error
 @property {?text|string} outcome_status
 @property {string} outcome_status_error
 @property {?text|string} outcome_type
 @property {string} outcome_type_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} refunded
 @property {string} refunded_error
 @property {?text|string} statement_descriptor
 @property {string} statement_descriptor_error
 @property {?text|string} status
 @property {string} status_error
 @property {?text|string} stripe_customer
 @property {string} stripe_customer_error
 @property {?text|string} stripe_event
 @property {string} stripe_event_error
 @property {?text|string} stripe_invoice
 @property {string} stripe_invoice_error
 @property {?text|string} stripe_subscription
 @property {string} stripe_subscription_error
 @property {?text|string} type
 @property {string} type_error
 */
/**
 @typedef {Object.<any>} Admins_Modules
 @property {Admins_Modules_Properties} properties
 @property {Admins_Modules_Has} has
 @property {Admins_Modules_Is} is
 @property {Admins_Modules_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Modules_Properties
 @property {text|string} _id
 @property {boolean} active
 @property {text|string} additional
 @property {text|string} binary_id
 @property {text|string} description
 @property {text|string} name
 @property {text|string} note
 @property {number|int} pkey
 @property {text|string} plan
 @property {text|string} price
 @property {number|int} type
 */
/**
 @typedef {Object.<any>} Admins_Modules_Has
 */
/**
 @typedef {Object.<any>} Admins_Modules_Is
 */
/**
 @typedef {Object.<any>} Admins_Modules_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?boolean} active
 @property {string} active_error
 @property {?text|string} additional
 @property {string} additional_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} description
 @property {string} description_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} plan
 @property {string} plan_error
 @property {?text|string} price
 @property {string} price_error
 @property {?number|int} type
 @property {string} type_error
 */
/**
 @typedef {Object.<any>} Admins_Stripe
 @property {Admins_Stripe_Properties} properties
 @property {Admins_Stripe_Has} has
 @property {Admins_Stripe_Is} is
 @property {Admins_Stripe_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Stripe_Properties
 */
/**
 @typedef {Object.<any>} Admins_Stripe_Has
 */
/**
 @typedef {Object.<any>} Admins_Stripe_Is
 */
/**
 @typedef {Object.<any>} Admins_Stripe_Object
 */
/**
 @typedef {Object.<any>} Admins_Subscriptions
 @property {Admins_Subscriptions_Properties} properties
 @property {Admins_Subscriptions_Has} has
 @property {Admins_Subscriptions_Is} is
 @property {Admins_Subscriptions_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Subscriptions_Properties
 @property {text|string} _id
 @property {text|string} authy
 @property {boolean} authy_enabled
 @property {text|string} binary_id
 @property {email} email
 @property {text|string} last_ip
 @property {date|string} last_logged_in
 @property {text|string} name_first
 @property {text|string} name_last
 @property {string} password
 @property {string} password_new
 @property {number|int} pkey
 @property {text|string} g_recaptcha_response
 */
/**
 @typedef {Object.<any>} Admins_Subscriptions_Has
 */
/**
 @typedef {Object.<any>} Admins_Subscriptions_Is
 */
/**
 @typedef {Object.<any>} Admins_Subscriptions_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} authy
 @property {string} authy_error
 @property {?boolean} authy_enabled
 @property {string} authy_enabled_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} last_ip
 @property {string} last_ip_error
 @property {?date|string} last_logged_in
 @property {string} last_logged_in_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?string} password
 @property {string} password_error
 @property {?string} password_new
 @property {string} password_new_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} g_recaptcha_response
 @property {string} g_recaptcha_response_error
 */
/**
 @typedef {Object.<any>} Ammoready_Orders
 @property {Ammoready_Orders_Properties} properties
 @property {Ammoready_Orders_Has} has
 @property {Ammoready_Orders_Is} is
 @property {Ammoready_Orders_Object} object
 */
/**
 @typedef {Object.<any>} Ammoready_Orders_Properties
 @property {text|string} _id
 @property {date|string} acquire_date
 @property {text|string} binary_id
 @property {date|string} created
 @property {string} customer
 @property {date|string} disposed_date
 @property {string} ffl
 @property {text|string} ffl_status
 @property {text|string} fulfillment_status
 @property {date|string} order_date
 @property {text|string} order_id
 @property {string} order_items
 @property {boolean} order_sold
 @property {number|int} pkey
 @property {string} shipping_address
 @property {text|string} status
 @property {number|int|float} total_price
 @property {number|int|float} total_tax
 @property {date|string} transfer_date
 */
/**
 @typedef {Object.<any>} Ammoready_Orders_Has
 */
/**
 @typedef {Object.<any>} Ammoready_Orders_Is
 */
/**
 @typedef {Object.<any>} Ammoready_Orders_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?date|string} acquire_date
 @property {string} acquire_date_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?string} customer
 @property {string} customer_error
 @property {?date|string} disposed_date
 @property {string} disposed_date_error
 @property {?string} ffl
 @property {string} ffl_error
 @property {?text|string} ffl_status
 @property {string} ffl_status_error
 @property {?text|string} fulfillment_status
 @property {string} fulfillment_status_error
 @property {?date|string} order_date
 @property {string} order_date_error
 @property {?text|string} order_id
 @property {string} order_id_error
 @property {?string} order_items
 @property {string} order_items_error
 @property {?boolean} order_sold
 @property {string} order_sold_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?string} shipping_address
 @property {string} shipping_address_error
 @property {?text|string} status
 @property {string} status_error
 @property {?number|int|float} total_price
 @property {string} total_price_error
 @property {?number|int|float} total_tax
 @property {string} total_tax_error
 @property {?date|string} transfer_date
 @property {string} transfer_date_error
 */
/**
 @typedef {Object.<any>} Bound_Books
 @property {Bound_Books_Properties} properties
 @property {Bound_Books_Has} has
 @property {Bound_Books_Is} is
 @property {Bound_Books_Object} object
 */
/**
 @typedef {Object.<any>} Bound_Books_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {text|string} caliber
 @property {text|string} country_of_origin
 @property {date|string} date
 @property {date|string} date_in
 @property {date|string} date_out
 @property {text|string} event
 @property {text|string} importer
 @property {text|string} importer_name
 @property {text|string} in_from
 @property {text|string} in_from_address
 @property {text|string} in_from_ffl
 @property {number|int} in_from_id
 @property {text|string} in_from_location
 @property {text|string} in_from_type
 @property {text|string} incident_number
 @property {text|string} inventory
 @property {text|string} item_description
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} manufacturer
 @property {text|string} model
 @property {text|string} nics
 @property {text|string} out_to
 @property {text|string} out_to_address
 @property {text|string} out_to_county
 @property {text|string} out_to_ffl
 @property {number|int} out_to_id
 @property {text|string} out_to_location
 @property {text|string} out_to_type
 @property {number|int} pkey
 @property {number|int} product
 @property {text|string} product_binary_id
 @property {text|string} product_id
 @property {text|string} serial_number
 @property {text|string} state
 @property {text|string} status
 @property {number|int} transaction_in
 @property {text|string} transaction_in_binary_id
 @property {text|string} transaction_in_id
 @property {number|int} transaction_in_type
 @property {number|int} transaction_out
 @property {text|string} transaction_out_binary_id
 @property {text|string} transaction_out_id
 @property {number|int} transaction_out_type
 @property {text|string} type
 */
/**
 @typedef {Object.<any>} Bound_Books_Has
 */
/**
 @typedef {Object.<any>} Bound_Books_Is
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections_related_by_transaction_in
 @property {Transactions_Collections_Object} transaction_collections_related_by_transaction_out
 @property {Transactions_Types_Object} transaction_types
 */
/**
 @typedef {Object.<any>} Bound_Books_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?text|string} caliber
 @property {string} caliber_error
 @property {?text|string} country_of_origin
 @property {string} country_of_origin_error
 @property {?date|string} date
 @property {string} date_error
 @property {?date|string} date_in
 @property {string} date_in_error
 @property {?date|string} date_out
 @property {string} date_out_error
 @property {?text|string} event
 @property {string} event_error
 @property {?text|string} importer
 @property {string} importer_error
 @property {?text|string} importer_name
 @property {string} importer_name_error
 @property {?text|string} in_from
 @property {string} in_from_error
 @property {?text|string} in_from_address
 @property {string} in_from_address_error
 @property {?text|string} in_from_ffl
 @property {string} in_from_ffl_error
 @property {?number|int} in_from_id
 @property {string} in_from_id_error
 @property {?text|string} in_from_location
 @property {string} in_from_location_error
 @property {?text|string} in_from_type
 @property {string} in_from_type_error
 @property {?text|string} incident_number
 @property {string} incident_number_error
 @property {?text|string} inventory
 @property {string} inventory_error
 @property {?text|string} item_description
 @property {string} item_description_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} model
 @property {string} model_error
 @property {?text|string} nics
 @property {string} nics_error
 @property {?text|string} out_to
 @property {string} out_to_error
 @property {?text|string} out_to_address
 @property {string} out_to_address_error
 @property {?text|string} out_to_county
 @property {string} out_to_county_error
 @property {?text|string} out_to_ffl
 @property {string} out_to_ffl_error
 @property {?number|int} out_to_id
 @property {string} out_to_id_error
 @property {?text|string} out_to_location
 @property {string} out_to_location_error
 @property {?text|string} out_to_type
 @property {string} out_to_type_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} product_binary_id
 @property {string} product_binary_id_error
 @property {?text|string} product_id
 @property {string} product_id_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} status
 @property {string} status_error
 @property {?number|int} transaction_in
 @property {string} transaction_in_error
 @property {?text|string} transaction_in_binary_id
 @property {string} transaction_in_binary_id_error
 @property {?text|string} transaction_in_id
 @property {string} transaction_in_id_error
 @property {?number|int} transaction_in_type
 @property {string} transaction_in_type_error
 @property {?number|int} transaction_out
 @property {string} transaction_out_error
 @property {?text|string} transaction_out_binary_id
 @property {string} transaction_out_binary_id_error
 @property {?text|string} transaction_out_id
 @property {string} transaction_out_id_error
 @property {?number|int} transaction_out_type
 @property {string} transaction_out_type_error
 @property {?text|string} type
 @property {string} type_error
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections_related_by_transaction_in
 @property {Transactions_Collections_Object} transaction_collections_related_by_transaction_out
 @property {Transactions_Types_Object} transaction_types
 */
/**
 @typedef {Object.<any>} Bound_Books_Products
 @property {Bound_Books_Products_Properties} properties
 @property {Bound_Books_Products_Has} has
 @property {Bound_Books_Products_Is} is
 @property {Bound_Books_Products_Object} object
 */
/**
 @typedef {Object.<any>} Bound_Books_Products_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {text|string} caliber
 @property {text|string} country_of_origin
 @property {date|string} date
 @property {date|string} date_in
 @property {date|string} date_out
 @property {text|string} event
 @property {text|string} importer
 @property {text|string} importer_name
 @property {text|string} in_from
 @property {text|string} in_from_address
 @property {text|string} in_from_ffl
 @property {number|int} in_from_id
 @property {text|string} in_from_location
 @property {text|string} in_from_type
 @property {text|string} incident_number
 @property {text|string} inventory
 @property {text|string} item_description
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} manufacturer
 @property {text|string} model
 @property {text|string} nics
 @property {text|string} out_to
 @property {text|string} out_to_address
 @property {text|string} out_to_county
 @property {text|string} out_to_ffl
 @property {number|int} out_to_id
 @property {text|string} out_to_location
 @property {text|string} out_to_type
 @property {number|int} pkey
 @property {number|int} product
 @property {text|string} product_binary_id
 @property {text|string} product_id
 @property {text|string} serial_number
 @property {text|string} state
 @property {text|string} status
 @property {number|int} transaction_in
 @property {text|string} transaction_in_binary_id
 @property {text|string} transaction_in_id
 @property {number|int} transaction_in_type
 @property {number|int} transaction_out
 @property {text|string} transaction_out_binary_id
 @property {text|string} transaction_out_id
 @property {number|int} transaction_out_type
 @property {text|string} type
 */
/**
 @typedef {Object.<any>} Bound_Books_Products_Has
 */
/**
 @typedef {Object.<any>} Bound_Books_Products_Is
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections_related_by_transaction_in
 @property {Transactions_Collections_Object} transaction_collections_related_by_transaction_out
 @property {Transactions_Types_Object} transaction_types
 */
/**
 @typedef {Object.<any>} Bound_Books_Products_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?text|string} caliber
 @property {string} caliber_error
 @property {?text|string} country_of_origin
 @property {string} country_of_origin_error
 @property {?date|string} date
 @property {string} date_error
 @property {?date|string} date_in
 @property {string} date_in_error
 @property {?date|string} date_out
 @property {string} date_out_error
 @property {?text|string} event
 @property {string} event_error
 @property {?text|string} importer
 @property {string} importer_error
 @property {?text|string} importer_name
 @property {string} importer_name_error
 @property {?text|string} in_from
 @property {string} in_from_error
 @property {?text|string} in_from_address
 @property {string} in_from_address_error
 @property {?text|string} in_from_ffl
 @property {string} in_from_ffl_error
 @property {?number|int} in_from_id
 @property {string} in_from_id_error
 @property {?text|string} in_from_location
 @property {string} in_from_location_error
 @property {?text|string} in_from_type
 @property {string} in_from_type_error
 @property {?text|string} incident_number
 @property {string} incident_number_error
 @property {?text|string} inventory
 @property {string} inventory_error
 @property {?text|string} item_description
 @property {string} item_description_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} model
 @property {string} model_error
 @property {?text|string} nics
 @property {string} nics_error
 @property {?text|string} out_to
 @property {string} out_to_error
 @property {?text|string} out_to_address
 @property {string} out_to_address_error
 @property {?text|string} out_to_county
 @property {string} out_to_county_error
 @property {?text|string} out_to_ffl
 @property {string} out_to_ffl_error
 @property {?number|int} out_to_id
 @property {string} out_to_id_error
 @property {?text|string} out_to_location
 @property {string} out_to_location_error
 @property {?text|string} out_to_type
 @property {string} out_to_type_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} product_binary_id
 @property {string} product_binary_id_error
 @property {?text|string} product_id
 @property {string} product_id_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} status
 @property {string} status_error
 @property {?number|int} transaction_in
 @property {string} transaction_in_error
 @property {?text|string} transaction_in_binary_id
 @property {string} transaction_in_binary_id_error
 @property {?text|string} transaction_in_id
 @property {string} transaction_in_id_error
 @property {?number|int} transaction_in_type
 @property {string} transaction_in_type_error
 @property {?number|int} transaction_out
 @property {string} transaction_out_error
 @property {?text|string} transaction_out_binary_id
 @property {string} transaction_out_binary_id_error
 @property {?text|string} transaction_out_id
 @property {string} transaction_out_id_error
 @property {?number|int} transaction_out_type
 @property {string} transaction_out_type_error
 @property {?text|string} type
 @property {string} type_error
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections_related_by_transaction_in
 @property {Transactions_Collections_Object} transaction_collections_related_by_transaction_out
 @property {Transactions_Types_Object} transaction_types
 */
/**
 @typedef {Object.<any>} Changes
 @property {Changes_Properties} properties
 @property {Changes_Has} has
 @property {Changes_Is} is
 @property {Changes_Object} object
 */
/**
 @typedef {Object.<any>} Changes_Properties
 @property {text|string} _id
 @property {number|int} account
 @property {text|string} binary_id
 @property {text|string} class
 @property {date|string} date
 @property {text|string} entity
 @property {text|string} field
 @property {number|int} fkey
 @property {text|string} note
 @property {text|string} o_table
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} user_name
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Changes_Has
 */
/**
 @typedef {Object.<any>} Changes_Is
 @property {Accounts_Object} accounts
 */
/**
 @typedef {Object.<any>} Changes_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} class
 @property {string} class_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} entity
 @property {string} entity_error
 @property {?text|string} field
 @property {string} field_error
 @property {?number|int} fkey
 @property {string} fkey_error
 @property {?text|string} note
 @property {string} note_error
 @property {?text|string} o_table
 @property {string} o_table_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_name
 @property {string} user_name_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Accounts_Object} accounts
 */
/**
 @typedef {Object.<any>} Changes_Emails
 @property {Changes_Emails_Properties} properties
 @property {Changes_Emails_Has} has
 @property {Changes_Emails_Is} is
 @property {Changes_Emails_Object} object
 */
/**
 @typedef {Object.<any>} Changes_Emails_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {date|string} date
 @property {number|int} dealer
 @property {text|string} dealer_binary_id
 @property {boolean} edited_email
 @property {email} email
 @property {text|string} message
 @property {number|int} pkey
 @property {number|int} template
 @property {number|int} user
 @property {text|string} user_binary_id
 */
/**
 @typedef {Object.<any>} Changes_Emails_Has
 */
/**
 @typedef {Object.<any>} Changes_Emails_Is
 @property {Customers_Object} customers
 @property {Dealers_Object} dealers
 @property {Email_Templates_Object} email_templates
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Changes_Emails_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?number|int} dealer
 @property {string} dealer_error
 @property {?text|string} dealer_binary_id
 @property {string} dealer_binary_id_error
 @property {?boolean} edited_email
 @property {string} edited_email_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} message
 @property {string} message_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} template
 @property {string} template_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {Customers_Object} customers
 @property {Dealers_Object} dealers
 @property {Email_Templates_Object} email_templates
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Custom_Modules
 @property {Custom_Modules_Properties} properties
 @property {Custom_Modules_Has} has
 @property {Custom_Modules_Is} is
 @property {Custom_Modules_Object} object
 */
/**
 @typedef {Object.<any>} Custom_Modules_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Custom_Modules_Has
 */
/**
 @typedef {Object.<any>} Custom_Modules_Is
 */
/**
 @typedef {Object.<any>} Custom_Modules_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Custom_Modules_Customs_880
 @property {Custom_Modules_Customs_880_Properties} properties
 @property {Custom_Modules_Customs_880_Has} has
 @property {Custom_Modules_Customs_880_Is} is
 @property {Custom_Modules_Customs_880_Object} object
 */
/**
 @typedef {Object.<any>} Custom_Modules_Customs_880_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Custom_Modules_Customs_880_Has
 */
/**
 @typedef {Object.<any>} Custom_Modules_Customs_880_Is
 */
/**
 @typedef {Object.<any>} Custom_Modules_Customs_880_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Customers
 @property {Customers_Properties} properties
 @property {Customers_Has} has
 @property {Customers_Is} is
 @property {Customers_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Properties
 @property {text|string} _id
 @property {text|string} alien_number
 @property {text|string} binary_id
 @property {text|string} birth_city
 @property {text|string} birth_country
 @property {text|string} birth_county
 @property {date|string} birth_date
 @property {text|string} birth_state
 @property {boolean} blacklist
 @property {date|string} blacklist_date
 @property {text|string} blacklist_reason
 @property {boolean} company
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {boolean} ethnicity_hispanic
 @property {text|string} eye_color
 @property {text|string} foreign_citizenship
 @property {text|string} gender
 @property {text|string} hair_color
 @property {number|int} height_ft
 @property {number|int} height_in
 @property {boolean} ignore_duplicate
 @property {boolean} imported
 @property {number|int} legal_entity
 @property {text|string} legal_entity_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name_company
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_middle
 @property {text|string} name_suffix
 @property {boolean} nics_denied
 @property {date|string} nics_denied_date
 @property {text|string} notes
 @property {number|int} pkey
 @property {boolean} race_african_american
 @property {boolean} race_american_indian
 @property {boolean} race_asian
 @property {boolean} race_native_hawaiian
 @property {boolean} race_white
 @property {text|string} silencer_shop_lookup_id
 @property {text|string} ssn
 @property {text|string} state_of_residence
 @property {text|string} upin
 @property {boolean} us_citizen
 @property {number|int} weight
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} county
 @property {text|string} email
 @property {text|string} phone
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {boolean} us_born
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Customers_Has
 @property {Customers_Addresses_Object[]} customer_addressess
 @property {Customers_Emails_Object[]} customer_emailss
 @property {Customers_Identifications_Object[]} customer_identificationss
 @property {Customers_Military_Object[]} customer_militaries
 @property {Customers_Numbers_Object[]} customer_numberss
 @property {Customers_Permits_Object[]} customer_permitss
 */
/**
 @typedef {Object.<any>} Customers_Is
 @property {Legal_Entities_Object} legal_entities
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} alien_number
 @property {string} alien_number_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} birth_city
 @property {string} birth_city_error
 @property {?text|string} birth_country
 @property {string} birth_country_error
 @property {?text|string} birth_county
 @property {string} birth_county_error
 @property {?date|string} birth_date
 @property {string} birth_date_error
 @property {?text|string} birth_state
 @property {string} birth_state_error
 @property {?boolean} blacklist
 @property {string} blacklist_error
 @property {?date|string} blacklist_date
 @property {string} blacklist_date_error
 @property {?text|string} blacklist_reason
 @property {string} blacklist_reason_error
 @property {?boolean} company
 @property {string} company_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?boolean} ethnicity_hispanic
 @property {string} ethnicity_hispanic_error
 @property {?text|string} eye_color
 @property {string} eye_color_error
 @property {?text|string} foreign_citizenship
 @property {string} foreign_citizenship_error
 @property {?text|string} gender
 @property {string} gender_error
 @property {?text|string} hair_color
 @property {string} hair_color_error
 @property {?number|int} height_ft
 @property {string} height_ft_error
 @property {?number|int} height_in
 @property {string} height_in_error
 @property {?boolean} ignore_duplicate
 @property {string} ignore_duplicate_error
 @property {?boolean} imported
 @property {string} imported_error
 @property {?number|int} legal_entity
 @property {string} legal_entity_error
 @property {?text|string} legal_entity_binary_id
 @property {string} legal_entity_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name_company
 @property {string} name_company_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_middle
 @property {string} name_middle_error
 @property {?text|string} name_suffix
 @property {string} name_suffix_error
 @property {?boolean} nics_denied
 @property {string} nics_denied_error
 @property {?date|string} nics_denied_date
 @property {string} nics_denied_date_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} race_african_american
 @property {string} race_african_american_error
 @property {?boolean} race_american_indian
 @property {string} race_american_indian_error
 @property {?boolean} race_asian
 @property {string} race_asian_error
 @property {?boolean} race_native_hawaiian
 @property {string} race_native_hawaiian_error
 @property {?boolean} race_white
 @property {string} race_white_error
 @property {?text|string} silencer_shop_lookup_id
 @property {string} silencer_shop_lookup_id_error
 @property {?text|string} ssn
 @property {string} ssn_error
 @property {?text|string} state_of_residence
 @property {string} state_of_residence_error
 @property {?text|string} upin
 @property {string} upin_error
 @property {?boolean} us_citizen
 @property {string} us_citizen_error
 @property {?number|int} weight
 @property {string} weight_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} county
 @property {string} county_error
 @property {?text|string} email
 @property {string} email_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?boolean} us_born
 @property {string} us_born_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Customers_Addresses_Object[]} customer_addressess
 @property {Customers_Emails_Object[]} customer_emailss
 @property {Customers_Identifications_Object[]} customer_identificationss
 @property {Customers_Military_Object[]} customer_militaries
 @property {Customers_Numbers_Object[]} customer_numberss
 @property {Customers_Permits_Object[]} customer_permitss
 @property {Legal_Entities_Object} legal_entities
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Addresses
 @property {Customers_Addresses_Properties} properties
 @property {Customers_Addresses_Has} has
 @property {Customers_Addresses_Is} is
 @property {Customers_Addresses_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Addresses_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} county
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {boolean} international
 @property {number|int} pkey
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Customers_Addresses_Has
 */
/**
 @typedef {Object.<any>} Customers_Addresses_Is
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Addresses_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} county
 @property {string} county_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?boolean} international
 @property {string} international_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Duplicates
 @property {Customers_Duplicates_Properties} properties
 @property {Customers_Duplicates_Has} has
 @property {Customers_Duplicates_Is} is
 @property {Customers_Duplicates_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Duplicates_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_middle
 @property {text|string} name_suffix
 @property {number|int} pkey
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} county
 @property {text|string} email
 @property {number|int} original
 @property {text|string} original_binary_id
 @property {text|string} original_city
 @property {text|string} original_county
 @property {text|string} original_email
 @property {text|string} original_name_first
 @property {text|string} original_name_last
 @property {text|string} original_name_middle
 @property {text|string} original_name_suffix
 @property {tel|string} original_phone
 @property {text|string} original_state
 @property {text|string} original_street_1
 @property {text|string} original_street_2
 @property {text|string} original_zip
 @property {tel|string} phone
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Customers_Duplicates_Has
 @property {Customers_Addresses_Object[]} customer_addressess
 @property {Customers_Emails_Object[]} customer_emailss
 @property {Customers_Numbers_Object[]} customer_numberss
 */
/**
 @typedef {Object.<any>} Customers_Duplicates_Is
 @property {Customers_Object} customers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Duplicates_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_middle
 @property {string} name_middle_error
 @property {?text|string} name_suffix
 @property {string} name_suffix_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} county
 @property {string} county_error
 @property {?text|string} email
 @property {string} email_error
 @property {?number|int} original
 @property {string} original_error
 @property {?text|string} original_binary_id
 @property {string} original_binary_id_error
 @property {?text|string} original_city
 @property {string} original_city_error
 @property {?text|string} original_county
 @property {string} original_county_error
 @property {?text|string} original_email
 @property {string} original_email_error
 @property {?text|string} original_name_first
 @property {string} original_name_first_error
 @property {?text|string} original_name_last
 @property {string} original_name_last_error
 @property {?text|string} original_name_middle
 @property {string} original_name_middle_error
 @property {?text|string} original_name_suffix
 @property {string} original_name_suffix_error
 @property {?tel|string} original_phone
 @property {string} original_phone_error
 @property {?text|string} original_state
 @property {string} original_state_error
 @property {?text|string} original_street_1
 @property {string} original_street_1_error
 @property {?text|string} original_street_2
 @property {string} original_street_2_error
 @property {?text|string} original_zip
 @property {string} original_zip_error
 @property {?tel|string} phone
 @property {string} phone_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Customers_Addresses_Object[]} customer_addressess
 @property {Customers_Emails_Object[]} customer_emailss
 @property {Customers_Numbers_Object[]} customer_numberss
 @property {Customers_Object} customers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Emails
 @property {Customers_Emails_Properties} properties
 @property {Customers_Emails_Has} has
 @property {Customers_Emails_Is} is
 @property {Customers_Emails_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Emails_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {text|string} email
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Customers_Emails_Has
 */
/**
 @typedef {Object.<any>} Customers_Emails_Is
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Emails_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?text|string} email
 @property {string} email_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Histories
 @property {Customers_Histories_Properties} properties
 @property {Customers_Histories_Has} has
 @property {Customers_Histories_Is} is
 @property {Customers_Histories_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Histories_Properties
 @property {text|string} _id
 @property {text|string} alien_number
 @property {text|string} binary_id
 @property {text|string} birth_city
 @property {text|string} birth_country
 @property {text|string} birth_county
 @property {date|string} birth_date
 @property {text|string} birth_state
 @property {boolean} blacklist
 @property {date|string} blacklist_date
 @property {text|string} blacklist_reason
 @property {boolean} company
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {boolean} ethnicity_hispanic
 @property {text|string} eye_color
 @property {text|string} foreign_citizenship
 @property {text|string} gender
 @property {text|string} hair_color
 @property {number|int} height_ft
 @property {number|int} height_in
 @property {boolean} ignore_duplicate
 @property {boolean} imported
 @property {number|int} legal_entity
 @property {text|string} legal_entity_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name_company
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_middle
 @property {text|string} name_suffix
 @property {boolean} nics_denied
 @property {date|string} nics_denied_date
 @property {text|string} notes
 @property {number|int} pkey
 @property {boolean} race_african_american
 @property {boolean} race_american_indian
 @property {boolean} race_asian
 @property {boolean} race_native_hawaiian
 @property {boolean} race_white
 @property {text|string} silencer_shop_lookup_id
 @property {text|string} ssn
 @property {text|string} state_of_residence
 @property {text|string} upin
 @property {boolean} us_citizen
 @property {number|int} weight
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} county
 @property {text|string} email
 @property {text|string} phone
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {boolean} us_born
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Customers_Histories_Has
 @property {Customers_Addresses_Object[]} customer_addressess
 @property {Customers_Emails_Object[]} customer_emailss
 @property {Customers_Identifications_Object[]} customer_identificationss
 @property {Customers_Military_Object[]} customer_militaries
 @property {Customers_Numbers_Object[]} customer_numberss
 @property {Customers_Permits_Object[]} customer_permitss
 */
/**
 @typedef {Object.<any>} Customers_Histories_Is
 @property {Legal_Entities_Object} legal_entities
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Histories_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} alien_number
 @property {string} alien_number_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} birth_city
 @property {string} birth_city_error
 @property {?text|string} birth_country
 @property {string} birth_country_error
 @property {?text|string} birth_county
 @property {string} birth_county_error
 @property {?date|string} birth_date
 @property {string} birth_date_error
 @property {?text|string} birth_state
 @property {string} birth_state_error
 @property {?boolean} blacklist
 @property {string} blacklist_error
 @property {?date|string} blacklist_date
 @property {string} blacklist_date_error
 @property {?text|string} blacklist_reason
 @property {string} blacklist_reason_error
 @property {?boolean} company
 @property {string} company_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?boolean} ethnicity_hispanic
 @property {string} ethnicity_hispanic_error
 @property {?text|string} eye_color
 @property {string} eye_color_error
 @property {?text|string} foreign_citizenship
 @property {string} foreign_citizenship_error
 @property {?text|string} gender
 @property {string} gender_error
 @property {?text|string} hair_color
 @property {string} hair_color_error
 @property {?number|int} height_ft
 @property {string} height_ft_error
 @property {?number|int} height_in
 @property {string} height_in_error
 @property {?boolean} ignore_duplicate
 @property {string} ignore_duplicate_error
 @property {?boolean} imported
 @property {string} imported_error
 @property {?number|int} legal_entity
 @property {string} legal_entity_error
 @property {?text|string} legal_entity_binary_id
 @property {string} legal_entity_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name_company
 @property {string} name_company_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_middle
 @property {string} name_middle_error
 @property {?text|string} name_suffix
 @property {string} name_suffix_error
 @property {?boolean} nics_denied
 @property {string} nics_denied_error
 @property {?date|string} nics_denied_date
 @property {string} nics_denied_date_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} race_african_american
 @property {string} race_african_american_error
 @property {?boolean} race_american_indian
 @property {string} race_american_indian_error
 @property {?boolean} race_asian
 @property {string} race_asian_error
 @property {?boolean} race_native_hawaiian
 @property {string} race_native_hawaiian_error
 @property {?boolean} race_white
 @property {string} race_white_error
 @property {?text|string} silencer_shop_lookup_id
 @property {string} silencer_shop_lookup_id_error
 @property {?text|string} ssn
 @property {string} ssn_error
 @property {?text|string} state_of_residence
 @property {string} state_of_residence_error
 @property {?text|string} upin
 @property {string} upin_error
 @property {?boolean} us_citizen
 @property {string} us_citizen_error
 @property {?number|int} weight
 @property {string} weight_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} county
 @property {string} county_error
 @property {?text|string} email
 @property {string} email_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?boolean} us_born
 @property {string} us_born_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Customers_Addresses_Object[]} customer_addressess
 @property {Customers_Emails_Object[]} customer_emailss
 @property {Customers_Identifications_Object[]} customer_identificationss
 @property {Customers_Military_Object[]} customer_militaries
 @property {Customers_Numbers_Object[]} customer_numberss
 @property {Customers_Permits_Object[]} customer_permitss
 @property {Legal_Entities_Object} legal_entities
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Identifications
 @property {Customers_Identifications_Properties} properties
 @property {Customers_Identifications_Has} has
 @property {Customers_Identifications_Is} is
 @property {Customers_Identifications_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Identifications_Properties
 @property {text|string} _id
 @property {text|string} alternate_documentation
 @property {text|string} binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {text|string} identification_authority
 @property {date|string} identification_expiration
 @property {date|string} identification_issue
 @property {text|string} identification_number
 @property {text|string} identification_type
 @property {string} image
 @property {string} image_back
 @property {text|string} non_immigrant_visa_prohibition
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Customers_Identifications_Has
 */
/**
 @typedef {Object.<any>} Customers_Identifications_Is
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Identifications_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} alternate_documentation
 @property {string} alternate_documentation_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?text|string} identification_authority
 @property {string} identification_authority_error
 @property {?date|string} identification_expiration
 @property {string} identification_expiration_error
 @property {?date|string} identification_issue
 @property {string} identification_issue_error
 @property {?text|string} identification_number
 @property {string} identification_number_error
 @property {?text|string} identification_type
 @property {string} identification_type_error
 @property {?string} image
 @property {string} image_error
 @property {?string} image_back
 @property {string} image_back_error
 @property {?text|string} non_immigrant_visa_prohibition
 @property {string} non_immigrant_visa_prohibition_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Identifications_Images
 @property {Customers_Identifications_Images_Properties} properties
 @property {Customers_Identifications_Images_Has} has
 @property {Customers_Identifications_Images_Is} is
 @property {Customers_Identifications_Images_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Identifications_Images_Properties
 @property {text|string} _id
 @property {text|string} alternate_documentation
 @property {text|string} binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {text|string} identification_authority
 @property {date|string} identification_expiration
 @property {date|string} identification_issue
 @property {text|string} identification_number
 @property {text|string} identification_type
 @property {string} image
 @property {string} image_back
 @property {text|string} non_immigrant_visa_prohibition
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Customers_Identifications_Images_Has
 */
/**
 @typedef {Object.<any>} Customers_Identifications_Images_Is
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Identifications_Images_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} alternate_documentation
 @property {string} alternate_documentation_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?text|string} identification_authority
 @property {string} identification_authority_error
 @property {?date|string} identification_expiration
 @property {string} identification_expiration_error
 @property {?date|string} identification_issue
 @property {string} identification_issue_error
 @property {?text|string} identification_number
 @property {string} identification_number_error
 @property {?text|string} identification_type
 @property {string} identification_type_error
 @property {?string} image
 @property {string} image_error
 @property {?string} image_back
 @property {string} image_back_error
 @property {?text|string} non_immigrant_visa_prohibition
 @property {string} non_immigrant_visa_prohibition_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Logs
 @property {Customers_Logs_Properties} properties
 @property {Customers_Logs_Has} has
 @property {Customers_Logs_Is} is
 @property {Customers_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Logs_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {date|string} date
 @property {text|string} field
 @property {number|int} fkey
 @property {text|string} location_binary_id
 @property {text|string} note
 @property {text|string} o_table
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} user_binary_id
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Customers_Logs_Has
 */
/**
 @typedef {Object.<any>} Customers_Logs_Is
 @property {Customers_Object} customers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Customers_Logs_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} field
 @property {string} field_error
 @property {?number|int} fkey
 @property {string} fkey_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} note
 @property {string} note_error
 @property {?text|string} o_table
 @property {string} o_table_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Customers_Object} customers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Customers_Military
 @property {Customers_Military_Properties} properties
 @property {Customers_Military_Has} has
 @property {Customers_Military_Is} is
 @property {Customers_Military_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Military_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} county
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {text|string} pcs_city
 @property {date|string} pcs_date
 @property {text|string} pcs_order_number
 @property {text|string} pcs_state
 @property {number|int} pkey
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Customers_Military_Has
 */
/**
 @typedef {Object.<any>} Customers_Military_Is
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Military_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} county
 @property {string} county_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?text|string} pcs_city
 @property {string} pcs_city_error
 @property {?date|string} pcs_date
 @property {string} pcs_date_error
 @property {?text|string} pcs_order_number
 @property {string} pcs_order_number_error
 @property {?text|string} pcs_state
 @property {string} pcs_state_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Nics_Denies
 @property {Customers_Nics_Denies_Properties} properties
 @property {Customers_Nics_Denies_Has} has
 @property {Customers_Nics_Denies_Is} is
 @property {Customers_Nics_Denies_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Nics_Denies_Properties
 @property {text|string} _id
 @property {text|string} alien_number
 @property {text|string} binary_id
 @property {text|string} birth_city
 @property {text|string} birth_country
 @property {text|string} birth_county
 @property {date|string} birth_date
 @property {text|string} birth_state
 @property {boolean} blacklist
 @property {date|string} blacklist_date
 @property {text|string} blacklist_reason
 @property {boolean} company
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {boolean} ethnicity_hispanic
 @property {text|string} eye_color
 @property {text|string} foreign_citizenship
 @property {text|string} gender
 @property {text|string} hair_color
 @property {number|int} height_ft
 @property {number|int} height_in
 @property {boolean} ignore_duplicate
 @property {boolean} imported
 @property {number|int} legal_entity
 @property {text|string} legal_entity_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name_company
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_middle
 @property {text|string} name_suffix
 @property {boolean} nics_denied
 @property {date|string} nics_denied_date
 @property {text|string} notes
 @property {number|int} pkey
 @property {boolean} race_african_american
 @property {boolean} race_american_indian
 @property {boolean} race_asian
 @property {boolean} race_native_hawaiian
 @property {boolean} race_white
 @property {text|string} silencer_shop_lookup_id
 @property {text|string} ssn
 @property {text|string} state_of_residence
 @property {text|string} upin
 @property {boolean} us_citizen
 @property {number|int} weight
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} county
 @property {text|string} email
 @property {text|string} phone
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {boolean} us_born
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Customers_Nics_Denies_Has
 @property {Customers_Addresses_Object[]} customer_addressess
 @property {Customers_Emails_Object[]} customer_emailss
 @property {Customers_Identifications_Object[]} customer_identificationss
 @property {Customers_Military_Object[]} customer_militaries
 @property {Customers_Numbers_Object[]} customer_numberss
 @property {Customers_Permits_Object[]} customer_permitss
 */
/**
 @typedef {Object.<any>} Customers_Nics_Denies_Is
 @property {Legal_Entities_Object} legal_entities
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Nics_Denies_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} alien_number
 @property {string} alien_number_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} birth_city
 @property {string} birth_city_error
 @property {?text|string} birth_country
 @property {string} birth_country_error
 @property {?text|string} birth_county
 @property {string} birth_county_error
 @property {?date|string} birth_date
 @property {string} birth_date_error
 @property {?text|string} birth_state
 @property {string} birth_state_error
 @property {?boolean} blacklist
 @property {string} blacklist_error
 @property {?date|string} blacklist_date
 @property {string} blacklist_date_error
 @property {?text|string} blacklist_reason
 @property {string} blacklist_reason_error
 @property {?boolean} company
 @property {string} company_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?boolean} ethnicity_hispanic
 @property {string} ethnicity_hispanic_error
 @property {?text|string} eye_color
 @property {string} eye_color_error
 @property {?text|string} foreign_citizenship
 @property {string} foreign_citizenship_error
 @property {?text|string} gender
 @property {string} gender_error
 @property {?text|string} hair_color
 @property {string} hair_color_error
 @property {?number|int} height_ft
 @property {string} height_ft_error
 @property {?number|int} height_in
 @property {string} height_in_error
 @property {?boolean} ignore_duplicate
 @property {string} ignore_duplicate_error
 @property {?boolean} imported
 @property {string} imported_error
 @property {?number|int} legal_entity
 @property {string} legal_entity_error
 @property {?text|string} legal_entity_binary_id
 @property {string} legal_entity_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name_company
 @property {string} name_company_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_middle
 @property {string} name_middle_error
 @property {?text|string} name_suffix
 @property {string} name_suffix_error
 @property {?boolean} nics_denied
 @property {string} nics_denied_error
 @property {?date|string} nics_denied_date
 @property {string} nics_denied_date_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} race_african_american
 @property {string} race_african_american_error
 @property {?boolean} race_american_indian
 @property {string} race_american_indian_error
 @property {?boolean} race_asian
 @property {string} race_asian_error
 @property {?boolean} race_native_hawaiian
 @property {string} race_native_hawaiian_error
 @property {?boolean} race_white
 @property {string} race_white_error
 @property {?text|string} silencer_shop_lookup_id
 @property {string} silencer_shop_lookup_id_error
 @property {?text|string} ssn
 @property {string} ssn_error
 @property {?text|string} state_of_residence
 @property {string} state_of_residence_error
 @property {?text|string} upin
 @property {string} upin_error
 @property {?boolean} us_citizen
 @property {string} us_citizen_error
 @property {?number|int} weight
 @property {string} weight_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} county
 @property {string} county_error
 @property {?text|string} email
 @property {string} email_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?boolean} us_born
 @property {string} us_born_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Customers_Addresses_Object[]} customer_addressess
 @property {Customers_Emails_Object[]} customer_emailss
 @property {Customers_Identifications_Object[]} customer_identificationss
 @property {Customers_Military_Object[]} customer_militaries
 @property {Customers_Numbers_Object[]} customer_numberss
 @property {Customers_Permits_Object[]} customer_permitss
 @property {Legal_Entities_Object} legal_entities
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Numbers
 @property {Customers_Numbers_Properties} properties
 @property {Customers_Numbers_Has} has
 @property {Customers_Numbers_Is} is
 @property {Customers_Numbers_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Numbers_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {tel|string} number
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Customers_Numbers_Has
 */
/**
 @typedef {Object.<any>} Customers_Numbers_Is
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Numbers_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?tel|string} number
 @property {string} number_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Permits
 @property {Customers_Permits_Properties} properties
 @property {Customers_Permits_Has} has
 @property {Customers_Permits_Is} is
 @property {Customers_Permits_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Permits_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {date|string} expiration
 @property {string} image
 @property {string} image_back
 @property {date|string} issue
 @property {text|string} number
 @property {number|int} pkey
 @property {text|string} state
 @property {text|string} type
 */
/**
 @typedef {Object.<any>} Customers_Permits_Has
 */
/**
 @typedef {Object.<any>} Customers_Permits_Is
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Permits_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?date|string} expiration
 @property {string} expiration_error
 @property {?string} image
 @property {string} image_error
 @property {?string} image_back
 @property {string} image_back_error
 @property {?date|string} issue
 @property {string} issue_error
 @property {?text|string} number
 @property {string} number_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} type
 @property {string} type_error
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Permits_Images
 @property {Customers_Permits_Images_Properties} properties
 @property {Customers_Permits_Images_Has} has
 @property {Customers_Permits_Images_Is} is
 @property {Customers_Permits_Images_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Permits_Images_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {date|string} expiration
 @property {string} image
 @property {string} image_back
 @property {date|string} issue
 @property {text|string} number
 @property {number|int} pkey
 @property {text|string} state
 @property {text|string} type
 */
/**
 @typedef {Object.<any>} Customers_Permits_Images_Has
 */
/**
 @typedef {Object.<any>} Customers_Permits_Images_Is
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Customers_Permits_Images_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?date|string} expiration
 @property {string} expiration_error
 @property {?string} image
 @property {string} image_error
 @property {?string} image_back
 @property {string} image_back_error
 @property {?date|string} issue
 @property {string} issue_error
 @property {?text|string} number
 @property {string} number_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} type
 @property {string} type_error
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Cypress
 @property {Cypress_Properties} properties
 @property {Cypress_Has} has
 @property {Cypress_Is} is
 @property {Cypress_Object} object
 */
/**
 @typedef {Object.<any>} Cypress_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Cypress_Has
 */
/**
 @typedef {Object.<any>} Cypress_Is
 */
/**
 @typedef {Object.<any>} Cypress_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Dashboard
 @property {Dashboard_Properties} properties
 @property {Dashboard_Has} has
 @property {Dashboard_Is} is
 @property {Dashboard_Object} object
 */
/**
 @typedef {Object.<any>} Dashboard_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 @property {number|int} acq_count
 @property {number|int} acq_limit
 @property {number|int} data_usage
 @property {number|int} dispo_count
 @property {number|int} dispo_limit
 @property {array} in_stock
 @property {array} totals
 @property {array} transactions
 */
/**
 @typedef {Object.<any>} Dashboard_Has
 */
/**
 @typedef {Object.<any>} Dashboard_Is
 */
/**
 @typedef {Object.<any>} Dashboard_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} acq_count
 @property {string} acq_count_error
 @property {?number|int} acq_limit
 @property {string} acq_limit_error
 @property {?number|int} data_usage
 @property {string} data_usage_error
 @property {?number|int} dispo_count
 @property {string} dispo_count_error
 @property {?number|int} dispo_limit
 @property {string} dispo_limit_error
 @property {?array} in_stock
 @property {string} in_stock_error
 @property {?array} totals
 @property {string} totals_error
 @property {?array} transactions
 @property {string} transactions_error
 */
/**
 @typedef {Object.<any>} Davidsons
 @property {Davidsons_Properties} properties
 @property {Davidsons_Has} has
 @property {Davidsons_Is} is
 @property {Davidsons_Object} object
 */
/**
 @typedef {Object.<any>} Davidsons_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {number|int} pkey
 @property {boolean} reference_id
 */
/**
 @typedef {Object.<any>} Davidsons_Has
 */
/**
 @typedef {Object.<any>} Davidsons_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Davidsons_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} reference_id
 @property {string} reference_id_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Davidsons_Pendings
 @property {Davidsons_Pendings_Properties} properties
 @property {Davidsons_Pendings_Has} has
 @property {Davidsons_Pendings_Is} is
 @property {Davidsons_Pendings_Object} object
 */
/**
 @typedef {Object.<any>} Davidsons_Pendings_Properties
 @property {text|string} _id
 @property {number|int} account
 @property {text|string} binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} date
 @property {text|string} ffl_name
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} pending
 @property {number|int} pkey
 @property {number|int} quantity_products
 @property {text|string} upcs
 */
/**
 @typedef {Object.<any>} Davidsons_Pendings_Has
 */
/**
 @typedef {Object.<any>} Davidsons_Pendings_Is
 @property {Accounts_Object} accounts
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Davidsons_Pendings_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} ffl_name
 @property {string} ffl_name_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} pending
 @property {string} pending_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} quantity_products
 @property {string} quantity_products_error
 @property {?text|string} upcs
 @property {string} upcs_error
 @property {Accounts_Object} accounts
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Davidsons_Products
 @property {Davidsons_Products_Properties} properties
 @property {Davidsons_Products_Has} has
 @property {Davidsons_Products_Is} is
 @property {Davidsons_Products_Object} object
 */
/**
 @typedef {Object.<any>} Davidsons_Products_Properties
 @property {text|string} _id
 @property {number|int|float} base_price
 @property {text|string} binary_id
 @property {number|int} caliber
 @property {text|string} item
 @property {text|string} mag_capicity
 @property {number|int} manufacturer
 @property {text|string} manufacturer_other
 @property {number|int|float} min_price
 @property {text|string} model
 @property {text|string} pict_file
 @property {number|int} pkey
 @property {text|string} product_class
 @property {number|int} quantity
 @property {number|int|float} sale_price
 @property {text|string} upc_code
 @property {text|string} davidsons_account_number
 @property {text|string} item_quantity
 @property {number|int} location
 */
/**
 @typedef {Object.<any>} Davidsons_Products_Has
 @property {Locations_Object[]} locationss
 */
/**
 @typedef {Object.<any>} Davidsons_Products_Is
 @property {Calibers_Object} calibers
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 */
/**
 @typedef {Object.<any>} Davidsons_Products_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int|float} base_price
 @property {string} base_price_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} caliber
 @property {string} caliber_error
 @property {?text|string} item
 @property {string} item_error
 @property {?text|string} mag_capicity
 @property {string} mag_capicity_error
 @property {?number|int} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} manufacturer_other
 @property {string} manufacturer_other_error
 @property {?number|int|float} min_price
 @property {string} min_price_error
 @property {?text|string} model
 @property {string} model_error
 @property {?text|string} pict_file
 @property {string} pict_file_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} product_class
 @property {string} product_class_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?number|int|float} sale_price
 @property {string} sale_price_error
 @property {?text|string} upc_code
 @property {string} upc_code_error
 @property {?text|string} davidsons_account_number
 @property {string} davidsons_account_number_error
 @property {?text|string} item_quantity
 @property {string} item_quantity_error
 @property {?number|int} location
 @property {string} location_error
 @property {Locations_Object[]} locationss
 @property {Calibers_Object} calibers
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 */
/**
 @typedef {Object.<any>} Dealers
 @property {Dealers_Properties} properties
 @property {Dealers_Has} has
 @property {Dealers_Is} is
 @property {Dealers_Object} object
 */
/**
 @typedef {Object.<any>} Dealers_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} change_note
 @property {text|string} city
 @property {text|string} city_limits
 @property {boolean} company
 @property {text|string} county
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {text|string} ein
 @property {email} email
 @property {text|string} ffl
 @property {number|int} ffl_class
 @property {date|string} ffl_expiration
 @property {number|int} ffl_type
 @property {string} image
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name_company
 @property {text|string} name_display
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_trade
 @property {text|string} note
 @property {tel|string} number_main
 @property {tel|string} number_mobile
 @property {number|int} pkey
 @property {text|string} ssn
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} zip
 @property {text|string} billing_split
 */
/**
 @typedef {Object.<any>} Dealers_Has
 */
/**
 @typedef {Object.<any>} Dealers_Is
 @property {Ffls_Classes_Object} ffl_classes
 @property {Ffls_Types_Object} ffl_types
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Dealers_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} change_note
 @property {string} change_note_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?boolean} company
 @property {string} company_error
 @property {?text|string} county
 @property {string} county_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?text|string} ein
 @property {string} ein_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} ffl
 @property {string} ffl_error
 @property {?number|int} ffl_class
 @property {string} ffl_class_error
 @property {?date|string} ffl_expiration
 @property {string} ffl_expiration_error
 @property {?number|int} ffl_type
 @property {string} ffl_type_error
 @property {?string} image
 @property {string} image_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name_company
 @property {string} name_company_error
 @property {?text|string} name_display
 @property {string} name_display_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_trade
 @property {string} name_trade_error
 @property {?text|string} note
 @property {string} note_error
 @property {?tel|string} number_main
 @property {string} number_main_error
 @property {?tel|string} number_mobile
 @property {string} number_mobile_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} ssn
 @property {string} ssn_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} billing_split
 @property {string} billing_split_error
 @property {Ffls_Classes_Object} ffl_classes
 @property {Ffls_Types_Object} ffl_types
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Dealers_Duplicates
 @property {Dealers_Duplicates_Properties} properties
 @property {Dealers_Duplicates_Has} has
 @property {Dealers_Duplicates_Is} is
 @property {Dealers_Duplicates_Object} object
 */
/**
 @typedef {Object.<any>} Dealers_Duplicates_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} county
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name_first
 @property {text|string} name_last
 @property {number|int} pkey
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} zip
 @property {text|string} city_limits
 @property {email} email
 @property {text|string} ffl
 @property {text|string} name_company
 @property {tel|string} number_main
 @property {tel|string} number_mobile
 @property {number|int} original
 @property {text|string} original_binary_id
 @property {text|string} original_city
 @property {text|string} original_county
 @property {email} original_email
 @property {text|string} original_ffl
 @property {text|string} original_name_company
 @property {text|string} original_name_first
 @property {text|string} original_name_last
 @property {tel|string} original_number_main
 @property {tel|string} original_number_mobile
 @property {text|string} original_state
 @property {text|string} original_street_1
 @property {text|string} original_street_2
 @property {text|string} original_zip
 */
/**
 @typedef {Object.<any>} Dealers_Duplicates_Has
 */
/**
 @typedef {Object.<any>} Dealers_Duplicates_Is
 @property {Dealers_Object} dealers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Dealers_Duplicates_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} county
 @property {string} county_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} ffl
 @property {string} ffl_error
 @property {?text|string} name_company
 @property {string} name_company_error
 @property {?tel|string} number_main
 @property {string} number_main_error
 @property {?tel|string} number_mobile
 @property {string} number_mobile_error
 @property {?number|int} original
 @property {string} original_error
 @property {?text|string} original_binary_id
 @property {string} original_binary_id_error
 @property {?text|string} original_city
 @property {string} original_city_error
 @property {?text|string} original_county
 @property {string} original_county_error
 @property {?email} original_email
 @property {string} original_email_error
 @property {?text|string} original_ffl
 @property {string} original_ffl_error
 @property {?text|string} original_name_company
 @property {string} original_name_company_error
 @property {?text|string} original_name_first
 @property {string} original_name_first_error
 @property {?text|string} original_name_last
 @property {string} original_name_last_error
 @property {?tel|string} original_number_main
 @property {string} original_number_main_error
 @property {?tel|string} original_number_mobile
 @property {string} original_number_mobile_error
 @property {?text|string} original_state
 @property {string} original_state_error
 @property {?text|string} original_street_1
 @property {string} original_street_1_error
 @property {?text|string} original_street_2
 @property {string} original_street_2_error
 @property {?text|string} original_zip
 @property {string} original_zip_error
 @property {Dealers_Object} dealers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Dealers_Images
 @property {Dealers_Images_Properties} properties
 @property {Dealers_Images_Has} has
 @property {Dealers_Images_Is} is
 @property {Dealers_Images_Object} object
 */
/**
 @typedef {Object.<any>} Dealers_Images_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} change_note
 @property {text|string} city
 @property {text|string} city_limits
 @property {boolean} company
 @property {text|string} county
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {text|string} ein
 @property {email} email
 @property {text|string} ffl
 @property {number|int} ffl_class
 @property {date|string} ffl_expiration
 @property {number|int} ffl_type
 @property {string} image
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name_company
 @property {text|string} name_display
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_trade
 @property {text|string} note
 @property {tel|string} number_main
 @property {tel|string} number_mobile
 @property {number|int} pkey
 @property {text|string} ssn
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} zip
 @property {text|string} billing_split
 */
/**
 @typedef {Object.<any>} Dealers_Images_Has
 */
/**
 @typedef {Object.<any>} Dealers_Images_Is
 @property {Ffls_Classes_Object} ffl_classes
 @property {Ffls_Types_Object} ffl_types
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Dealers_Images_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} change_note
 @property {string} change_note_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?boolean} company
 @property {string} company_error
 @property {?text|string} county
 @property {string} county_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?text|string} ein
 @property {string} ein_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} ffl
 @property {string} ffl_error
 @property {?number|int} ffl_class
 @property {string} ffl_class_error
 @property {?date|string} ffl_expiration
 @property {string} ffl_expiration_error
 @property {?number|int} ffl_type
 @property {string} ffl_type_error
 @property {?string} image
 @property {string} image_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name_company
 @property {string} name_company_error
 @property {?text|string} name_display
 @property {string} name_display_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_trade
 @property {string} name_trade_error
 @property {?text|string} note
 @property {string} note_error
 @property {?tel|string} number_main
 @property {string} number_main_error
 @property {?tel|string} number_mobile
 @property {string} number_mobile_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} ssn
 @property {string} ssn_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} billing_split
 @property {string} billing_split_error
 @property {Ffls_Classes_Object} ffl_classes
 @property {Ffls_Types_Object} ffl_types
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Dealers_Logs
 @property {Dealers_Logs_Properties} properties
 @property {Dealers_Logs_Has} has
 @property {Dealers_Logs_Is} is
 @property {Dealers_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Dealers_Logs_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} date
 @property {number|int} dealer
 @property {text|string} dealer_binary_id
 @property {text|string} display_new
 @property {text|string} display_old
 @property {text|string} field
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} user_binary_id
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Dealers_Logs_Has
 */
/**
 @typedef {Object.<any>} Dealers_Logs_Is
 @property {Dealers_Object} dealers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Dealers_Logs_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?number|int} dealer
 @property {string} dealer_error
 @property {?text|string} dealer_binary_id
 @property {string} dealer_binary_id_error
 @property {?text|string} display_new
 @property {string} display_new_error
 @property {?text|string} display_old
 @property {string} display_old_error
 @property {?text|string} field
 @property {string} field_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Dealers_Object} dealers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Dealers_Missing_Email_Logs
 @property {Dealers_Missing_Email_Logs_Properties} properties
 @property {Dealers_Missing_Email_Logs_Has} has
 @property {Dealers_Missing_Email_Logs_Is} is
 @property {Dealers_Missing_Email_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Dealers_Missing_Email_Logs_Properties
 @property {text|string} _id
 @property {number|int} account
 @property {text|string} binary_id
 @property {date|string} created
 @property {date|string} date
 @property {date|string} date_ignored
 @property {number|int} dealer
 @property {text|string} dealer_binary_id
 @property {text|string} display_new
 @property {text|string} display_old
 @property {text|string} ffl_type
 @property {text|string} field
 @property {text|string} note
 @property {text|string} notes
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} user_binary_id
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Dealers_Missing_Email_Logs_Has
 */
/**
 @typedef {Object.<any>} Dealers_Missing_Email_Logs_Is
 @property {Accounts_Object} accounts
 @property {Dealers_Object} dealers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Dealers_Missing_Email_Logs_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?date|string} date
 @property {string} date_error
 @property {?date|string} date_ignored
 @property {string} date_ignored_error
 @property {?number|int} dealer
 @property {string} dealer_error
 @property {?text|string} dealer_binary_id
 @property {string} dealer_binary_id_error
 @property {?text|string} display_new
 @property {string} display_new_error
 @property {?text|string} display_old
 @property {string} display_old_error
 @property {?text|string} ffl_type
 @property {string} ffl_type_error
 @property {?text|string} field
 @property {string} field_error
 @property {?text|string} note
 @property {string} note_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Accounts_Object} accounts
 @property {Dealers_Object} dealers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Dispositions_Nics
 @property {Dispositions_Nics_Properties} properties
 @property {Dispositions_Nics_Has} has
 @property {Dispositions_Nics_Is} is
 @property {Dispositions_Nics_Object} object
 */
/**
 @typedef {Object.<any>} Dispositions_Nics_Properties
 @property {text|string} _id
 @property {date|string} background_checked
 @property {number|int} background_checker
 @property {text|string} background_checker_binary_id
 @property {text|string} binary_id
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {boolean} cancelled
 @property {text|string} change_note
 @property {text|string} cpl_number
 @property {date|string} created
 @property {text|string} created_first_name
 @property {text|string} created_last_name
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {text|string} customer_city
 @property {text|string} customer_city_limits
 @property {text|string} customer_county
 @property {text|string} customer_military_city
 @property {text|string} customer_military_county
 @property {text|string} customer_military_pcs_basename
 @property {text|string} customer_military_pcs_city
 @property {date|string} customer_military_pcs_date
 @property {text|string} customer_military_pcs_order_number
 @property {text|string} customer_military_pcs_state
 @property {text|string} customer_military_state
 @property {text|string} customer_military_street_1
 @property {text|string} customer_military_street_2
 @property {text|string} customer_military_zip
 @property {text|string} customer_name_company
 @property {text|string} customer_name_first
 @property {text|string} customer_name_last
 @property {text|string} customer_name_middle
 @property {text|string} customer_name_suffix
 @property {text|string} customer_state
 @property {text|string} customer_street_1
 @property {text|string} customer_street_2
 @property {text|string} customer_zip
 @property {date|string} date
 @property {number|int} dealer
 @property {text|string} dealer_binary_id
 @property {text|string} dealer_ffl
 @property {text|string} dealer_name_company
 @property {number|int} event
 @property {text|string} event_binary_id
 @property {number|int} exporter
 @property {text|string} exporter_address
 @property {text|string} exporter_binary_id
 @property {text|string} exporter_name
 @property {boolean} ghost
 @property {boolean} has_combined
 @property {text|string} identification_image
 @property {text|string} identification_image_back
 @property {boolean} imported
 @property {number|int} importer
 @property {text|string} importer_binary_id
 @property {text|string} importer_ffl
 @property {text|string} importer_full_address
 @property {text|string} importer_name_display
 @property {text|string} incident_number
 @property {number|int} internal
 @property {text|string} internal_binary_id
 @property {number|int} legal_entity
 @property {text|string} legal_entity_binary_id
 @property {text|string} legal_entity_city
 @property {text|string} legal_entity_county
 @property {text|string} legal_entity_name
 @property {text|string} legal_entity_state
 @property {text|string} legal_entity_street_1
 @property {text|string} legal_entity_street_2
 @property {text|string} legal_entity_zip
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} maker_city
 @property {text|string} maker_state
 @property {text|string} maker_street_1
 @property {text|string} maker_street_2
 @property {text|string} maker_zip
 @property {text|string} manual_4473
 @property {boolean} manufacturing
 @property {text|string} mcoles_number
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} notes
 @property {text|string} pawn_inventory
 @property {boolean} pawn_redemption
 @property {text|string} pawn_ticket
 @property {date|string} permit_expiration_date
 @property {text|string} permit_image
 @property {text|string} permit_image_back
 @property {text|string} permit_number
 @property {number|int} pkey
 @property {boolean} private_party_transfer
 @property {boolean} returned
 @property {date|string} returned_date
 @property {text|string} transaction
 @property {boolean} transfer_internal_sent
 @property {text|string} transfer_notification_email
 @property {number|int} type
 @property {text|string} type_of_notice
 @property {array} caliber_others
 @property {text|string} collection
 @property {text|string} collection_binary_id
 @property {text|string} disposed_to
 @property {text|string} foreign_order_id
 @property {boolean} is_military
 @property {number|int} kiosk
 @property {text|string} kiosk_binary_id
 @property {array} manufacturer_others
 @property {array} models
 @property {text|string} old_dealer_ffl
 @property {array} products
 @property {array} serial_numbers
 @property {string} signature_30
 @property {date|string} signature_30_date
 @property {array} types
 */
/**
 @typedef {Object.<any>} Dispositions_Nics_Has
 @property {Forms_Results_Object[]} form_resultss
 @property {Multiple_Sales_Object[]} multiple_saless
 @property {Signatures_Object[]} signaturess
 @property {Transactions_Entries_Object[]} transaction_entriess
 @property {Transactions_Nics_Object[]} transaction_nicss
 @property {Transactions_Questions_Object[]} transaction_questionss
 @property {Transactions_Signatures_Object[]} transaction_signaturess
 */
/**
 @typedef {Object.<any>} Dispositions_Nics_Is
 @property {Customers_Object} customers
 @property {Dealers_Object} dealers
 @property {Events_Object} events
 @property {Exports_Object} exports
 @property {Importers_Object} importers
 @property {Kiosks_Object} kiosks
 @property {Legal_Entities_Object} legal_entities
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations_related_by_internal
 @property {Locations_Object} locations_related_by_location
 @property {Transactions_Types_Object} transaction_types
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Dispositions_Nics_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?date|string} background_checked
 @property {string} background_checked_error
 @property {?number|int} background_checker
 @property {string} background_checker_error
 @property {?text|string} background_checker_binary_id
 @property {string} background_checker_binary_id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?boolean} cancelled
 @property {string} cancelled_error
 @property {?text|string} change_note
 @property {string} change_note_error
 @property {?text|string} cpl_number
 @property {string} cpl_number_error
 @property {?date|string} created
 @property {string} created_error
 @property {?text|string} created_first_name
 @property {string} created_first_name_error
 @property {?text|string} created_last_name
 @property {string} created_last_name_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?text|string} customer_city
 @property {string} customer_city_error
 @property {?text|string} customer_city_limits
 @property {string} customer_city_limits_error
 @property {?text|string} customer_county
 @property {string} customer_county_error
 @property {?text|string} customer_military_city
 @property {string} customer_military_city_error
 @property {?text|string} customer_military_county
 @property {string} customer_military_county_error
 @property {?text|string} customer_military_pcs_basename
 @property {string} customer_military_pcs_basename_error
 @property {?text|string} customer_military_pcs_city
 @property {string} customer_military_pcs_city_error
 @property {?date|string} customer_military_pcs_date
 @property {string} customer_military_pcs_date_error
 @property {?text|string} customer_military_pcs_order_number
 @property {string} customer_military_pcs_order_number_error
 @property {?text|string} customer_military_pcs_state
 @property {string} customer_military_pcs_state_error
 @property {?text|string} customer_military_state
 @property {string} customer_military_state_error
 @property {?text|string} customer_military_street_1
 @property {string} customer_military_street_1_error
 @property {?text|string} customer_military_street_2
 @property {string} customer_military_street_2_error
 @property {?text|string} customer_military_zip
 @property {string} customer_military_zip_error
 @property {?text|string} customer_name_company
 @property {string} customer_name_company_error
 @property {?text|string} customer_name_first
 @property {string} customer_name_first_error
 @property {?text|string} customer_name_last
 @property {string} customer_name_last_error
 @property {?text|string} customer_name_middle
 @property {string} customer_name_middle_error
 @property {?text|string} customer_name_suffix
 @property {string} customer_name_suffix_error
 @property {?text|string} customer_state
 @property {string} customer_state_error
 @property {?text|string} customer_street_1
 @property {string} customer_street_1_error
 @property {?text|string} customer_street_2
 @property {string} customer_street_2_error
 @property {?text|string} customer_zip
 @property {string} customer_zip_error
 @property {?date|string} date
 @property {string} date_error
 @property {?number|int} dealer
 @property {string} dealer_error
 @property {?text|string} dealer_binary_id
 @property {string} dealer_binary_id_error
 @property {?text|string} dealer_ffl
 @property {string} dealer_ffl_error
 @property {?text|string} dealer_name_company
 @property {string} dealer_name_company_error
 @property {?number|int} event
 @property {string} event_error
 @property {?text|string} event_binary_id
 @property {string} event_binary_id_error
 @property {?number|int} exporter
 @property {string} exporter_error
 @property {?text|string} exporter_address
 @property {string} exporter_address_error
 @property {?text|string} exporter_binary_id
 @property {string} exporter_binary_id_error
 @property {?text|string} exporter_name
 @property {string} exporter_name_error
 @property {?boolean} ghost
 @property {string} ghost_error
 @property {?boolean} has_combined
 @property {string} has_combined_error
 @property {?text|string} identification_image
 @property {string} identification_image_error
 @property {?text|string} identification_image_back
 @property {string} identification_image_back_error
 @property {?boolean} imported
 @property {string} imported_error
 @property {?number|int} importer
 @property {string} importer_error
 @property {?text|string} importer_binary_id
 @property {string} importer_binary_id_error
 @property {?text|string} importer_ffl
 @property {string} importer_ffl_error
 @property {?text|string} importer_full_address
 @property {string} importer_full_address_error
 @property {?text|string} importer_name_display
 @property {string} importer_name_display_error
 @property {?text|string} incident_number
 @property {string} incident_number_error
 @property {?number|int} internal
 @property {string} internal_error
 @property {?text|string} internal_binary_id
 @property {string} internal_binary_id_error
 @property {?number|int} legal_entity
 @property {string} legal_entity_error
 @property {?text|string} legal_entity_binary_id
 @property {string} legal_entity_binary_id_error
 @property {?text|string} legal_entity_city
 @property {string} legal_entity_city_error
 @property {?text|string} legal_entity_county
 @property {string} legal_entity_county_error
 @property {?text|string} legal_entity_name
 @property {string} legal_entity_name_error
 @property {?text|string} legal_entity_state
 @property {string} legal_entity_state_error
 @property {?text|string} legal_entity_street_1
 @property {string} legal_entity_street_1_error
 @property {?text|string} legal_entity_street_2
 @property {string} legal_entity_street_2_error
 @property {?text|string} legal_entity_zip
 @property {string} legal_entity_zip_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} maker_city
 @property {string} maker_city_error
 @property {?text|string} maker_state
 @property {string} maker_state_error
 @property {?text|string} maker_street_1
 @property {string} maker_street_1_error
 @property {?text|string} maker_street_2
 @property {string} maker_street_2_error
 @property {?text|string} maker_zip
 @property {string} maker_zip_error
 @property {?text|string} manual_4473
 @property {string} manual_4473_error
 @property {?boolean} manufacturing
 @property {string} manufacturing_error
 @property {?text|string} mcoles_number
 @property {string} mcoles_number_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} pawn_inventory
 @property {string} pawn_inventory_error
 @property {?boolean} pawn_redemption
 @property {string} pawn_redemption_error
 @property {?text|string} pawn_ticket
 @property {string} pawn_ticket_error
 @property {?date|string} permit_expiration_date
 @property {string} permit_expiration_date_error
 @property {?text|string} permit_image
 @property {string} permit_image_error
 @property {?text|string} permit_image_back
 @property {string} permit_image_back_error
 @property {?text|string} permit_number
 @property {string} permit_number_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} private_party_transfer
 @property {string} private_party_transfer_error
 @property {?boolean} returned
 @property {string} returned_error
 @property {?date|string} returned_date
 @property {string} returned_date_error
 @property {?text|string} transaction
 @property {string} transaction_error
 @property {?boolean} transfer_internal_sent
 @property {string} transfer_internal_sent_error
 @property {?text|string} transfer_notification_email
 @property {string} transfer_notification_email_error
 @property {?number|int} type
 @property {string} type_error
 @property {?text|string} type_of_notice
 @property {string} type_of_notice_error
 @property {?array} caliber_others
 @property {string} caliber_others_error
 @property {?text|string} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?text|string} disposed_to
 @property {string} disposed_to_error
 @property {?text|string} foreign_order_id
 @property {string} foreign_order_id_error
 @property {?boolean} is_military
 @property {string} is_military_error
 @property {?number|int} kiosk
 @property {string} kiosk_error
 @property {?text|string} kiosk_binary_id
 @property {string} kiosk_binary_id_error
 @property {?array} manufacturer_others
 @property {string} manufacturer_others_error
 @property {?array} models
 @property {string} models_error
 @property {?text|string} old_dealer_ffl
 @property {string} old_dealer_ffl_error
 @property {?array} products
 @property {string} products_error
 @property {?array} serial_numbers
 @property {string} serial_numbers_error
 @property {?string} signature_30
 @property {string} signature_30_error
 @property {?date|string} signature_30_date
 @property {string} signature_30_date_error
 @property {?array} types
 @property {string} types_error
 @property {Forms_Results_Object[]} form_resultss
 @property {Multiple_Sales_Object[]} multiple_saless
 @property {Signatures_Object[]} signaturess
 @property {Transactions_Entries_Object[]} transaction_entriess
 @property {Transactions_Nics_Object[]} transaction_nicss
 @property {Transactions_Questions_Object[]} transaction_questionss
 @property {Transactions_Signatures_Object[]} transaction_signaturess
 @property {Customers_Object} customers
 @property {Dealers_Object} dealers
 @property {Events_Object} events
 @property {Exports_Object} exports
 @property {Importers_Object} importers
 @property {Kiosks_Object} kiosks
 @property {Legal_Entities_Object} legal_entities
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations_related_by_internal
 @property {Locations_Object} locations_related_by_location
 @property {Transactions_Types_Object} transaction_types
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Drivers_License_Logs
 @property {Drivers_License_Logs_Properties} properties
 @property {Drivers_License_Logs_Has} has
 @property {Drivers_License_Logs_Is} is
 @property {Drivers_License_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Drivers_License_Logs_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {date|string} date
 @property {text|string} field
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} user_binary_id
 @property {text|string} user_scan
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Drivers_License_Logs_Has
 */
/**
 @typedef {Object.<any>} Drivers_License_Logs_Is
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Drivers_License_Logs_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} field
 @property {string} field_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?text|string} user_scan
 @property {string} user_scan_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Dropbox
 @property {Dropbox_Properties} properties
 @property {Dropbox_Has} has
 @property {Dropbox_Is} is
 @property {Dropbox_Object} object
 */
/**
 @typedef {Object.<any>} Dropbox_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Dropbox_Has
 */
/**
 @typedef {Object.<any>} Dropbox_Is
 */
/**
 @typedef {Object.<any>} Dropbox_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Email_Templates
 @property {Email_Templates_Properties} properties
 @property {Email_Templates_Has} has
 @property {Email_Templates_Is} is
 @property {Email_Templates_Object} object
 */
/**
 @typedef {Object.<any>} Email_Templates_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} name
 @property {number|int} pkey
 @property {boolean} show_admin
 @property {text|string} template
 */
/**
 @typedef {Object.<any>} Email_Templates_Has
 */
/**
 @typedef {Object.<any>} Email_Templates_Is
 */
/**
 @typedef {Object.<any>} Email_Templates_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} show_admin
 @property {string} show_admin_error
 @property {?text|string} template
 @property {string} template_error
 */
/**
 @typedef {Object.<any>} Email_Testing
 @property {Email_Testing_Properties} properties
 @property {Email_Testing_Has} has
 @property {Email_Testing_Is} is
 @property {Email_Testing_Object} object
 */
/**
 @typedef {Object.<any>} Email_Testing_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {date|string} date
 @property {number|int} dealer
 @property {text|string} dealer_binary_id
 @property {boolean} edited_email
 @property {email} email
 @property {text|string} message
 @property {number|int} pkey
 @property {number|int} template
 @property {number|int} user
 @property {text|string} user_binary_id
 */
/**
 @typedef {Object.<any>} Email_Testing_Has
 */
/**
 @typedef {Object.<any>} Email_Testing_Is
 @property {Customers_Object} customers
 @property {Dealers_Object} dealers
 @property {Email_Templates_Object} email_templates
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Email_Testing_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?number|int} dealer
 @property {string} dealer_error
 @property {?text|string} dealer_binary_id
 @property {string} dealer_binary_id_error
 @property {?boolean} edited_email
 @property {string} edited_email_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} message
 @property {string} message_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} template
 @property {string} template_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {Customers_Object} customers
 @property {Dealers_Object} dealers
 @property {Email_Templates_Object} email_templates
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Events
 @property {Events_Properties} properties
 @property {Events_Has} has
 @property {Events_Is} is
 @property {Events_Object} object
 */
/**
 @typedef {Object.<any>} Events_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} county
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} end
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name
 @property {number|int} pkey
 @property {date|string} start
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Events_Has
 */
/**
 @typedef {Object.<any>} Events_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Events_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} county
 @property {string} county_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} end
 @property {string} end_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?date|string} start
 @property {string} start_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Events_Logs
 @property {Events_Logs_Properties} properties
 @property {Events_Logs_Has} has
 @property {Events_Logs_Is} is
 @property {Events_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Events_Logs_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} date
 @property {number|int} event
 @property {text|string} event_binary_id
 @property {text|string} field
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} user_binary_id
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Events_Logs_Has
 */
/**
 @typedef {Object.<any>} Events_Logs_Is
 @property {Events_Object} events
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Events_Logs_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?number|int} event
 @property {string} event_error
 @property {?text|string} event_binary_id
 @property {string} event_binary_id_error
 @property {?text|string} field
 @property {string} field_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Events_Object} events
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Export
 @property {Export_Properties} properties
 @property {Export_Has} has
 @property {Export_Is} is
 @property {Export_Object} object
 */
/**
 @typedef {Object.<any>} Export_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Export_Has
 */
/**
 @typedef {Object.<any>} Export_Is
 */
/**
 @typedef {Object.<any>} Export_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Exports
 @property {Exports_Properties} properties
 @property {Exports_Has} has
 @property {Exports_Is} is
 @property {Exports_Object} object
 */
/**
 @typedef {Object.<any>} Exports_Properties
 @property {text|string} _id
 @property {text|string} address
 @property {text|string} binary_id
 @property {text|string} change_note
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Exports_Has
 */
/**
 @typedef {Object.<any>} Exports_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Exports_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} address
 @property {string} address_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} change_note
 @property {string} change_note_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Exports_Logs
 @property {Exports_Logs_Properties} properties
 @property {Exports_Logs_Has} has
 @property {Exports_Logs_Is} is
 @property {Exports_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Exports_Logs_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} date
 @property {number|int} exporter
 @property {text|string} exporter_binary_id
 @property {text|string} field
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} user_binary_id
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Exports_Logs_Has
 */
/**
 @typedef {Object.<any>} Exports_Logs_Is
 @property {Exports_Object} exports
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Exports_Logs_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?number|int} exporter
 @property {string} exporter_error
 @property {?text|string} exporter_binary_id
 @property {string} exporter_binary_id_error
 @property {?text|string} field
 @property {string} field_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Exports_Object} exports
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Filesizes
 @property {Filesizes_Properties} properties
 @property {Filesizes_Has} has
 @property {Filesizes_Is} is
 @property {Filesizes_Object} object
 */
/**
 @typedef {Object.<any>} Filesizes_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {date|string} created
 @property {text|string} filename
 @property {number|int} form
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {number|int} pkey
 @property {number|int} signature_location
 @property {number|int} size
 */
/**
 @typedef {Object.<any>} Filesizes_Has
 */
/**
 @typedef {Object.<any>} Filesizes_Is
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Transactions_Collections_Object} transaction_collections
 @property {Transactions_Signatures_Locations_Object} transaction_signature_locations
 */
/**
 @typedef {Object.<any>} Filesizes_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?text|string} filename
 @property {string} filename_error
 @property {?number|int} form
 @property {string} form_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} signature_location
 @property {string} signature_location_error
 @property {?number|int} size
 @property {string} size_error
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Transactions_Collections_Object} transaction_collections
 @property {Transactions_Signatures_Locations_Object} transaction_signature_locations
 */
/**
 @typedef {Object.<any>} Form_P12s
 @property {Form_P12s_Properties} properties
 @property {Form_P12s_Has} has
 @property {Form_P12s_Is} is
 @property {Form_P12s_Object} object
 */
/**
 @typedef {Object.<any>} Form_P12s_Properties
 @property {text|string} _id
 @property {text|string} address
 @property {text|string} address_secondary
 @property {text|string} badge_number
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {text|string} county
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} date_issued
 @property {date|string} date_of_birth
 @property {text|string} dealer_gunsmith
 @property {text|string} employer_agency
 @property {text|string} issuing_authority
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {date|string} month_day_year
 @property {text|string} nysp_code_number
 @property {text|string} occupation
 @property {text|string} pistol_license_number_nysp_dealer_code_ffl
 @property {number|int} pkey
 @property {boolean} received_from
 @property {boolean} repaired_for
 @property {text|string} serial_number
 @property {text|string} sold_received_repaired_name
 @property {boolean} sold_to
 */
/**
 @typedef {Object.<any>} Form_P12s_Has
 */
/**
 @typedef {Object.<any>} Form_P12s_Is
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Form_P12s_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} address
 @property {string} address_error
 @property {?text|string} address_secondary
 @property {string} address_secondary_error
 @property {?text|string} badge_number
 @property {string} badge_number_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?text|string} county
 @property {string} county_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} date_issued
 @property {string} date_issued_error
 @property {?date|string} date_of_birth
 @property {string} date_of_birth_error
 @property {?text|string} dealer_gunsmith
 @property {string} dealer_gunsmith_error
 @property {?text|string} employer_agency
 @property {string} employer_agency_error
 @property {?text|string} issuing_authority
 @property {string} issuing_authority_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?date|string} month_day_year
 @property {string} month_day_year_error
 @property {?text|string} nysp_code_number
 @property {string} nysp_code_number_error
 @property {?text|string} occupation
 @property {string} occupation_error
 @property {?text|string} pistol_license_number_nysp_dealer_code_ffl
 @property {string} pistol_license_number_nysp_dealer_code_ffl_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} received_from
 @property {string} received_from_error
 @property {?boolean} repaired_for
 @property {string} repaired_for_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} sold_received_repaired_name
 @property {string} sold_received_repaired_name_error
 @property {?boolean} sold_to
 @property {string} sold_to_error
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Forms_Results
 @property {Forms_Results_Properties} properties
 @property {Forms_Results_Has} has
 @property {Forms_Results_Is} is
 @property {Forms_Results_Object} object
 */
/**
 @typedef {Object.<any>} Forms_Results_Properties
 @property {text|string} _id
 @property {string} amended
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {number|int} disposition_pending
 @property {text|string} disposition_pending_binary_id
 @property {text|string} filename
 @property {number|int} form
 @property {number|int} form_p12
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} payment
 @property {number|int} pkey
 @property {number|int} product
 @property {text|string} product_binary_id
 @property {number|int} quarter
 @property {string} results
 @property {boolean} sent_atf
 @property {boolean} sent_cleo
 @property {text|string} sent_cleo_email
 @property {text|string} type
 @property {text|string} year
 @property {boolean} has_notes
 @property {boolean} send_email
 */
/**
 @typedef {Object.<any>} Forms_Results_Has
 */
/**
 @typedef {Object.<any>} Forms_Results_Is
 @property {Customers_Object} customers
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Form_P12s_Object} form_p12s
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Forms_Results_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?string} amended
 @property {string} amended_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?number|int} disposition_pending
 @property {string} disposition_pending_error
 @property {?text|string} disposition_pending_binary_id
 @property {string} disposition_pending_binary_id_error
 @property {?text|string} filename
 @property {string} filename_error
 @property {?number|int} form
 @property {string} form_error
 @property {?number|int} form_p12
 @property {string} form_p12_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} payment
 @property {string} payment_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} product_binary_id
 @property {string} product_binary_id_error
 @property {?number|int} quarter
 @property {string} quarter_error
 @property {?string} results
 @property {string} results_error
 @property {?boolean} sent_atf
 @property {string} sent_atf_error
 @property {?boolean} sent_cleo
 @property {string} sent_cleo_error
 @property {?text|string} sent_cleo_email
 @property {string} sent_cleo_email_error
 @property {?text|string} type
 @property {string} type_error
 @property {?text|string} year
 @property {string} year_error
 @property {?boolean} has_notes
 @property {string} has_notes_error
 @property {?boolean} send_email
 @property {string} send_email_error
 @property {Customers_Object} customers
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Form_P12s_Object} form_p12s
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Gunbroker_Orders
 @property {Gunbroker_Orders_Properties} properties
 @property {Gunbroker_Orders_Has} has
 @property {Gunbroker_Orders_Is} is
 @property {Gunbroker_Orders_Object} object
 */
/**
 @typedef {Object.<any>} Gunbroker_Orders_Properties
 @property {text|string} _id
 @property {date|string} acquire_date
 @property {string} bill_to
 @property {text|string} binary_id
 @property {string} buyer
 @property {date|string} created
 @property {date|string} disposed_date
 @property {text|string} ffl_number
 @property {text|string} ffl_status
 @property {string} items
 @property {date|string} order_date
 @property {text|string} order_id
 @property {boolean} order_sold
 @property {number|int} pkey
 @property {string} seller
 @property {string} ship_to
 @property {text|string} status
 @property {number|int|float} total_price
 @property {number|int|float} total_tax
 @property {date|string} transfer_date
 */
/**
 @typedef {Object.<any>} Gunbroker_Orders_Has
 */
/**
 @typedef {Object.<any>} Gunbroker_Orders_Is
 */
/**
 @typedef {Object.<any>} Gunbroker_Orders_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?date|string} acquire_date
 @property {string} acquire_date_error
 @property {?string} bill_to
 @property {string} bill_to_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?string} buyer
 @property {string} buyer_error
 @property {?date|string} created
 @property {string} created_error
 @property {?date|string} disposed_date
 @property {string} disposed_date_error
 @property {?text|string} ffl_number
 @property {string} ffl_number_error
 @property {?text|string} ffl_status
 @property {string} ffl_status_error
 @property {?string} items
 @property {string} items_error
 @property {?date|string} order_date
 @property {string} order_date_error
 @property {?text|string} order_id
 @property {string} order_id_error
 @property {?boolean} order_sold
 @property {string} order_sold_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?string} seller
 @property {string} seller_error
 @property {?string} ship_to
 @property {string} ship_to_error
 @property {?text|string} status
 @property {string} status_error
 @property {?number|int|float} total_price
 @property {string} total_price_error
 @property {?number|int|float} total_tax
 @property {string} total_tax_error
 @property {?date|string} transfer_date
 @property {string} transfer_date_error
 */
/**
 @typedef {Object.<any>} Importers
 @property {Importers_Properties} properties
 @property {Importers_Has} has
 @property {Importers_Is} is
 @property {Importers_Object} object
 */
/**
 @typedef {Object.<any>} Importers_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} country_of_origin
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {email} email
 @property {text|string} ffl
 @property {date|string} ffl_expiration
 @property {text|string} full_address
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name
 @property {text|string} phone_number
 @property {number|int} pkey
 @property {text|string} aeca
 @property {date|string} aeca_expiration
 @property {text|string} ammunition_caliber
 @property {text|string} ammunition_manufacturer_address
 @property {text|string} ammunition_manufacturer_name
 @property {text|string} ammunition_munitions
 @property {text|string} ammunition_quantity
 @property {text|string} ammunition_unit
 @property {text|string} applicant
 @property {text|string} applicant_address
 @property {text|string} applicant_title
 @property {text|string} collection
 @property {text|string} collection_binary_id
 @property {text|string} customs_broker
 @property {text|string} customs_broker_address
 @property {date|string} date_in
 @property {text|string} defense_articles_caliber
 @property {text|string} defense_articles_manufacturer_address
 @property {text|string} defense_articles_manufacturer_name
 @property {text|string} defense_articles_munitions
 @property {text|string} defense_articles_quantity
 @property {text|string} defense_articles_unit
 @property {text|string} foreign_seller
 @property {text|string} foreign_seller_address
 @property {text|string} foreign_shipper
 @property {text|string} foreign_shipper_address
 @property {text|string} gross_shipment_value
 @property {text|string} permit_number
 @property {text|string} purpose_of_importation
 @property {boolean} registered_pursuant
 @property {text|string} registration_expiration
 @property {boolean} return_applicant
 @property {boolean} return_customs_broker
 @property {boolean} signature_of_applicant
 */
/**
 @typedef {Object.<any>} Importers_Has
 */
/**
 @typedef {Object.<any>} Importers_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Importers_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} country_of_origin
 @property {string} country_of_origin_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} ffl
 @property {string} ffl_error
 @property {?date|string} ffl_expiration
 @property {string} ffl_expiration_error
 @property {?text|string} full_address
 @property {string} full_address_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} phone_number
 @property {string} phone_number_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} aeca
 @property {string} aeca_error
 @property {?date|string} aeca_expiration
 @property {string} aeca_expiration_error
 @property {?text|string} ammunition_caliber
 @property {string} ammunition_caliber_error
 @property {?text|string} ammunition_manufacturer_address
 @property {string} ammunition_manufacturer_address_error
 @property {?text|string} ammunition_manufacturer_name
 @property {string} ammunition_manufacturer_name_error
 @property {?text|string} ammunition_munitions
 @property {string} ammunition_munitions_error
 @property {?text|string} ammunition_quantity
 @property {string} ammunition_quantity_error
 @property {?text|string} ammunition_unit
 @property {string} ammunition_unit_error
 @property {?text|string} applicant
 @property {string} applicant_error
 @property {?text|string} applicant_address
 @property {string} applicant_address_error
 @property {?text|string} applicant_title
 @property {string} applicant_title_error
 @property {?text|string} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?text|string} customs_broker
 @property {string} customs_broker_error
 @property {?text|string} customs_broker_address
 @property {string} customs_broker_address_error
 @property {?date|string} date_in
 @property {string} date_in_error
 @property {?text|string} defense_articles_caliber
 @property {string} defense_articles_caliber_error
 @property {?text|string} defense_articles_manufacturer_address
 @property {string} defense_articles_manufacturer_address_error
 @property {?text|string} defense_articles_manufacturer_name
 @property {string} defense_articles_manufacturer_name_error
 @property {?text|string} defense_articles_munitions
 @property {string} defense_articles_munitions_error
 @property {?text|string} defense_articles_quantity
 @property {string} defense_articles_quantity_error
 @property {?text|string} defense_articles_unit
 @property {string} defense_articles_unit_error
 @property {?text|string} foreign_seller
 @property {string} foreign_seller_error
 @property {?text|string} foreign_seller_address
 @property {string} foreign_seller_address_error
 @property {?text|string} foreign_shipper
 @property {string} foreign_shipper_error
 @property {?text|string} foreign_shipper_address
 @property {string} foreign_shipper_address_error
 @property {?text|string} gross_shipment_value
 @property {string} gross_shipment_value_error
 @property {?text|string} permit_number
 @property {string} permit_number_error
 @property {?text|string} purpose_of_importation
 @property {string} purpose_of_importation_error
 @property {?boolean} registered_pursuant
 @property {string} registered_pursuant_error
 @property {?text|string} registration_expiration
 @property {string} registration_expiration_error
 @property {?boolean} return_applicant
 @property {string} return_applicant_error
 @property {?boolean} return_customs_broker
 @property {string} return_customs_broker_error
 @property {?boolean} signature_of_applicant
 @property {string} signature_of_applicant_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Importers_Logs
 @property {Importers_Logs_Properties} properties
 @property {Importers_Logs_Has} has
 @property {Importers_Logs_Is} is
 @property {Importers_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Importers_Logs_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} date
 @property {text|string} display_new
 @property {text|string} display_old
 @property {text|string} field
 @property {number|int} importer
 @property {text|string} importer_binary_id
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} user_binary_id
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Importers_Logs_Has
 */
/**
 @typedef {Object.<any>} Importers_Logs_Is
 @property {Dealers_Object} dealers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Importers_Logs_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} display_new
 @property {string} display_new_error
 @property {?text|string} display_old
 @property {string} display_old_error
 @property {?text|string} field
 @property {string} field_error
 @property {?number|int} importer
 @property {string} importer_error
 @property {?text|string} importer_binary_id
 @property {string} importer_binary_id_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Dealers_Object} dealers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Imports
 @property {Imports_Properties} properties
 @property {Imports_Has} has
 @property {Imports_Is} is
 @property {Imports_Object} object
 */
/**
 @typedef {Object.<any>} Imports_Properties
 */
/**
 @typedef {Object.<any>} Imports_Has
 */
/**
 @typedef {Object.<any>} Imports_Is
 */
/**
 @typedef {Object.<any>} Imports_Object
 */
/**
 @typedef {Object.<any>} Inventories
 @property {Inventories_Properties} properties
 @property {Inventories_Has} has
 @property {Inventories_Is} is
 @property {Inventories_Object} object
 */
/**
 @typedef {Object.<any>} Inventories_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} end_date
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} notes
 @property {number|int} pkey
 @property {date|string} start_date
 @property {text|string} title
 */
/**
 @typedef {Object.<any>} Inventories_Has
 */
/**
 @typedef {Object.<any>} Inventories_Is
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Inventories_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} end_date
 @property {string} end_date_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?date|string} start_date
 @property {string} start_date_error
 @property {?text|string} title
 @property {string} title_error
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Inventories_Items
 @property {Inventories_Items_Properties} properties
 @property {Inventories_Items_Has} has
 @property {Inventories_Items_Is} is
 @property {Inventories_Items_Object} object
 */
/**
 @typedef {Object.<any>} Inventories_Items_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} inventory
 @property {text|string} inventory_binary_id
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} notes
 @property {number|int} pkey
 @property {number|int} product
 @property {text|string} product_binary_id
 @property {boolean} removed
 @property {number|int} scanned
 @property {number|int} status
 @property {text|string} title
 */
/**
 @typedef {Object.<any>} Inventories_Items_Has
 */
/**
 @typedef {Object.<any>} Inventories_Items_Is
 @property {Inventories_Object} inventories
 @property {Locations_Object} locations
 @property {Products_Statuses_Object} product_statuses
 @property {Products_Object} products
 */
/**
 @typedef {Object.<any>} Inventories_Items_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} inventory
 @property {string} inventory_error
 @property {?text|string} inventory_binary_id
 @property {string} inventory_binary_id_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} product_binary_id
 @property {string} product_binary_id_error
 @property {?boolean} removed
 @property {string} removed_error
 @property {?number|int} scanned
 @property {string} scanned_error
 @property {?number|int} status
 @property {string} status_error
 @property {?text|string} title
 @property {string} title_error
 @property {Inventories_Object} inventories
 @property {Locations_Object} locations
 @property {Products_Statuses_Object} product_statuses
 @property {Products_Object} products
 */
/**
 @typedef {Object.<any>} Ioi_Batches
 @property {Ioi_Batches_Properties} properties
 @property {Ioi_Batches_Has} has
 @property {Ioi_Batches_Is} is
 @property {Ioi_Batches_Object} object
 */
/**
 @typedef {Object.<any>} Ioi_Batches_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} customer_binary_id
 @property {date|string} date
 @property {email} email
 @property {text|string} hash
 @property {number|int} location
 @property {text|string} pin
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Ioi_Batches_Has
 */
/**
 @typedef {Object.<any>} Ioi_Batches_Is
 @property {Forms_Object} forms
 */
/**
 @typedef {Object.<any>} Ioi_Batches_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} hash
 @property {string} hash_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} pin
 @property {string} pin_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Forms_Object} forms
 */
/**
 @typedef {Object.<any>} Kiosks
 @property {Kiosks_Properties} properties
 @property {Kiosks_Has} has
 @property {Kiosks_Is} is
 @property {Kiosks_Object} object
 */
/**
 @typedef {Object.<any>} Kiosks_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Kiosks_Has
 */
/**
 @typedef {Object.<any>} Kiosks_Is
 @property {Locations_Object} locations
 */
/**
 @typedef {Object.<any>} Kiosks_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Locations_Object} locations
 */
/**
 @typedef {Object.<any>} Leep_User_Answers
 @property {Leep_User_Answers_Properties} properties
 @property {Leep_User_Answers_Has} has
 @property {Leep_User_Answers_Is} is
 @property {Leep_User_Answers_Object} object
 */
/**
 @typedef {Object.<any>} Leep_User_Answers_Properties
 @property {text|string} _id
 @property {number|int} account
 @property {text|string} binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {text|string} leep_answer_1
 @property {text|string} leep_answer_10
 @property {text|string} leep_answer_2
 @property {text|string} leep_answer_3
 @property {text|string} leep_answer_4
 @property {text|string} leep_answer_5
 @property {text|string} leep_answer_6
 @property {text|string} leep_answer_7
 @property {text|string} leep_answer_8
 @property {text|string} leep_answer_9
 @property {number|int} leep_question_1
 @property {number|int} leep_question_10
 @property {number|int} leep_question_2
 @property {number|int} leep_question_3
 @property {number|int} leep_question_4
 @property {number|int} leep_question_5
 @property {number|int} leep_question_6
 @property {number|int} leep_question_7
 @property {number|int} leep_question_8
 @property {number|int} leep_question_9
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {number|int} pkey
 @property {text|string} user_binary_id
 */
/**
 @typedef {Object.<any>} Leep_User_Answers_Has
 */
/**
 @typedef {Object.<any>} Leep_User_Answers_Is
 @property {Accounts_Object} accounts
 @property {Leep_Questions_Object} leep_questions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Leep_User_Answers_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?text|string} leep_answer_1
 @property {string} leep_answer_1_error
 @property {?text|string} leep_answer_10
 @property {string} leep_answer_10_error
 @property {?text|string} leep_answer_2
 @property {string} leep_answer_2_error
 @property {?text|string} leep_answer_3
 @property {string} leep_answer_3_error
 @property {?text|string} leep_answer_4
 @property {string} leep_answer_4_error
 @property {?text|string} leep_answer_5
 @property {string} leep_answer_5_error
 @property {?text|string} leep_answer_6
 @property {string} leep_answer_6_error
 @property {?text|string} leep_answer_7
 @property {string} leep_answer_7_error
 @property {?text|string} leep_answer_8
 @property {string} leep_answer_8_error
 @property {?text|string} leep_answer_9
 @property {string} leep_answer_9_error
 @property {?number|int} leep_question_1
 @property {string} leep_question_1_error
 @property {?number|int} leep_question_10
 @property {string} leep_question_10_error
 @property {?number|int} leep_question_2
 @property {string} leep_question_2_error
 @property {?number|int} leep_question_3
 @property {string} leep_question_3_error
 @property {?number|int} leep_question_4
 @property {string} leep_question_4_error
 @property {?number|int} leep_question_5
 @property {string} leep_question_5_error
 @property {?number|int} leep_question_6
 @property {string} leep_question_6_error
 @property {?number|int} leep_question_7
 @property {string} leep_question_7_error
 @property {?number|int} leep_question_8
 @property {string} leep_question_8_error
 @property {?number|int} leep_question_9
 @property {string} leep_question_9_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {Accounts_Object} accounts
 @property {Leep_Questions_Object} leep_questions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Leep_User_Logs
 @property {Leep_User_Logs_Properties} properties
 @property {Leep_User_Logs_Has} has
 @property {Leep_User_Logs_Is} is
 @property {Leep_User_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Leep_User_Logs_Properties
 @property {number|int} $user
 @property {text|string} _id
 @property {number|int} account
 @property {text|string} alien_number
 @property {text|string} binary_id
 @property {text|string} birth_city
 @property {text|string} birth_country
 @property {date|string} birth_date
 @property {text|string} birth_state
 @property {text|string} citizenship_status
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {text|string} ethnicity
 @property {boolean} ethnicity_hispanic
 @property {text|string} foreign_citizenship
 @property {text|string} gender
 @property {text|string} height
 @property {text|string} identification_authority
 @property {text|string} identification_number
 @property {text|string} identification_type
 @property {boolean} is_checked1
 @property {boolean} is_checked2
 @property {boolean} is_checked3
 @property {boolean} is_checked7
 @property {boolean} is_checked8
 @property {boolean} is_checked9
 @property {text|string} leep_password
 @property {text|string} leep_username
 @property {text|string} message_logs
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_middle
 @property {text|string} name_suffix
 @property {text|string} nonimmigrant_visa
 @property {text|string} pending_hash
 @property {number|int} pkey
 @property {text|string} race
 @property {boolean} race_african_american
 @property {boolean} race_american_indian
 @property {boolean} race_asian
 @property {boolean} race_native_hawaiian
 @property {boolean} race_white
 @property {text|string} security_question_1
 @property {text|string} security_question_2
 @property {text|string} security_question_3
 @property {text|string} security_question_4
 @property {text|string} security_question_5
 @property {text|string} ssn
 @property {text|string} state_of_residence
 @property {text|string} transaction_flag
 @property {text|string} transaction_purposes
 @property {text|string} upin
 @property {boolean} us_born
 @property {boolean} us_citizen
 @property {text|string} user_binary_id
 @property {number|int} weight
 */
/**
 @typedef {Object.<any>} Leep_User_Logs_Has
 */
/**
 @typedef {Object.<any>} Leep_User_Logs_Is
 @property {Accounts_Object} accounts
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Leep_User_Logs_Object
 @property {?number|int} $user
 @property {string} $user_error
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} alien_number
 @property {string} alien_number_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} birth_city
 @property {string} birth_city_error
 @property {?text|string} birth_country
 @property {string} birth_country_error
 @property {?date|string} birth_date
 @property {string} birth_date_error
 @property {?text|string} birth_state
 @property {string} birth_state_error
 @property {?text|string} citizenship_status
 @property {string} citizenship_status_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?text|string} ethnicity
 @property {string} ethnicity_error
 @property {?boolean} ethnicity_hispanic
 @property {string} ethnicity_hispanic_error
 @property {?text|string} foreign_citizenship
 @property {string} foreign_citizenship_error
 @property {?text|string} gender
 @property {string} gender_error
 @property {?text|string} height
 @property {string} height_error
 @property {?text|string} identification_authority
 @property {string} identification_authority_error
 @property {?text|string} identification_number
 @property {string} identification_number_error
 @property {?text|string} identification_type
 @property {string} identification_type_error
 @property {?boolean} is_checked1
 @property {string} is_checked1_error
 @property {?boolean} is_checked2
 @property {string} is_checked2_error
 @property {?boolean} is_checked3
 @property {string} is_checked3_error
 @property {?boolean} is_checked7
 @property {string} is_checked7_error
 @property {?boolean} is_checked8
 @property {string} is_checked8_error
 @property {?boolean} is_checked9
 @property {string} is_checked9_error
 @property {?text|string} leep_password
 @property {string} leep_password_error
 @property {?text|string} leep_username
 @property {string} leep_username_error
 @property {?text|string} message_logs
 @property {string} message_logs_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_middle
 @property {string} name_middle_error
 @property {?text|string} name_suffix
 @property {string} name_suffix_error
 @property {?text|string} nonimmigrant_visa
 @property {string} nonimmigrant_visa_error
 @property {?text|string} pending_hash
 @property {string} pending_hash_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} race
 @property {string} race_error
 @property {?boolean} race_african_american
 @property {string} race_african_american_error
 @property {?boolean} race_american_indian
 @property {string} race_american_indian_error
 @property {?boolean} race_asian
 @property {string} race_asian_error
 @property {?boolean} race_native_hawaiian
 @property {string} race_native_hawaiian_error
 @property {?boolean} race_white
 @property {string} race_white_error
 @property {?text|string} security_question_1
 @property {string} security_question_1_error
 @property {?text|string} security_question_2
 @property {string} security_question_2_error
 @property {?text|string} security_question_3
 @property {string} security_question_3_error
 @property {?text|string} security_question_4
 @property {string} security_question_4_error
 @property {?text|string} security_question_5
 @property {string} security_question_5_error
 @property {?text|string} ssn
 @property {string} ssn_error
 @property {?text|string} state_of_residence
 @property {string} state_of_residence_error
 @property {?text|string} transaction_flag
 @property {string} transaction_flag_error
 @property {?text|string} transaction_purposes
 @property {string} transaction_purposes_error
 @property {?text|string} upin
 @property {string} upin_error
 @property {?boolean} us_born
 @property {string} us_born_error
 @property {?boolean} us_citizen
 @property {string} us_citizen_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?number|int} weight
 @property {string} weight_error
 @property {Accounts_Object} accounts
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Legal_Entities
 @property {Legal_Entities_Properties} properties
 @property {Legal_Entities_Has} has
 @property {Legal_Entities_Is} is
 @property {Legal_Entities_Object} object
 */
/**
 @typedef {Object.<any>} Legal_Entities_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} county
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {email} email
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name
 @property {tel|string} number
 @property {number|int} pkey
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {boolean} trust
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Legal_Entities_Has
 @property {Customers_Object[]} customers
 */
/**
 @typedef {Object.<any>} Legal_Entities_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Legal_Entities_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} county
 @property {string} county_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?email} email
 @property {string} email_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?tel|string} number
 @property {string} number_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?boolean} trust
 @property {string} trust_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Customers_Object[]} customers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Legal_Entities_Logs
 @property {Legal_Entities_Logs_Properties} properties
 @property {Legal_Entities_Logs_Has} has
 @property {Legal_Entities_Logs_Is} is
 @property {Legal_Entities_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Legal_Entities_Logs_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} date
 @property {text|string} field
 @property {number|int} legal_entity
 @property {text|string} legal_entity_binary_id
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} user_binary_id
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Legal_Entities_Logs_Has
 */
/**
 @typedef {Object.<any>} Legal_Entities_Logs_Is
 @property {Legal_Entities_Object} legal_entities
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Legal_Entities_Logs_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} field
 @property {string} field_error
 @property {?number|int} legal_entity
 @property {string} legal_entity_error
 @property {?text|string} legal_entity_binary_id
 @property {string} legal_entity_binary_id_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Legal_Entities_Object} legal_entities
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Legal_Entities_Trustees
 @property {Legal_Entities_Trustees_Properties} properties
 @property {Legal_Entities_Trustees_Has} has
 @property {Legal_Entities_Trustees_Is} is
 @property {Legal_Entities_Trustees_Object} object
 */
/**
 @typedef {Object.<any>} Legal_Entities_Trustees_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Legal_Entities_Trustees_Has
 */
/**
 @typedef {Object.<any>} Legal_Entities_Trustees_Is
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Legal_Entities_Trustees_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Location_Banners
 @property {Location_Banners_Properties} properties
 @property {Location_Banners_Has} has
 @property {Location_Banners_Is} is
 @property {Location_Banners_Object} object
 */
/**
 @typedef {Object.<any>} Location_Banners_Properties
 @property {text|string} _id
 @property {number|int} account
 @property {text|string} binary_id
 @property {date|string} created
 @property {boolean} dismiss
 @property {text|string} expiration_message
 @property {boolean} is_active
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {boolean} marketing
 @property {text|string} marketing_background_color
 @property {text|string} marketing_cta_text
 @property {text|string} marketing_cta_url
 @property {text|string} marketing_description
 @property {date|string} marketing_end_date
 @property {text|string} marketing_foreground_color
 @property {date|string} marketing_start_date
 @property {text|string} marketing_subtitle
 @property {number|int} marketing_title
 @property {boolean} persist
 @property {number|int} pkey
 @property {number|int} set_number
 @property {number|int} user_access
 */
/**
 @typedef {Object.<any>} Location_Banners_Has
 */
/**
 @typedef {Object.<any>} Location_Banners_Is
 @property {Accounts_Object} accounts
 @property {Location_Banners_Object} location_banners
 @property {Master_Banners_Object} master_banners
 @property {Users_Accesses_Object} user_accesses
 */
/**
 @typedef {Object.<any>} Location_Banners_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?boolean} dismiss
 @property {string} dismiss_error
 @property {?text|string} expiration_message
 @property {string} expiration_message_error
 @property {?boolean} is_active
 @property {string} is_active_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?boolean} marketing
 @property {string} marketing_error
 @property {?text|string} marketing_background_color
 @property {string} marketing_background_color_error
 @property {?text|string} marketing_cta_text
 @property {string} marketing_cta_text_error
 @property {?text|string} marketing_cta_url
 @property {string} marketing_cta_url_error
 @property {?text|string} marketing_description
 @property {string} marketing_description_error
 @property {?date|string} marketing_end_date
 @property {string} marketing_end_date_error
 @property {?text|string} marketing_foreground_color
 @property {string} marketing_foreground_color_error
 @property {?date|string} marketing_start_date
 @property {string} marketing_start_date_error
 @property {?text|string} marketing_subtitle
 @property {string} marketing_subtitle_error
 @property {?number|int} marketing_title
 @property {string} marketing_title_error
 @property {?boolean} persist
 @property {string} persist_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} set_number
 @property {string} set_number_error
 @property {?number|int} user_access
 @property {string} user_access_error
 @property {Accounts_Object} accounts
 @property {Location_Banners_Object} location_banners
 @property {Master_Banners_Object} master_banners
 @property {Users_Accesses_Object} user_accesses
 */
/**
 @typedef {Object.<any>} Locations
 @property {Locations_Properties} properties
 @property {Locations_Has} has
 @property {Locations_Is} is
 @property {Locations_Object} object
 */
/**
 @typedef {Object.<any>} Locations_Properties
 @property {text|string} _id
 @property {text|string} archive_signature
 @property {date|string} archive_signature_date
 @property {boolean} archived
 @property {text|string} binary_id
 @property {text|string} bound_book
 @property {boolean} bound_book_07
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} cleo_address
 @property {text|string} cleo_agency
 @property {boolean} cleo_auto_send
 @property {text|string} cleo_email
 @property {text|string} cleo_name
 @property {text|string} county
 @property {date|string} created
 @property {number|int} data_usage
 @property {text|string} data_usage_limit
 @property {text|string} days_open
 @property {text|string} ein
 @property {text|string} email
 @property {text|string} fax
 @property {text|string} ffl
 @property {number|int} ffl_class
 @property {string} ffl_license
 @property {number|int} ffl_type
 @property {number|int} gb_count_1
 @property {number|int} gb_count_5
 @property {boolean} has_ammoready_module
 @property {boolean} has_bound_book_07_module
 @property {boolean} has_gunbroker_module
 @property {boolean} has_manufacturing_module
 @property {boolean} has_michigan_module
 @property {boolean} has_ny_module
 @property {boolean} has_trialed
 @property {text|string} ip_address
 @property {number|int} mb_count_100
 @property {boolean} multisale_rifles_opt_out
 @property {text|string} name
 @property {text|string} name_display
 @property {boolean} on_cloud
 @property {boolean} pdf_save_server
 @property {text|string} phone
 @property {number|int} pkey
 @property {number|int} previous_day_data_usage
 @property {text|string} product_prefix
 @property {date|string} renews
 @property {number|int} sent
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} subscription
 @property {text|string} subscription_old
 @property {date|string} trialing
 @property {number|int} type
 @property {text|string} zip
 @property {number|int} additional_data
 @property {string} previewHtml
 @property {boolean} resubscribe
 @property {text|string} send_email_to
 @property {text|string} send_message
 @property {text|string} serial_trace
 @property {number|int} subscriptions_special
 */
/**
 @typedef {Object.<any>} Locations_Has
 @property {Locations_Bound_Books_Object[]} location_bound_bookss
 @property {Locations_Modules_Object[]} location_moduless
 */
/**
 @typedef {Object.<any>} Locations_Is
 @property {Ffls_Classes_Object} ffl_classes
 @property {Ffls_Types_Object} ffl_types
 @property {Subscriptions_Object} subscriptions
 @property {Subscriptions_Special_Object} subscriptions_special
 */
/**
 @typedef {Object.<any>} Locations_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} archive_signature
 @property {string} archive_signature_error
 @property {?date|string} archive_signature_date
 @property {string} archive_signature_date_error
 @property {?boolean} archived
 @property {string} archived_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} bound_book
 @property {string} bound_book_error
 @property {?boolean} bound_book_07
 @property {string} bound_book_07_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} cleo_address
 @property {string} cleo_address_error
 @property {?text|string} cleo_agency
 @property {string} cleo_agency_error
 @property {?boolean} cleo_auto_send
 @property {string} cleo_auto_send_error
 @property {?text|string} cleo_email
 @property {string} cleo_email_error
 @property {?text|string} cleo_name
 @property {string} cleo_name_error
 @property {?text|string} county
 @property {string} county_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} data_usage
 @property {string} data_usage_error
 @property {?text|string} data_usage_limit
 @property {string} data_usage_limit_error
 @property {?text|string} days_open
 @property {string} days_open_error
 @property {?text|string} ein
 @property {string} ein_error
 @property {?text|string} email
 @property {string} email_error
 @property {?text|string} fax
 @property {string} fax_error
 @property {?text|string} ffl
 @property {string} ffl_error
 @property {?number|int} ffl_class
 @property {string} ffl_class_error
 @property {?string} ffl_license
 @property {string} ffl_license_error
 @property {?number|int} ffl_type
 @property {string} ffl_type_error
 @property {?number|int} gb_count_1
 @property {string} gb_count_1_error
 @property {?number|int} gb_count_5
 @property {string} gb_count_5_error
 @property {?boolean} has_ammoready_module
 @property {string} has_ammoready_module_error
 @property {?boolean} has_bound_book_07_module
 @property {string} has_bound_book_07_module_error
 @property {?boolean} has_gunbroker_module
 @property {string} has_gunbroker_module_error
 @property {?boolean} has_manufacturing_module
 @property {string} has_manufacturing_module_error
 @property {?boolean} has_michigan_module
 @property {string} has_michigan_module_error
 @property {?boolean} has_ny_module
 @property {string} has_ny_module_error
 @property {?boolean} has_trialed
 @property {string} has_trialed_error
 @property {?text|string} ip_address
 @property {string} ip_address_error
 @property {?number|int} mb_count_100
 @property {string} mb_count_100_error
 @property {?boolean} multisale_rifles_opt_out
 @property {string} multisale_rifles_opt_out_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} name_display
 @property {string} name_display_error
 @property {?boolean} on_cloud
 @property {string} on_cloud_error
 @property {?boolean} pdf_save_server
 @property {string} pdf_save_server_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} previous_day_data_usage
 @property {string} previous_day_data_usage_error
 @property {?text|string} product_prefix
 @property {string} product_prefix_error
 @property {?date|string} renews
 @property {string} renews_error
 @property {?number|int} sent
 @property {string} sent_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} subscription
 @property {string} subscription_error
 @property {?text|string} subscription_old
 @property {string} subscription_old_error
 @property {?date|string} trialing
 @property {string} trialing_error
 @property {?number|int} type
 @property {string} type_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?number|int} additional_data
 @property {string} additional_data_error
 @property {?string} previewHtml
 @property {string} previewHtml_error
 @property {?boolean} resubscribe
 @property {string} resubscribe_error
 @property {?text|string} send_email_to
 @property {string} send_email_to_error
 @property {?text|string} send_message
 @property {string} send_message_error
 @property {?text|string} serial_trace
 @property {string} serial_trace_error
 @property {?number|int} subscriptions_special
 @property {string} subscriptions_special_error
 @property {Locations_Bound_Books_Object[]} location_bound_bookss
 @property {Locations_Modules_Object[]} location_moduless
 @property {Ffls_Classes_Object} ffl_classes
 @property {Ffls_Types_Object} ffl_types
 @property {Subscriptions_Object} subscriptions
 @property {Subscriptions_Special_Object} subscriptions_special
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books
 @property {Locations_Bound_Books_Properties} properties
 @property {Locations_Bound_Books_Has} has
 @property {Locations_Bound_Books_Is} is
 @property {Locations_Bound_Books_Object} object
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} product_prefix
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Has
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Is
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} product_prefix
 @property {string} product_prefix_error
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Flags
 @property {Locations_Bound_Books_Flags_Properties} properties
 @property {Locations_Bound_Books_Flags_Has} has
 @property {Locations_Bound_Books_Flags_Is} is
 @property {Locations_Bound_Books_Flags_Object} object
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Flags_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {number|int} caliber
 @property {text|string} caliber_other
 @property {date|string} date
 @property {text|string} gun_type
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {number|int} manufacturer
 @property {text|string} manufacturer_other
 @property {text|string} model
 @property {text|string} note
 @property {number|int} pkey
 @property {text|string} serial_number
 @property {text|string} status
 @property {number|int} transaction_entry
 @property {text|string} transaction_entry_binary_id
 @property {text|string} upc
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Flags_Has
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Flags_Is
 @property {Calibers_Object} calibers
 @property {Forms_Object} forms
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Manufacturers_Object} manufacturers
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Flags_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?number|int} caliber
 @property {string} caliber_error
 @property {?text|string} caliber_other
 @property {string} caliber_other_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} gun_type
 @property {string} gun_type_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?number|int} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} manufacturer_other
 @property {string} manufacturer_other_error
 @property {?text|string} model
 @property {string} model_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} status
 @property {string} status_error
 @property {?number|int} transaction_entry
 @property {string} transaction_entry_error
 @property {?text|string} transaction_entry_binary_id
 @property {string} transaction_entry_binary_id_error
 @property {?text|string} upc
 @property {string} upc_error
 @property {Calibers_Object} calibers
 @property {Forms_Object} forms
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Manufacturers_Object} manufacturers
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Queues
 @property {Locations_Bound_Books_Queues_Properties} properties
 @property {Locations_Bound_Books_Queues_Has} has
 @property {Locations_Bound_Books_Queues_Is} is
 @property {Locations_Bound_Books_Queues_Object} object
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Queues_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {boolean} completed
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} date_end
 @property {date|string} date_start
 @property {boolean} downloaded
 @property {text|string} entries
 @property {boolean} failed
 @property {text|string} file
 @property {date|string} finished
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {number|int} pkey
 @property {boolean} processing
 @property {text|string} search
 @property {text|string} search_field
 @property {text|string} sort
 @property {text|string} sort_order
 @property {date|string} started
 @property {boolean} zip_file
 @property {text|string} days_to_delete
 @property {text|string} serial_trace
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Queues_Has
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Queues_Is
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Locations_Bound_Books_Queues_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?boolean} completed
 @property {string} completed_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} date_end
 @property {string} date_end_error
 @property {?date|string} date_start
 @property {string} date_start_error
 @property {?boolean} downloaded
 @property {string} downloaded_error
 @property {?text|string} entries
 @property {string} entries_error
 @property {?boolean} failed
 @property {string} failed_error
 @property {?text|string} file
 @property {string} file_error
 @property {?date|string} finished
 @property {string} finished_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} processing
 @property {string} processing_error
 @property {?text|string} search
 @property {string} search_error
 @property {?text|string} search_field
 @property {string} search_field_error
 @property {?text|string} sort
 @property {string} sort_error
 @property {?text|string} sort_order
 @property {string} sort_order_error
 @property {?date|string} started
 @property {string} started_error
 @property {?boolean} zip_file
 @property {string} zip_file_error
 @property {?text|string} days_to_delete
 @property {string} days_to_delete_error
 @property {?text|string} serial_trace
 @property {string} serial_trace_error
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Locations_Images
 @property {Locations_Images_Properties} properties
 @property {Locations_Images_Has} has
 @property {Locations_Images_Is} is
 @property {Locations_Images_Object} object
 */
/**
 @typedef {Object.<any>} Locations_Images_Properties
 @property {text|string} _id
 @property {text|string} archive_signature
 @property {date|string} archive_signature_date
 @property {boolean} archived
 @property {text|string} binary_id
 @property {text|string} bound_book
 @property {boolean} bound_book_07
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} cleo_address
 @property {text|string} cleo_agency
 @property {boolean} cleo_auto_send
 @property {text|string} cleo_email
 @property {text|string} cleo_name
 @property {text|string} county
 @property {date|string} created
 @property {number|int} data_usage
 @property {text|string} data_usage_limit
 @property {text|string} days_open
 @property {text|string} ein
 @property {text|string} email
 @property {text|string} fax
 @property {text|string} ffl
 @property {number|int} ffl_class
 @property {string} ffl_license
 @property {number|int} ffl_type
 @property {number|int} gb_count_1
 @property {number|int} gb_count_5
 @property {boolean} has_ammoready_module
 @property {boolean} has_bound_book_07_module
 @property {boolean} has_gunbroker_module
 @property {boolean} has_manufacturing_module
 @property {boolean} has_michigan_module
 @property {boolean} has_ny_module
 @property {boolean} has_trialed
 @property {text|string} ip_address
 @property {number|int} mb_count_100
 @property {boolean} multisale_rifles_opt_out
 @property {text|string} name
 @property {text|string} name_display
 @property {boolean} on_cloud
 @property {boolean} pdf_save_server
 @property {text|string} phone
 @property {number|int} pkey
 @property {number|int} previous_day_data_usage
 @property {text|string} product_prefix
 @property {date|string} renews
 @property {number|int} sent
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} subscription
 @property {text|string} subscription_old
 @property {date|string} trialing
 @property {number|int} type
 @property {text|string} zip
 @property {number|int} additional_data
 @property {string} previewHtml
 @property {boolean} resubscribe
 @property {text|string} send_email_to
 @property {text|string} send_message
 @property {text|string} serial_trace
 @property {number|int} subscriptions_special
 */
/**
 @typedef {Object.<any>} Locations_Images_Has
 @property {Locations_Bound_Books_Object[]} location_bound_bookss
 @property {Locations_Modules_Object[]} location_moduless
 */
/**
 @typedef {Object.<any>} Locations_Images_Is
 @property {Ffls_Classes_Object} ffl_classes
 @property {Ffls_Types_Object} ffl_types
 @property {Subscriptions_Object} subscriptions
 @property {Subscriptions_Special_Object} subscriptions_special
 */
/**
 @typedef {Object.<any>} Locations_Images_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} archive_signature
 @property {string} archive_signature_error
 @property {?date|string} archive_signature_date
 @property {string} archive_signature_date_error
 @property {?boolean} archived
 @property {string} archived_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} bound_book
 @property {string} bound_book_error
 @property {?boolean} bound_book_07
 @property {string} bound_book_07_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} cleo_address
 @property {string} cleo_address_error
 @property {?text|string} cleo_agency
 @property {string} cleo_agency_error
 @property {?boolean} cleo_auto_send
 @property {string} cleo_auto_send_error
 @property {?text|string} cleo_email
 @property {string} cleo_email_error
 @property {?text|string} cleo_name
 @property {string} cleo_name_error
 @property {?text|string} county
 @property {string} county_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} data_usage
 @property {string} data_usage_error
 @property {?text|string} data_usage_limit
 @property {string} data_usage_limit_error
 @property {?text|string} days_open
 @property {string} days_open_error
 @property {?text|string} ein
 @property {string} ein_error
 @property {?text|string} email
 @property {string} email_error
 @property {?text|string} fax
 @property {string} fax_error
 @property {?text|string} ffl
 @property {string} ffl_error
 @property {?number|int} ffl_class
 @property {string} ffl_class_error
 @property {?string} ffl_license
 @property {string} ffl_license_error
 @property {?number|int} ffl_type
 @property {string} ffl_type_error
 @property {?number|int} gb_count_1
 @property {string} gb_count_1_error
 @property {?number|int} gb_count_5
 @property {string} gb_count_5_error
 @property {?boolean} has_ammoready_module
 @property {string} has_ammoready_module_error
 @property {?boolean} has_bound_book_07_module
 @property {string} has_bound_book_07_module_error
 @property {?boolean} has_gunbroker_module
 @property {string} has_gunbroker_module_error
 @property {?boolean} has_manufacturing_module
 @property {string} has_manufacturing_module_error
 @property {?boolean} has_michigan_module
 @property {string} has_michigan_module_error
 @property {?boolean} has_ny_module
 @property {string} has_ny_module_error
 @property {?boolean} has_trialed
 @property {string} has_trialed_error
 @property {?text|string} ip_address
 @property {string} ip_address_error
 @property {?number|int} mb_count_100
 @property {string} mb_count_100_error
 @property {?boolean} multisale_rifles_opt_out
 @property {string} multisale_rifles_opt_out_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} name_display
 @property {string} name_display_error
 @property {?boolean} on_cloud
 @property {string} on_cloud_error
 @property {?boolean} pdf_save_server
 @property {string} pdf_save_server_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} previous_day_data_usage
 @property {string} previous_day_data_usage_error
 @property {?text|string} product_prefix
 @property {string} product_prefix_error
 @property {?date|string} renews
 @property {string} renews_error
 @property {?number|int} sent
 @property {string} sent_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} subscription
 @property {string} subscription_error
 @property {?text|string} subscription_old
 @property {string} subscription_old_error
 @property {?date|string} trialing
 @property {string} trialing_error
 @property {?number|int} type
 @property {string} type_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?number|int} additional_data
 @property {string} additional_data_error
 @property {?string} previewHtml
 @property {string} previewHtml_error
 @property {?boolean} resubscribe
 @property {string} resubscribe_error
 @property {?text|string} send_email_to
 @property {string} send_email_to_error
 @property {?text|string} send_message
 @property {string} send_message_error
 @property {?text|string} serial_trace
 @property {string} serial_trace_error
 @property {?number|int} subscriptions_special
 @property {string} subscriptions_special_error
 @property {Locations_Bound_Books_Object[]} location_bound_bookss
 @property {Locations_Modules_Object[]} location_moduless
 @property {Ffls_Classes_Object} ffl_classes
 @property {Ffls_Types_Object} ffl_types
 @property {Subscriptions_Object} subscriptions
 @property {Subscriptions_Special_Object} subscriptions_special
 */
/**
 @typedef {Object.<any>} Locations_Logs
 @property {Locations_Logs_Properties} properties
 @property {Locations_Logs_Has} has
 @property {Locations_Logs_Is} is
 @property {Locations_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Locations_Logs_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} date
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} user_binary_id
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Locations_Logs_Has
 */
/**
 @typedef {Object.<any>} Locations_Logs_Is
 @property {Locations_Object} locations
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Locations_Logs_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Locations_Object} locations
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Locations_Modules
 @property {Locations_Modules_Properties} properties
 @property {Locations_Modules_Has} has
 @property {Locations_Modules_Is} is
 @property {Locations_Modules_Object} object
 */
/**
 @typedef {Object.<any>} Locations_Modules_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {number|int} module
 @property {number|int} pkey
 @property {text|string} subscription
 @property {string} csv_import
 @property {boolean} subscribed
 */
/**
 @typedef {Object.<any>} Locations_Modules_Has
 */
/**
 @typedef {Object.<any>} Locations_Modules_Is
 @property {Locations_Object} locations
 @property {Modules_Object} modules
 */
/**
 @typedef {Object.<any>} Locations_Modules_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?number|int} module
 @property {string} module_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} subscription
 @property {string} subscription_error
 @property {?string} csv_import
 @property {string} csv_import_error
 @property {?boolean} subscribed
 @property {string} subscribed_error
 @property {Locations_Object} locations
 @property {Modules_Object} modules
 */
/**
 @typedef {Object.<any>} Locations_Queues
 @property {Locations_Queues_Properties} properties
 @property {Locations_Queues_Has} has
 @property {Locations_Queues_Is} is
 @property {Locations_Queues_Object} object
 */
/**
 @typedef {Object.<any>} Locations_Queues_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {boolean} completed
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} date_end
 @property {date|string} date_start
 @property {boolean} downloaded
 @property {text|string} entries
 @property {boolean} failed
 @property {text|string} file
 @property {date|string} finished
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {number|int} pkey
 @property {boolean} processing
 @property {text|string} search
 @property {text|string} search_field
 @property {text|string} sort
 @property {text|string} sort_order
 @property {date|string} started
 @property {boolean} zip_file
 @property {text|string} days_to_delete
 @property {text|string} serial_trace
 */
/**
 @typedef {Object.<any>} Locations_Queues_Has
 */
/**
 @typedef {Object.<any>} Locations_Queues_Is
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Locations_Queues_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?boolean} completed
 @property {string} completed_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} date_end
 @property {string} date_end_error
 @property {?date|string} date_start
 @property {string} date_start_error
 @property {?boolean} downloaded
 @property {string} downloaded_error
 @property {?text|string} entries
 @property {string} entries_error
 @property {?boolean} failed
 @property {string} failed_error
 @property {?text|string} file
 @property {string} file_error
 @property {?date|string} finished
 @property {string} finished_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} processing
 @property {string} processing_error
 @property {?text|string} search
 @property {string} search_error
 @property {?text|string} search_field
 @property {string} search_field_error
 @property {?text|string} sort
 @property {string} sort_error
 @property {?text|string} sort_order
 @property {string} sort_order_error
 @property {?date|string} started
 @property {string} started_error
 @property {?boolean} zip_file
 @property {string} zip_file_error
 @property {?text|string} days_to_delete
 @property {string} days_to_delete_error
 @property {?text|string} serial_trace
 @property {string} serial_trace_error
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Manufactureds
 @property {Manufactureds_Properties} properties
 @property {Manufactureds_Has} has
 @property {Manufactureds_Is} is
 @property {Manufactureds_Object} object
 */
/**
 @typedef {Object.<any>} Manufactureds_Properties
 @property {text|string} _id
 @property {date|string} acquisition_date
 @property {boolean} available
 @property {text|string} barrel_length
 @property {text|string} binary_id
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {number|int} caliber
 @property {text|string} caliber_other
 @property {text|string} change_note
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} disposition_date
 @property {text|string} id
 @property {boolean} imported
 @property {text|string} importer
 @property {text|string} inv
 @property {text|string} item_description
 @property {number|int} label
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {boolean} manufactured
 @property {number|int} manufacturer
 @property {text|string} manufacturer_other
 @property {text|string} model
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} overall_length
 @property {number|int} pkey
 @property {number|int|float} price_list
 @property {number|int|float} price_min
 @property {number|int|float} price_sale
 @property {boolean} semi_auto_w_detach
 @property {text|string} serial_number
 @property {text|string} sku
 @property {number|int} status
 @property {text|string} tag_note
 @property {number|int} taxable
 @property {text|string} type
 @property {number|int} type_previous
 @property {boolean} used_firearm
 @property {date|string} date
 @property {array} products
 @property {array} transaction_entriess
 */
/**
 @typedef {Object.<any>} Manufactureds_Has
 */
/**
 @typedef {Object.<any>} Manufactureds_Is
 @property {Calibers_Object} calibers
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Products_Statuses_Object} product_statuses
 @property {Products_Types_Object} product_types
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Manufactureds_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?date|string} acquisition_date
 @property {string} acquisition_date_error
 @property {?boolean} available
 @property {string} available_error
 @property {?text|string} barrel_length
 @property {string} barrel_length_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?number|int} caliber
 @property {string} caliber_error
 @property {?text|string} caliber_other
 @property {string} caliber_other_error
 @property {?text|string} change_note
 @property {string} change_note_error
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} disposition_date
 @property {string} disposition_date_error
 @property {?text|string} id
 @property {string} id_error
 @property {?boolean} imported
 @property {string} imported_error
 @property {?text|string} importer
 @property {string} importer_error
 @property {?text|string} inv
 @property {string} inv_error
 @property {?text|string} item_description
 @property {string} item_description_error
 @property {?number|int} label
 @property {string} label_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?boolean} manufactured
 @property {string} manufactured_error
 @property {?number|int} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} manufacturer_other
 @property {string} manufacturer_other_error
 @property {?text|string} model
 @property {string} model_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} overall_length
 @property {string} overall_length_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price_list
 @property {string} price_list_error
 @property {?number|int|float} price_min
 @property {string} price_min_error
 @property {?number|int|float} price_sale
 @property {string} price_sale_error
 @property {?boolean} semi_auto_w_detach
 @property {string} semi_auto_w_detach_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?number|int} status
 @property {string} status_error
 @property {?text|string} tag_note
 @property {string} tag_note_error
 @property {?number|int} taxable
 @property {string} taxable_error
 @property {?text|string} type
 @property {string} type_error
 @property {?number|int} type_previous
 @property {string} type_previous_error
 @property {?boolean} used_firearm
 @property {string} used_firearm_error
 @property {?date|string} date
 @property {string} date_error
 @property {?array} products
 @property {string} products_error
 @property {?array} transaction_entriess
 @property {string} transaction_entriess_error
 @property {Calibers_Object} calibers
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Products_Statuses_Object} product_statuses
 @property {Products_Types_Object} product_types
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Manufactureds_Forms
 @property {Manufactureds_Forms_Properties} properties
 @property {Manufactureds_Forms_Has} has
 @property {Manufactureds_Forms_Is} is
 @property {Manufactureds_Forms_Object} object
 */
/**
 @typedef {Object.<any>} Manufactureds_Forms_Properties
 @property {text|string} _id
 @property {string} amended
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {number|int} disposition_pending
 @property {text|string} disposition_pending_binary_id
 @property {text|string} filename
 @property {number|int} form
 @property {number|int} form_p12
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} payment
 @property {number|int} pkey
 @property {number|int} product
 @property {text|string} product_binary_id
 @property {number|int} quarter
 @property {string} results
 @property {boolean} sent_atf
 @property {boolean} sent_cleo
 @property {text|string} sent_cleo_email
 @property {text|string} type
 @property {text|string} year
 @property {boolean} has_notes
 @property {boolean} send_email
 */
/**
 @typedef {Object.<any>} Manufactureds_Forms_Has
 */
/**
 @typedef {Object.<any>} Manufactureds_Forms_Is
 @property {Customers_Object} customers
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Form_P12s_Object} form_p12s
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Manufactureds_Forms_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?string} amended
 @property {string} amended_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?number|int} disposition_pending
 @property {string} disposition_pending_error
 @property {?text|string} disposition_pending_binary_id
 @property {string} disposition_pending_binary_id_error
 @property {?text|string} filename
 @property {string} filename_error
 @property {?number|int} form
 @property {string} form_error
 @property {?number|int} form_p12
 @property {string} form_p12_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} payment
 @property {string} payment_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} product_binary_id
 @property {string} product_binary_id_error
 @property {?number|int} quarter
 @property {string} quarter_error
 @property {?string} results
 @property {string} results_error
 @property {?boolean} sent_atf
 @property {string} sent_atf_error
 @property {?boolean} sent_cleo
 @property {string} sent_cleo_error
 @property {?text|string} sent_cleo_email
 @property {string} sent_cleo_email_error
 @property {?text|string} type
 @property {string} type_error
 @property {?text|string} year
 @property {string} year_error
 @property {?boolean} has_notes
 @property {string} has_notes_error
 @property {?boolean} send_email
 @property {string} send_email_error
 @property {Customers_Object} customers
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Form_P12s_Object} form_p12s
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Master_Banners
 @property {Master_Banners_Properties} properties
 @property {Master_Banners_Has} has
 @property {Master_Banners_Is} is
 @property {Master_Banners_Object} object
 */
/**
 @typedef {Object.<any>} Master_Banners_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} marketing_description
 @property {text|string} marketing_title
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Master_Banners_Has
 */
/**
 @typedef {Object.<any>} Master_Banners_Is
 */
/**
 @typedef {Object.<any>} Master_Banners_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} marketing_description
 @property {string} marketing_description_error
 @property {?text|string} marketing_title
 @property {string} marketing_title_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Mobile_Notifications
 @property {Mobile_Notifications_Properties} properties
 @property {Mobile_Notifications_Has} has
 @property {Mobile_Notifications_Is} is
 @property {Mobile_Notifications_Object} object
 */
/**
 @typedef {Object.<any>} Mobile_Notifications_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 @property {text|string} request
 @property {number|int} request_id
 @property {date|string} sent
 @property {number|int} user
 @property {text|string} user_binary_id
 */
/**
 @typedef {Object.<any>} Mobile_Notifications_Has
 */
/**
 @typedef {Object.<any>} Mobile_Notifications_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Mobile_Notifications_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} request
 @property {string} request_error
 @property {?number|int} request_id
 @property {string} request_id_error
 @property {?date|string} sent
 @property {string} sent_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Modules
 @property {Modules_Properties} properties
 @property {Modules_Has} has
 @property {Modules_Is} is
 @property {Modules_Object} object
 */
/**
 @typedef {Object.<any>} Modules_Properties
 @property {text|string} _id
 @property {boolean} active
 @property {text|string} additional
 @property {text|string} binary_id
 @property {text|string} description
 @property {text|string} name
 @property {text|string} note
 @property {number|int} pkey
 @property {text|string} plan
 @property {text|string} price
 @property {number|int} type
 */
/**
 @typedef {Object.<any>} Modules_Has
 */
/**
 @typedef {Object.<any>} Modules_Is
 */
/**
 @typedef {Object.<any>} Modules_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?boolean} active
 @property {string} active_error
 @property {?text|string} additional
 @property {string} additional_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} description
 @property {string} description_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} plan
 @property {string} plan_error
 @property {?text|string} price
 @property {string} price_error
 @property {?number|int} type
 @property {string} type_error
 */
/**
 @typedef {Object.<any>} Modules_Module_Services
 @property {Modules_Module_Services_Properties} properties
 @property {Modules_Module_Services_Has} has
 @property {Modules_Module_Services_Is} is
 @property {Modules_Module_Services_Object} object
 */
/**
 @typedef {Object.<any>} Modules_Module_Services_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} description
 @property {text|string} link
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} price
 @property {text|string} stripe_price
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {number|int} upgrade
 @property {text|string} upgrade_type
 */
/**
 @typedef {Object.<any>} Modules_Module_Services_Has
 */
/**
 @typedef {Object.<any>} Modules_Module_Services_Is
 */
/**
 @typedef {Object.<any>} Modules_Module_Services_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} description
 @property {string} description_error
 @property {?text|string} link
 @property {string} link_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} price
 @property {string} price_error
 @property {?text|string} stripe_price
 @property {string} stripe_price_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?number|int} upgrade
 @property {string} upgrade_error
 @property {?text|string} upgrade_type
 @property {string} upgrade_type_error
 */
/**
 @typedef {Object.<any>} Multiple_Sales
 @property {Multiple_Sales_Properties} properties
 @property {Multiple_Sales_Has} has
 @property {Multiple_Sales_Is} is
 @property {Multiple_Sales_Object} object
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {date|string} date
 @property {number|int} form
 @property {boolean} generated
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} notes
 @property {number|int} pkey
 @property {boolean} sent
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Has
 @property {Multiple_Sales_Entries_Object[]} multiple_sales_entriess
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Is
 @property {Customers_Object} customers
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Transactions_Collections_Object} transaction_collections
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?number|int} form
 @property {string} form_error
 @property {?boolean} generated
 @property {string} generated_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} sent
 @property {string} sent_error
 @property {Multiple_Sales_Entries_Object[]} multiple_sales_entriess
 @property {Customers_Object} customers
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Transactions_Collections_Object} transaction_collections
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Entries
 @property {Multiple_Sales_Entries_Properties} properties
 @property {Multiple_Sales_Entries_Has} has
 @property {Multiple_Sales_Entries_Is} is
 @property {Multiple_Sales_Entries_Object} object
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Entries_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {number|int} entry
 @property {text|string} entry_binary_id
 @property {number|int} multiple_sale
 @property {text|string} multiple_sale_binary_id
 @property {number|int} pkey
 @property {number|int} product
 @property {text|string} product_binary_id
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Entries_Has
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Entries_Is
 @property {Multiple_Sales_Object} multiple_sales
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Transactions_Entries_Object} transaction_entries
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Entries_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?number|int} entry
 @property {string} entry_error
 @property {?text|string} entry_binary_id
 @property {string} entry_binary_id_error
 @property {?number|int} multiple_sale
 @property {string} multiple_sale_error
 @property {?text|string} multiple_sale_binary_id
 @property {string} multiple_sale_binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} product_binary_id
 @property {string} product_binary_id_error
 @property {Multiple_Sales_Object} multiple_sales
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Transactions_Entries_Object} transaction_entries
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Options
 @property {Multiple_Sales_Options_Properties} properties
 @property {Multiple_Sales_Options_Has} has
 @property {Multiple_Sales_Options_Is} is
 @property {Multiple_Sales_Options_Object} object
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Options_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} calibers_but
 @property {number|int} pkey
 @property {text|string} products
 @property {boolean} semi_auto_w_detach_but
 @property {text|string} states
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Options_Has
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Options_Is
 */
/**
 @typedef {Object.<any>} Multiple_Sales_Options_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} calibers_but
 @property {string} calibers_but_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} products
 @property {string} products_error
 @property {?boolean} semi_auto_w_detach_but
 @property {string} semi_auto_w_detach_but_error
 @property {?text|string} states
 @property {string} states_error
 */
/**
 @typedef {Object.<any>} National_Firearms_Acts
 @property {National_Firearms_Acts_Properties} properties
 @property {National_Firearms_Acts_Has} has
 @property {National_Firearms_Acts_Is} is
 @property {National_Firearms_Acts_Object} object
 */
/**
 @typedef {Object.<any>} National_Firearms_Acts_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 @property {boolean} subscription
 @property {array} totals
 @property {array} transactions
 */
/**
 @typedef {Object.<any>} National_Firearms_Acts_Has
 */
/**
 @typedef {Object.<any>} National_Firearms_Acts_Is
 */
/**
 @typedef {Object.<any>} National_Firearms_Acts_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} subscription
 @property {string} subscription_error
 @property {?array} totals
 @property {string} totals_error
 @property {?array} transactions
 @property {string} transactions_error
 */
/**
 @typedef {Object.<any>} Pins
 @property {Pins_Properties} properties
 @property {Pins_Has} has
 @property {Pins_Is} is
 @property {Pins_Object} object
 */
/**
 @typedef {Object.<any>} Pins_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Pins_Has
 */
/**
 @typedef {Object.<any>} Pins_Is
 */
/**
 @typedef {Object.<any>} Pins_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Point_Of_Sales
 @property {Point_Of_Sales_Properties} properties
 @property {Point_Of_Sales_Has} has
 @property {Point_Of_Sales_Is} is
 @property {Point_Of_Sales_Object} object
 */
/**
 @typedef {Object.<any>} Point_Of_Sales_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} phone
 */
/**
 @typedef {Object.<any>} Point_Of_Sales_Has
 */
/**
 @typedef {Object.<any>} Point_Of_Sales_Is
 */
/**
 @typedef {Object.<any>} Point_Of_Sales_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} phone
 @property {string} phone_error
 */
/**
 @typedef {Object.<any>} Products
 @property {Products_Properties} properties
 @property {Products_Has} has
 @property {Products_Is} is
 @property {Products_Object} object
 */
/**
 @typedef {Object.<any>} Products_Properties
 @property {text|string} _id
 @property {date|string} acquisition_date
 @property {text|string} ammoready_id
 @property {boolean} ammoready_item
 @property {text|string} ammoready_order_id
 @property {boolean} available
 @property {text|string} barrel_length
 @property {text|string} binary_id
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {number|int} caliber
 @property {text|string} caliber_other
 @property {text|string} change_note
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} disposition_date
 @property {text|string} gunbroker_id
 @property {boolean} gunbroker_listed
 @property {text|string} gunbroker_order_id
 @property {boolean} gunbroker_sold
 @property {text|string} gunbroker_title
 @property {date|string} gunbroker_upload_date
 @property {text|string} id
 @property {boolean} imported
 @property {text|string} importer
 @property {text|string} inv
 @property {text|string} item_description
 @property {text|string} item_number
 @property {text|string} label
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {boolean} manufactured
 @property {number|int} manufacturer
 @property {text|string} manufacturer_other
 @property {text|string} model
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} overall_length
 @property {number|int} pkey
 @property {number|int|float} price_list
 @property {number|int|float} price_min
 @property {number|int|float} price_sale
 @property {boolean} semi_auto
 @property {boolean} semi_auto_w_detach
 @property {text|string} serial_number
 @property {text|string} shot
 @property {text|string} sku
 @property {text|string} state_oal
 @property {number|int} status
 @property {text|string} tag_note
 @property {number|int} taxable
 @property {text|string} type
 @property {text|string} type_previous
 @property {text|string} upc
 @property {boolean} used_firearm
 @property {boolean} waiting_for_serial
 @property {text|string} acq_id
 @property {boolean} alaska_hawaii_us_territory
 @property {boolean} amex
 @property {text|string} ammoready_brand
 @property {text|string} ammoready_caliber
 @property {text|string} ammoready_category
 @property {text|string} ammoready_condition
 @property {number|int|float} ammoready_cost
 @property {text|string} ammoready_height
 @property {text|string} ammoready_length
 @property {text|string} ammoready_name
 @property {number|int|float} ammoready_price
 @property {array} ammoready_products
 @property {text|string} ammoready_shipping_restriction
 @property {text|string} ammoready_type
 @property {text|string} ammoready_weight
 @property {text|string} ammoready_width
 @property {number|int|float} appraisal_value
 @property {text|string} atf_type
 @property {number|int|float} auction_price
 @property {number|int|float} buy_now_price
 @property {text|string} caliber_copy
 @property {boolean} certified_check
 @property {boolean} check
 @property {boolean} cod
 @property {array} csv_products_array
 @property {boolean} discover
 @property {boolean} do_not_relist
 @property {boolean} duplicate_serial
 @property {boolean} escrow
 @property {boolean} factory_new
 @property {boolean} financing
 @property {number|int} fixed_count
 @property {boolean} fixed_listing
 @property {boolean} freedom_coin
 @property {boolean} ground
 @property {text|string} gunbroker_category
 @property {text|string} gunbroker_condition
 @property {text|string} gunbroker_description
 @property {number|int} gunbroker_quantity
 @property {text|string} gunbroker_title
 @property {text|string} item_weight_gunbroker
 @property {boolean} item_weight_pounds
 @property {text|string} listing_duration
 @property {text|string} location_name
 @property {text|string} manufacturer_copy
 @property {text|string} map_price
 @property {text|string} mfg_part_number
 @property {boolean} money_order
 @property {boolean} new_old_stock
 @property {boolean} other
 @property {boolean} overnight
 @property {text|string} p_id
 @property {array} payment_methods
 @property {boolean} paypal
 @property {text|string} postal_code
 @property {number|int} product_buyer
 @property {boolean} quantity
 @property {boolean} relist_fixed_count
 @property {boolean} relist_fixed_price
 @property {boolean} relist_until_sold
 @property {number|int|float} reserve_price
 @property {boolean} second_day
 @property {array} serial_numbers
 @property {text|string} shipping_profile
 @property {boolean} third_day
 @property {text|string} type_copy
 @property {boolean} use_shipping_profile
 @property {boolean} used
 @property {boolean} usps_first_class
 @property {boolean} usps_money_order
 @property {boolean} usps_priority_mail
 @property {boolean} visa_mastercard
 @property {boolean} who_pays_for_shipping
 @property {boolean} will_ship_international
 */
/**
 @typedef {Object.<any>} Products_Has
 */
/**
 @typedef {Object.<any>} Products_Is
 @property {Calibers_Object} calibers
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Products_Statuses_Object} product_statuses
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Products_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?date|string} acquisition_date
 @property {string} acquisition_date_error
 @property {?text|string} ammoready_id
 @property {string} ammoready_id_error
 @property {?boolean} ammoready_item
 @property {string} ammoready_item_error
 @property {?text|string} ammoready_order_id
 @property {string} ammoready_order_id_error
 @property {?boolean} available
 @property {string} available_error
 @property {?text|string} barrel_length
 @property {string} barrel_length_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?number|int} caliber
 @property {string} caliber_error
 @property {?text|string} caliber_other
 @property {string} caliber_other_error
 @property {?text|string} change_note
 @property {string} change_note_error
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} disposition_date
 @property {string} disposition_date_error
 @property {?text|string} gunbroker_id
 @property {string} gunbroker_id_error
 @property {?boolean} gunbroker_listed
 @property {string} gunbroker_listed_error
 @property {?text|string} gunbroker_order_id
 @property {string} gunbroker_order_id_error
 @property {?boolean} gunbroker_sold
 @property {string} gunbroker_sold_error
 @property {?text|string} gunbroker_title
 @property {string} gunbroker_title_error
 @property {?date|string} gunbroker_upload_date
 @property {string} gunbroker_upload_date_error
 @property {?text|string} id
 @property {string} id_error
 @property {?boolean} imported
 @property {string} imported_error
 @property {?text|string} importer
 @property {string} importer_error
 @property {?text|string} inv
 @property {string} inv_error
 @property {?text|string} item_description
 @property {string} item_description_error
 @property {?text|string} item_number
 @property {string} item_number_error
 @property {?text|string} label
 @property {string} label_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?boolean} manufactured
 @property {string} manufactured_error
 @property {?number|int} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} manufacturer_other
 @property {string} manufacturer_other_error
 @property {?text|string} model
 @property {string} model_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} overall_length
 @property {string} overall_length_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price_list
 @property {string} price_list_error
 @property {?number|int|float} price_min
 @property {string} price_min_error
 @property {?number|int|float} price_sale
 @property {string} price_sale_error
 @property {?boolean} semi_auto
 @property {string} semi_auto_error
 @property {?boolean} semi_auto_w_detach
 @property {string} semi_auto_w_detach_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} shot
 @property {string} shot_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?text|string} state_oal
 @property {string} state_oal_error
 @property {?number|int} status
 @property {string} status_error
 @property {?text|string} tag_note
 @property {string} tag_note_error
 @property {?number|int} taxable
 @property {string} taxable_error
 @property {?text|string} type
 @property {string} type_error
 @property {?text|string} type_previous
 @property {string} type_previous_error
 @property {?text|string} upc
 @property {string} upc_error
 @property {?boolean} used_firearm
 @property {string} used_firearm_error
 @property {?boolean} waiting_for_serial
 @property {string} waiting_for_serial_error
 @property {?text|string} acq_id
 @property {string} acq_id_error
 @property {?boolean} alaska_hawaii_us_territory
 @property {string} alaska_hawaii_us_territory_error
 @property {?boolean} amex
 @property {string} amex_error
 @property {?text|string} ammoready_brand
 @property {string} ammoready_brand_error
 @property {?text|string} ammoready_caliber
 @property {string} ammoready_caliber_error
 @property {?text|string} ammoready_category
 @property {string} ammoready_category_error
 @property {?text|string} ammoready_condition
 @property {string} ammoready_condition_error
 @property {?number|int|float} ammoready_cost
 @property {string} ammoready_cost_error
 @property {?text|string} ammoready_height
 @property {string} ammoready_height_error
 @property {?text|string} ammoready_length
 @property {string} ammoready_length_error
 @property {?text|string} ammoready_name
 @property {string} ammoready_name_error
 @property {?number|int|float} ammoready_price
 @property {string} ammoready_price_error
 @property {?array} ammoready_products
 @property {string} ammoready_products_error
 @property {?text|string} ammoready_shipping_restriction
 @property {string} ammoready_shipping_restriction_error
 @property {?text|string} ammoready_type
 @property {string} ammoready_type_error
 @property {?text|string} ammoready_weight
 @property {string} ammoready_weight_error
 @property {?text|string} ammoready_width
 @property {string} ammoready_width_error
 @property {?number|int|float} appraisal_value
 @property {string} appraisal_value_error
 @property {?text|string} atf_type
 @property {string} atf_type_error
 @property {?number|int|float} auction_price
 @property {string} auction_price_error
 @property {?number|int|float} buy_now_price
 @property {string} buy_now_price_error
 @property {?text|string} caliber_copy
 @property {string} caliber_copy_error
 @property {?boolean} certified_check
 @property {string} certified_check_error
 @property {?boolean} check
 @property {string} check_error
 @property {?boolean} cod
 @property {string} cod_error
 @property {?array} csv_products_array
 @property {string} csv_products_array_error
 @property {?boolean} discover
 @property {string} discover_error
 @property {?boolean} do_not_relist
 @property {string} do_not_relist_error
 @property {?boolean} duplicate_serial
 @property {string} duplicate_serial_error
 @property {?boolean} escrow
 @property {string} escrow_error
 @property {?boolean} factory_new
 @property {string} factory_new_error
 @property {?boolean} financing
 @property {string} financing_error
 @property {?number|int} fixed_count
 @property {string} fixed_count_error
 @property {?boolean} fixed_listing
 @property {string} fixed_listing_error
 @property {?boolean} freedom_coin
 @property {string} freedom_coin_error
 @property {?boolean} ground
 @property {string} ground_error
 @property {?text|string} gunbroker_category
 @property {string} gunbroker_category_error
 @property {?text|string} gunbroker_condition
 @property {string} gunbroker_condition_error
 @property {?text|string} gunbroker_description
 @property {string} gunbroker_description_error
 @property {?number|int} gunbroker_quantity
 @property {string} gunbroker_quantity_error
 @property {?text|string} gunbroker_title
 @property {string} gunbroker_title_error
 @property {?text|string} item_weight_gunbroker
 @property {string} item_weight_gunbroker_error
 @property {?boolean} item_weight_pounds
 @property {string} item_weight_pounds_error
 @property {?text|string} listing_duration
 @property {string} listing_duration_error
 @property {?text|string} location_name
 @property {string} location_name_error
 @property {?text|string} manufacturer_copy
 @property {string} manufacturer_copy_error
 @property {?text|string} map_price
 @property {string} map_price_error
 @property {?text|string} mfg_part_number
 @property {string} mfg_part_number_error
 @property {?boolean} money_order
 @property {string} money_order_error
 @property {?boolean} new_old_stock
 @property {string} new_old_stock_error
 @property {?boolean} other
 @property {string} other_error
 @property {?boolean} overnight
 @property {string} overnight_error
 @property {?text|string} p_id
 @property {string} p_id_error
 @property {?array} payment_methods
 @property {string} payment_methods_error
 @property {?boolean} paypal
 @property {string} paypal_error
 @property {?text|string} postal_code
 @property {string} postal_code_error
 @property {?number|int} product_buyer
 @property {string} product_buyer_error
 @property {?boolean} quantity
 @property {string} quantity_error
 @property {?boolean} relist_fixed_count
 @property {string} relist_fixed_count_error
 @property {?boolean} relist_fixed_price
 @property {string} relist_fixed_price_error
 @property {?boolean} relist_until_sold
 @property {string} relist_until_sold_error
 @property {?number|int|float} reserve_price
 @property {string} reserve_price_error
 @property {?boolean} second_day
 @property {string} second_day_error
 @property {?array} serial_numbers
 @property {string} serial_numbers_error
 @property {?text|string} shipping_profile
 @property {string} shipping_profile_error
 @property {?boolean} third_day
 @property {string} third_day_error
 @property {?text|string} type_copy
 @property {string} type_copy_error
 @property {?boolean} use_shipping_profile
 @property {string} use_shipping_profile_error
 @property {?boolean} used
 @property {string} used_error
 @property {?boolean} usps_first_class
 @property {string} usps_first_class_error
 @property {?boolean} usps_money_order
 @property {string} usps_money_order_error
 @property {?boolean} usps_priority_mail
 @property {string} usps_priority_mail_error
 @property {?boolean} visa_mastercard
 @property {string} visa_mastercard_error
 @property {?boolean} who_pays_for_shipping
 @property {string} who_pays_for_shipping_error
 @property {?boolean} will_ship_international
 @property {string} will_ship_international_error
 @property {Calibers_Object} calibers
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Products_Statuses_Object} product_statuses
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Products_Histories
 @property {Products_Histories_Properties} properties
 @property {Products_Histories_Has} has
 @property {Products_Histories_Is} is
 @property {Products_Histories_Object} object
 */
/**
 @typedef {Object.<any>} Products_Histories_Properties
 @property {text|string} _id
 @property {date|string} acquisition_date
 @property {text|string} ammoready_id
 @property {boolean} ammoready_item
 @property {text|string} ammoready_order_id
 @property {boolean} available
 @property {text|string} barrel_length
 @property {text|string} binary_id
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {number|int} caliber
 @property {text|string} caliber_other
 @property {text|string} change_note
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} disposition_date
 @property {text|string} gunbroker_id
 @property {boolean} gunbroker_listed
 @property {text|string} gunbroker_order_id
 @property {boolean} gunbroker_sold
 @property {text|string} gunbroker_title
 @property {date|string} gunbroker_upload_date
 @property {text|string} id
 @property {boolean} imported
 @property {text|string} importer
 @property {text|string} inv
 @property {text|string} item_description
 @property {text|string} item_number
 @property {text|string} label
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {boolean} manufactured
 @property {number|int} manufacturer
 @property {text|string} manufacturer_other
 @property {text|string} model
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} overall_length
 @property {number|int} pkey
 @property {number|int|float} price_list
 @property {number|int|float} price_min
 @property {number|int|float} price_sale
 @property {boolean} semi_auto
 @property {boolean} semi_auto_w_detach
 @property {text|string} serial_number
 @property {text|string} shot
 @property {text|string} sku
 @property {text|string} state_oal
 @property {number|int} status
 @property {text|string} tag_note
 @property {number|int} taxable
 @property {text|string} type
 @property {text|string} type_previous
 @property {text|string} upc
 @property {boolean} used_firearm
 @property {boolean} waiting_for_serial
 @property {text|string} acq_id
 @property {boolean} alaska_hawaii_us_territory
 @property {boolean} amex
 @property {text|string} ammoready_brand
 @property {text|string} ammoready_caliber
 @property {text|string} ammoready_category
 @property {text|string} ammoready_condition
 @property {number|int|float} ammoready_cost
 @property {text|string} ammoready_height
 @property {text|string} ammoready_length
 @property {text|string} ammoready_name
 @property {number|int|float} ammoready_price
 @property {array} ammoready_products
 @property {text|string} ammoready_shipping_restriction
 @property {text|string} ammoready_type
 @property {text|string} ammoready_weight
 @property {text|string} ammoready_width
 @property {number|int|float} appraisal_value
 @property {text|string} atf_type
 @property {number|int|float} auction_price
 @property {number|int|float} buy_now_price
 @property {text|string} caliber_copy
 @property {boolean} certified_check
 @property {boolean} check
 @property {boolean} cod
 @property {array} csv_products_array
 @property {boolean} discover
 @property {boolean} do_not_relist
 @property {boolean} duplicate_serial
 @property {boolean} escrow
 @property {boolean} factory_new
 @property {boolean} financing
 @property {number|int} fixed_count
 @property {boolean} fixed_listing
 @property {boolean} freedom_coin
 @property {boolean} ground
 @property {text|string} gunbroker_category
 @property {text|string} gunbroker_condition
 @property {text|string} gunbroker_description
 @property {number|int} gunbroker_quantity
 @property {text|string} gunbroker_title
 @property {text|string} item_weight_gunbroker
 @property {boolean} item_weight_pounds
 @property {text|string} listing_duration
 @property {text|string} location_name
 @property {text|string} manufacturer_copy
 @property {text|string} map_price
 @property {text|string} mfg_part_number
 @property {boolean} money_order
 @property {boolean} new_old_stock
 @property {boolean} other
 @property {boolean} overnight
 @property {text|string} p_id
 @property {array} payment_methods
 @property {boolean} paypal
 @property {text|string} postal_code
 @property {number|int} product_buyer
 @property {boolean} quantity
 @property {boolean} relist_fixed_count
 @property {boolean} relist_fixed_price
 @property {boolean} relist_until_sold
 @property {number|int|float} reserve_price
 @property {boolean} second_day
 @property {array} serial_numbers
 @property {text|string} shipping_profile
 @property {boolean} third_day
 @property {text|string} type_copy
 @property {boolean} use_shipping_profile
 @property {boolean} used
 @property {boolean} usps_first_class
 @property {boolean} usps_money_order
 @property {boolean} usps_priority_mail
 @property {boolean} visa_mastercard
 @property {boolean} who_pays_for_shipping
 @property {boolean} will_ship_international
 */
/**
 @typedef {Object.<any>} Products_Histories_Has
 */
/**
 @typedef {Object.<any>} Products_Histories_Is
 @property {Calibers_Object} calibers
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Products_Statuses_Object} product_statuses
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Products_Histories_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?date|string} acquisition_date
 @property {string} acquisition_date_error
 @property {?text|string} ammoready_id
 @property {string} ammoready_id_error
 @property {?boolean} ammoready_item
 @property {string} ammoready_item_error
 @property {?text|string} ammoready_order_id
 @property {string} ammoready_order_id_error
 @property {?boolean} available
 @property {string} available_error
 @property {?text|string} barrel_length
 @property {string} barrel_length_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?number|int} caliber
 @property {string} caliber_error
 @property {?text|string} caliber_other
 @property {string} caliber_other_error
 @property {?text|string} change_note
 @property {string} change_note_error
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} disposition_date
 @property {string} disposition_date_error
 @property {?text|string} gunbroker_id
 @property {string} gunbroker_id_error
 @property {?boolean} gunbroker_listed
 @property {string} gunbroker_listed_error
 @property {?text|string} gunbroker_order_id
 @property {string} gunbroker_order_id_error
 @property {?boolean} gunbroker_sold
 @property {string} gunbroker_sold_error
 @property {?text|string} gunbroker_title
 @property {string} gunbroker_title_error
 @property {?date|string} gunbroker_upload_date
 @property {string} gunbroker_upload_date_error
 @property {?text|string} id
 @property {string} id_error
 @property {?boolean} imported
 @property {string} imported_error
 @property {?text|string} importer
 @property {string} importer_error
 @property {?text|string} inv
 @property {string} inv_error
 @property {?text|string} item_description
 @property {string} item_description_error
 @property {?text|string} item_number
 @property {string} item_number_error
 @property {?text|string} label
 @property {string} label_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?boolean} manufactured
 @property {string} manufactured_error
 @property {?number|int} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} manufacturer_other
 @property {string} manufacturer_other_error
 @property {?text|string} model
 @property {string} model_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} overall_length
 @property {string} overall_length_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price_list
 @property {string} price_list_error
 @property {?number|int|float} price_min
 @property {string} price_min_error
 @property {?number|int|float} price_sale
 @property {string} price_sale_error
 @property {?boolean} semi_auto
 @property {string} semi_auto_error
 @property {?boolean} semi_auto_w_detach
 @property {string} semi_auto_w_detach_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} shot
 @property {string} shot_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?text|string} state_oal
 @property {string} state_oal_error
 @property {?number|int} status
 @property {string} status_error
 @property {?text|string} tag_note
 @property {string} tag_note_error
 @property {?number|int} taxable
 @property {string} taxable_error
 @property {?text|string} type
 @property {string} type_error
 @property {?text|string} type_previous
 @property {string} type_previous_error
 @property {?text|string} upc
 @property {string} upc_error
 @property {?boolean} used_firearm
 @property {string} used_firearm_error
 @property {?boolean} waiting_for_serial
 @property {string} waiting_for_serial_error
 @property {?text|string} acq_id
 @property {string} acq_id_error
 @property {?boolean} alaska_hawaii_us_territory
 @property {string} alaska_hawaii_us_territory_error
 @property {?boolean} amex
 @property {string} amex_error
 @property {?text|string} ammoready_brand
 @property {string} ammoready_brand_error
 @property {?text|string} ammoready_caliber
 @property {string} ammoready_caliber_error
 @property {?text|string} ammoready_category
 @property {string} ammoready_category_error
 @property {?text|string} ammoready_condition
 @property {string} ammoready_condition_error
 @property {?number|int|float} ammoready_cost
 @property {string} ammoready_cost_error
 @property {?text|string} ammoready_height
 @property {string} ammoready_height_error
 @property {?text|string} ammoready_length
 @property {string} ammoready_length_error
 @property {?text|string} ammoready_name
 @property {string} ammoready_name_error
 @property {?number|int|float} ammoready_price
 @property {string} ammoready_price_error
 @property {?array} ammoready_products
 @property {string} ammoready_products_error
 @property {?text|string} ammoready_shipping_restriction
 @property {string} ammoready_shipping_restriction_error
 @property {?text|string} ammoready_type
 @property {string} ammoready_type_error
 @property {?text|string} ammoready_weight
 @property {string} ammoready_weight_error
 @property {?text|string} ammoready_width
 @property {string} ammoready_width_error
 @property {?number|int|float} appraisal_value
 @property {string} appraisal_value_error
 @property {?text|string} atf_type
 @property {string} atf_type_error
 @property {?number|int|float} auction_price
 @property {string} auction_price_error
 @property {?number|int|float} buy_now_price
 @property {string} buy_now_price_error
 @property {?text|string} caliber_copy
 @property {string} caliber_copy_error
 @property {?boolean} certified_check
 @property {string} certified_check_error
 @property {?boolean} check
 @property {string} check_error
 @property {?boolean} cod
 @property {string} cod_error
 @property {?array} csv_products_array
 @property {string} csv_products_array_error
 @property {?boolean} discover
 @property {string} discover_error
 @property {?boolean} do_not_relist
 @property {string} do_not_relist_error
 @property {?boolean} duplicate_serial
 @property {string} duplicate_serial_error
 @property {?boolean} escrow
 @property {string} escrow_error
 @property {?boolean} factory_new
 @property {string} factory_new_error
 @property {?boolean} financing
 @property {string} financing_error
 @property {?number|int} fixed_count
 @property {string} fixed_count_error
 @property {?boolean} fixed_listing
 @property {string} fixed_listing_error
 @property {?boolean} freedom_coin
 @property {string} freedom_coin_error
 @property {?boolean} ground
 @property {string} ground_error
 @property {?text|string} gunbroker_category
 @property {string} gunbroker_category_error
 @property {?text|string} gunbroker_condition
 @property {string} gunbroker_condition_error
 @property {?text|string} gunbroker_description
 @property {string} gunbroker_description_error
 @property {?number|int} gunbroker_quantity
 @property {string} gunbroker_quantity_error
 @property {?text|string} gunbroker_title
 @property {string} gunbroker_title_error
 @property {?text|string} item_weight_gunbroker
 @property {string} item_weight_gunbroker_error
 @property {?boolean} item_weight_pounds
 @property {string} item_weight_pounds_error
 @property {?text|string} listing_duration
 @property {string} listing_duration_error
 @property {?text|string} location_name
 @property {string} location_name_error
 @property {?text|string} manufacturer_copy
 @property {string} manufacturer_copy_error
 @property {?text|string} map_price
 @property {string} map_price_error
 @property {?text|string} mfg_part_number
 @property {string} mfg_part_number_error
 @property {?boolean} money_order
 @property {string} money_order_error
 @property {?boolean} new_old_stock
 @property {string} new_old_stock_error
 @property {?boolean} other
 @property {string} other_error
 @property {?boolean} overnight
 @property {string} overnight_error
 @property {?text|string} p_id
 @property {string} p_id_error
 @property {?array} payment_methods
 @property {string} payment_methods_error
 @property {?boolean} paypal
 @property {string} paypal_error
 @property {?text|string} postal_code
 @property {string} postal_code_error
 @property {?number|int} product_buyer
 @property {string} product_buyer_error
 @property {?boolean} quantity
 @property {string} quantity_error
 @property {?boolean} relist_fixed_count
 @property {string} relist_fixed_count_error
 @property {?boolean} relist_fixed_price
 @property {string} relist_fixed_price_error
 @property {?boolean} relist_until_sold
 @property {string} relist_until_sold_error
 @property {?number|int|float} reserve_price
 @property {string} reserve_price_error
 @property {?boolean} second_day
 @property {string} second_day_error
 @property {?array} serial_numbers
 @property {string} serial_numbers_error
 @property {?text|string} shipping_profile
 @property {string} shipping_profile_error
 @property {?boolean} third_day
 @property {string} third_day_error
 @property {?text|string} type_copy
 @property {string} type_copy_error
 @property {?boolean} use_shipping_profile
 @property {string} use_shipping_profile_error
 @property {?boolean} used
 @property {string} used_error
 @property {?boolean} usps_first_class
 @property {string} usps_first_class_error
 @property {?boolean} usps_money_order
 @property {string} usps_money_order_error
 @property {?boolean} usps_priority_mail
 @property {string} usps_priority_mail_error
 @property {?boolean} visa_mastercard
 @property {string} visa_mastercard_error
 @property {?boolean} who_pays_for_shipping
 @property {string} who_pays_for_shipping_error
 @property {?boolean} will_ship_international
 @property {string} will_ship_international_error
 @property {Calibers_Object} calibers
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Products_Statuses_Object} product_statuses
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Products_Ioi_Inspection_Items
 @property {Products_Ioi_Inspection_Items_Properties} properties
 @property {Products_Ioi_Inspection_Items_Has} has
 @property {Products_Ioi_Inspection_Items_Is} is
 @property {Products_Ioi_Inspection_Items_Object} object
 */
/**
 @typedef {Object.<any>} Products_Ioi_Inspection_Items_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} end_date
 @property {text|string} inspector
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} notes
 @property {number|int} pkey
 @property {date|string} start_date
 */
/**
 @typedef {Object.<any>} Products_Ioi_Inspection_Items_Has
 */
/**
 @typedef {Object.<any>} Products_Ioi_Inspection_Items_Is
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Products_Ioi_Inspection_Items_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} end_date
 @property {string} end_date_error
 @property {?text|string} inspector
 @property {string} inspector_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?date|string} start_date
 @property {string} start_date_error
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Products_Ioi_Inspections
 @property {Products_Ioi_Inspections_Properties} properties
 @property {Products_Ioi_Inspections_Has} has
 @property {Products_Ioi_Inspections_Is} is
 @property {Products_Ioi_Inspections_Object} object
 */
/**
 @typedef {Object.<any>} Products_Ioi_Inspections_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} date_end
 @property {date|string} date_start
 @property {text|string} inspector
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} notes
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Products_Ioi_Inspections_Has
 */
/**
 @typedef {Object.<any>} Products_Ioi_Inspections_Is
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Products_Ioi_Inspections_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} date_end
 @property {string} date_end_error
 @property {?date|string} date_start
 @property {string} date_start_error
 @property {?text|string} inspector
 @property {string} inspector_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {Locations_Object} locations
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Products_Logs
 @property {Products_Logs_Properties} properties
 @property {Products_Logs_Has} has
 @property {Products_Logs_Is} is
 @property {Products_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Products_Logs_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} date
 @property {text|string} display_new
 @property {text|string} display_old
 @property {text|string} field
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} product
 @property {text|string} product_binary_id
 @property {number|int} user
 @property {text|string} user_binary_id
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Products_Logs_Has
 */
/**
 @typedef {Object.<any>} Products_Logs_Is
 @property {Products_Object} products
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Products_Logs_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} display_new
 @property {string} display_new_error
 @property {?text|string} display_old
 @property {string} display_old_error
 @property {?text|string} field
 @property {string} field_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} product_binary_id
 @property {string} product_binary_id_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Products_Object} products
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Products_Point_Of_Sales
 @property {Products_Point_Of_Sales_Properties} properties
 @property {Products_Point_Of_Sales_Has} has
 @property {Products_Point_Of_Sales_Is} is
 @property {Products_Point_Of_Sales_Object} object
 */
/**
 @typedef {Object.<any>} Products_Point_Of_Sales_Properties
 @property {text|string} _id
 @property {date|string} acquisition_date
 @property {text|string} ammoready_id
 @property {boolean} ammoready_item
 @property {text|string} ammoready_order_id
 @property {boolean} available
 @property {text|string} barrel_length
 @property {text|string} binary_id
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {number|int} caliber
 @property {text|string} caliber_other
 @property {text|string} change_note
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} disposition_date
 @property {text|string} gunbroker_id
 @property {boolean} gunbroker_listed
 @property {text|string} gunbroker_order_id
 @property {boolean} gunbroker_sold
 @property {text|string} gunbroker_title
 @property {date|string} gunbroker_upload_date
 @property {text|string} id
 @property {boolean} imported
 @property {text|string} importer
 @property {text|string} inv
 @property {text|string} item_description
 @property {text|string} item_number
 @property {text|string} label
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {boolean} manufactured
 @property {number|int} manufacturer
 @property {text|string} manufacturer_other
 @property {text|string} model
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} overall_length
 @property {number|int} pkey
 @property {number|int|float} price_list
 @property {number|int|float} price_min
 @property {number|int|float} price_sale
 @property {boolean} semi_auto
 @property {boolean} semi_auto_w_detach
 @property {text|string} serial_number
 @property {text|string} shot
 @property {text|string} sku
 @property {text|string} state_oal
 @property {number|int} status
 @property {text|string} tag_note
 @property {number|int} taxable
 @property {text|string} type
 @property {text|string} type_previous
 @property {text|string} upc
 @property {boolean} used_firearm
 @property {boolean} waiting_for_serial
 @property {text|string} acq_id
 @property {boolean} alaska_hawaii_us_territory
 @property {boolean} amex
 @property {text|string} ammoready_brand
 @property {text|string} ammoready_caliber
 @property {text|string} ammoready_category
 @property {text|string} ammoready_condition
 @property {number|int|float} ammoready_cost
 @property {text|string} ammoready_height
 @property {text|string} ammoready_length
 @property {text|string} ammoready_name
 @property {number|int|float} ammoready_price
 @property {array} ammoready_products
 @property {text|string} ammoready_shipping_restriction
 @property {text|string} ammoready_type
 @property {text|string} ammoready_weight
 @property {text|string} ammoready_width
 @property {number|int|float} appraisal_value
 @property {text|string} atf_type
 @property {number|int|float} auction_price
 @property {number|int|float} buy_now_price
 @property {text|string} caliber_copy
 @property {boolean} certified_check
 @property {boolean} check
 @property {boolean} cod
 @property {array} csv_products_array
 @property {boolean} discover
 @property {boolean} do_not_relist
 @property {boolean} duplicate_serial
 @property {boolean} escrow
 @property {boolean} factory_new
 @property {boolean} financing
 @property {number|int} fixed_count
 @property {boolean} fixed_listing
 @property {boolean} freedom_coin
 @property {boolean} ground
 @property {text|string} gunbroker_category
 @property {text|string} gunbroker_condition
 @property {text|string} gunbroker_description
 @property {number|int} gunbroker_quantity
 @property {text|string} gunbroker_title
 @property {text|string} item_weight_gunbroker
 @property {boolean} item_weight_pounds
 @property {text|string} listing_duration
 @property {text|string} location_name
 @property {text|string} manufacturer_copy
 @property {text|string} map_price
 @property {text|string} mfg_part_number
 @property {boolean} money_order
 @property {boolean} new_old_stock
 @property {boolean} other
 @property {boolean} overnight
 @property {text|string} p_id
 @property {array} payment_methods
 @property {boolean} paypal
 @property {text|string} postal_code
 @property {number|int} product_buyer
 @property {boolean} quantity
 @property {boolean} relist_fixed_count
 @property {boolean} relist_fixed_price
 @property {boolean} relist_until_sold
 @property {number|int|float} reserve_price
 @property {boolean} second_day
 @property {array} serial_numbers
 @property {text|string} shipping_profile
 @property {boolean} third_day
 @property {text|string} type_copy
 @property {boolean} use_shipping_profile
 @property {boolean} used
 @property {boolean} usps_first_class
 @property {boolean} usps_money_order
 @property {boolean} usps_priority_mail
 @property {boolean} visa_mastercard
 @property {boolean} who_pays_for_shipping
 @property {boolean} will_ship_international
 */
/**
 @typedef {Object.<any>} Products_Point_Of_Sales_Has
 */
/**
 @typedef {Object.<any>} Products_Point_Of_Sales_Is
 @property {Calibers_Object} calibers
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Products_Statuses_Object} product_statuses
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Products_Point_Of_Sales_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?date|string} acquisition_date
 @property {string} acquisition_date_error
 @property {?text|string} ammoready_id
 @property {string} ammoready_id_error
 @property {?boolean} ammoready_item
 @property {string} ammoready_item_error
 @property {?text|string} ammoready_order_id
 @property {string} ammoready_order_id_error
 @property {?boolean} available
 @property {string} available_error
 @property {?text|string} barrel_length
 @property {string} barrel_length_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?number|int} caliber
 @property {string} caliber_error
 @property {?text|string} caliber_other
 @property {string} caliber_other_error
 @property {?text|string} change_note
 @property {string} change_note_error
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} disposition_date
 @property {string} disposition_date_error
 @property {?text|string} gunbroker_id
 @property {string} gunbroker_id_error
 @property {?boolean} gunbroker_listed
 @property {string} gunbroker_listed_error
 @property {?text|string} gunbroker_order_id
 @property {string} gunbroker_order_id_error
 @property {?boolean} gunbroker_sold
 @property {string} gunbroker_sold_error
 @property {?text|string} gunbroker_title
 @property {string} gunbroker_title_error
 @property {?date|string} gunbroker_upload_date
 @property {string} gunbroker_upload_date_error
 @property {?text|string} id
 @property {string} id_error
 @property {?boolean} imported
 @property {string} imported_error
 @property {?text|string} importer
 @property {string} importer_error
 @property {?text|string} inv
 @property {string} inv_error
 @property {?text|string} item_description
 @property {string} item_description_error
 @property {?text|string} item_number
 @property {string} item_number_error
 @property {?text|string} label
 @property {string} label_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?boolean} manufactured
 @property {string} manufactured_error
 @property {?number|int} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} manufacturer_other
 @property {string} manufacturer_other_error
 @property {?text|string} model
 @property {string} model_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} overall_length
 @property {string} overall_length_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price_list
 @property {string} price_list_error
 @property {?number|int|float} price_min
 @property {string} price_min_error
 @property {?number|int|float} price_sale
 @property {string} price_sale_error
 @property {?boolean} semi_auto
 @property {string} semi_auto_error
 @property {?boolean} semi_auto_w_detach
 @property {string} semi_auto_w_detach_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} shot
 @property {string} shot_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?text|string} state_oal
 @property {string} state_oal_error
 @property {?number|int} status
 @property {string} status_error
 @property {?text|string} tag_note
 @property {string} tag_note_error
 @property {?number|int} taxable
 @property {string} taxable_error
 @property {?text|string} type
 @property {string} type_error
 @property {?text|string} type_previous
 @property {string} type_previous_error
 @property {?text|string} upc
 @property {string} upc_error
 @property {?boolean} used_firearm
 @property {string} used_firearm_error
 @property {?boolean} waiting_for_serial
 @property {string} waiting_for_serial_error
 @property {?text|string} acq_id
 @property {string} acq_id_error
 @property {?boolean} alaska_hawaii_us_territory
 @property {string} alaska_hawaii_us_territory_error
 @property {?boolean} amex
 @property {string} amex_error
 @property {?text|string} ammoready_brand
 @property {string} ammoready_brand_error
 @property {?text|string} ammoready_caliber
 @property {string} ammoready_caliber_error
 @property {?text|string} ammoready_category
 @property {string} ammoready_category_error
 @property {?text|string} ammoready_condition
 @property {string} ammoready_condition_error
 @property {?number|int|float} ammoready_cost
 @property {string} ammoready_cost_error
 @property {?text|string} ammoready_height
 @property {string} ammoready_height_error
 @property {?text|string} ammoready_length
 @property {string} ammoready_length_error
 @property {?text|string} ammoready_name
 @property {string} ammoready_name_error
 @property {?number|int|float} ammoready_price
 @property {string} ammoready_price_error
 @property {?array} ammoready_products
 @property {string} ammoready_products_error
 @property {?text|string} ammoready_shipping_restriction
 @property {string} ammoready_shipping_restriction_error
 @property {?text|string} ammoready_type
 @property {string} ammoready_type_error
 @property {?text|string} ammoready_weight
 @property {string} ammoready_weight_error
 @property {?text|string} ammoready_width
 @property {string} ammoready_width_error
 @property {?number|int|float} appraisal_value
 @property {string} appraisal_value_error
 @property {?text|string} atf_type
 @property {string} atf_type_error
 @property {?number|int|float} auction_price
 @property {string} auction_price_error
 @property {?number|int|float} buy_now_price
 @property {string} buy_now_price_error
 @property {?text|string} caliber_copy
 @property {string} caliber_copy_error
 @property {?boolean} certified_check
 @property {string} certified_check_error
 @property {?boolean} check
 @property {string} check_error
 @property {?boolean} cod
 @property {string} cod_error
 @property {?array} csv_products_array
 @property {string} csv_products_array_error
 @property {?boolean} discover
 @property {string} discover_error
 @property {?boolean} do_not_relist
 @property {string} do_not_relist_error
 @property {?boolean} duplicate_serial
 @property {string} duplicate_serial_error
 @property {?boolean} escrow
 @property {string} escrow_error
 @property {?boolean} factory_new
 @property {string} factory_new_error
 @property {?boolean} financing
 @property {string} financing_error
 @property {?number|int} fixed_count
 @property {string} fixed_count_error
 @property {?boolean} fixed_listing
 @property {string} fixed_listing_error
 @property {?boolean} freedom_coin
 @property {string} freedom_coin_error
 @property {?boolean} ground
 @property {string} ground_error
 @property {?text|string} gunbroker_category
 @property {string} gunbroker_category_error
 @property {?text|string} gunbroker_condition
 @property {string} gunbroker_condition_error
 @property {?text|string} gunbroker_description
 @property {string} gunbroker_description_error
 @property {?number|int} gunbroker_quantity
 @property {string} gunbroker_quantity_error
 @property {?text|string} gunbroker_title
 @property {string} gunbroker_title_error
 @property {?text|string} item_weight_gunbroker
 @property {string} item_weight_gunbroker_error
 @property {?boolean} item_weight_pounds
 @property {string} item_weight_pounds_error
 @property {?text|string} listing_duration
 @property {string} listing_duration_error
 @property {?text|string} location_name
 @property {string} location_name_error
 @property {?text|string} manufacturer_copy
 @property {string} manufacturer_copy_error
 @property {?text|string} map_price
 @property {string} map_price_error
 @property {?text|string} mfg_part_number
 @property {string} mfg_part_number_error
 @property {?boolean} money_order
 @property {string} money_order_error
 @property {?boolean} new_old_stock
 @property {string} new_old_stock_error
 @property {?boolean} other
 @property {string} other_error
 @property {?boolean} overnight
 @property {string} overnight_error
 @property {?text|string} p_id
 @property {string} p_id_error
 @property {?array} payment_methods
 @property {string} payment_methods_error
 @property {?boolean} paypal
 @property {string} paypal_error
 @property {?text|string} postal_code
 @property {string} postal_code_error
 @property {?number|int} product_buyer
 @property {string} product_buyer_error
 @property {?boolean} quantity
 @property {string} quantity_error
 @property {?boolean} relist_fixed_count
 @property {string} relist_fixed_count_error
 @property {?boolean} relist_fixed_price
 @property {string} relist_fixed_price_error
 @property {?boolean} relist_until_sold
 @property {string} relist_until_sold_error
 @property {?number|int|float} reserve_price
 @property {string} reserve_price_error
 @property {?boolean} second_day
 @property {string} second_day_error
 @property {?array} serial_numbers
 @property {string} serial_numbers_error
 @property {?text|string} shipping_profile
 @property {string} shipping_profile_error
 @property {?boolean} third_day
 @property {string} third_day_error
 @property {?text|string} type_copy
 @property {string} type_copy_error
 @property {?boolean} use_shipping_profile
 @property {string} use_shipping_profile_error
 @property {?boolean} used
 @property {string} used_error
 @property {?boolean} usps_first_class
 @property {string} usps_first_class_error
 @property {?boolean} usps_money_order
 @property {string} usps_money_order_error
 @property {?boolean} usps_priority_mail
 @property {string} usps_priority_mail_error
 @property {?boolean} visa_mastercard
 @property {string} visa_mastercard_error
 @property {?boolean} who_pays_for_shipping
 @property {string} who_pays_for_shipping_error
 @property {?boolean} will_ship_international
 @property {string} will_ship_international_error
 @property {Calibers_Object} calibers
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Products_Statuses_Object} product_statuses
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Products_Statuses
 @property {Products_Statuses_Properties} properties
 @property {Products_Statuses_Has} has
 @property {Products_Statuses_Is} is
 @property {Products_Statuses_Object} object
 */
/**
 @typedef {Object.<any>} Products_Statuses_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int} transaction
 */
/**
 @typedef {Object.<any>} Products_Statuses_Has
 */
/**
 @typedef {Object.<any>} Products_Statuses_Is
 @property {Transactions_Types_Object} transaction_types
 */
/**
 @typedef {Object.<any>} Products_Statuses_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} transaction
 @property {string} transaction_error
 @property {Transactions_Types_Object} transaction_types
 */
/**
 @typedef {Object.<any>} Products_Types
 @property {Products_Types_Properties} properties
 @property {Products_Types_Has} has
 @property {Products_Types_Is} is
 @property {Products_Types_Object} object
 */
/**
 @typedef {Object.<any>} Products_Types_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Products_Types_Has
 */
/**
 @typedef {Object.<any>} Products_Types_Is
 */
/**
 @typedef {Object.<any>} Products_Types_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Signatures
 @property {Signatures_Properties} properties
 @property {Signatures_Has} has
 @property {Signatures_Is} is
 @property {Signatures_Object} object
 */
/**
 @typedef {Object.<any>} Signatures_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {date|string} date
 @property {number|int} pkey
 @property {text|string} signature
 @property {number|int} signature_location
 @property {number|int} user
 @property {text|string} user_binary_id
 */
/**
 @typedef {Object.<any>} Signatures_Has
 */
/**
 @typedef {Object.<any>} Signatures_Is
 @property {Transactions_Collections_Object} transaction_collections
 @property {Transactions_Signatures_Locations_Object} transaction_signature_locations
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Signatures_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} signature
 @property {string} signature_error
 @property {?number|int} signature_location
 @property {string} signature_location_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {Transactions_Collections_Object} transaction_collections
 @property {Transactions_Signatures_Locations_Object} transaction_signature_locations
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Stripe_Charges
 @property {Stripe_Charges_Properties} properties
 @property {Stripe_Charges_Has} has
 @property {Stripe_Charges_Is} is
 @property {Stripe_Charges_Object} object
 */
/**
 @typedef {Object.<any>} Stripe_Charges_Properties
 @property {text|string} _id
 @property {number|int|float} amount
 @property {number|int|float} amount_refunded
 @property {text|string} binary_id
 @property {boolean} captured
 @property {text|string} card_address_city
 @property {text|string} card_address_country
 @property {text|string} card_address_line_1
 @property {text|string} card_address_line_2
 @property {text|string} card_address_state
 @property {text|string} card_address_zip
 @property {text|string} card_avs_line_1_status
 @property {text|string} card_avs_zip_status
 @property {text|string} card_brand
 @property {text|string} card_cvc_status
 @property {text|string} card_ex_month
 @property {text|string} card_ex_year
 @property {text|string} card_fingerprint
 @property {text|string} card_funding
 @property {text|string} card_id
 @property {text|string} card_issue_country
 @property {text|string} card_last_4
 @property {text|string} card_name
 @property {number|int|float} converted_amount
 @property {number|int|float} converted_amount_refunded
 @property {text|string} converted_currency
 @property {date|string} created
 @property {text|string} currency
 @property {text|string} customer_email
 @property {text|string} customer_id
 @property {text|string} description
 @property {number|int|float} fee
 @property {text|string} id
 @property {text|string} invoice_id
 @property {text|string} mode
 @property {number|int} pkey
 @property {text|string} statement_description
 @property {text|string} statement_descriptor
 @property {text|string} status
 @property {number|int|float} tax
 */
/**
 @typedef {Object.<any>} Stripe_Charges_Has
 */
/**
 @typedef {Object.<any>} Stripe_Charges_Is
 */
/**
 @typedef {Object.<any>} Stripe_Charges_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?number|int|float} amount_refunded
 @property {string} amount_refunded_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?boolean} captured
 @property {string} captured_error
 @property {?text|string} card_address_city
 @property {string} card_address_city_error
 @property {?text|string} card_address_country
 @property {string} card_address_country_error
 @property {?text|string} card_address_line_1
 @property {string} card_address_line_1_error
 @property {?text|string} card_address_line_2
 @property {string} card_address_line_2_error
 @property {?text|string} card_address_state
 @property {string} card_address_state_error
 @property {?text|string} card_address_zip
 @property {string} card_address_zip_error
 @property {?text|string} card_avs_line_1_status
 @property {string} card_avs_line_1_status_error
 @property {?text|string} card_avs_zip_status
 @property {string} card_avs_zip_status_error
 @property {?text|string} card_brand
 @property {string} card_brand_error
 @property {?text|string} card_cvc_status
 @property {string} card_cvc_status_error
 @property {?text|string} card_ex_month
 @property {string} card_ex_month_error
 @property {?text|string} card_ex_year
 @property {string} card_ex_year_error
 @property {?text|string} card_fingerprint
 @property {string} card_fingerprint_error
 @property {?text|string} card_funding
 @property {string} card_funding_error
 @property {?text|string} card_id
 @property {string} card_id_error
 @property {?text|string} card_issue_country
 @property {string} card_issue_country_error
 @property {?text|string} card_last_4
 @property {string} card_last_4_error
 @property {?text|string} card_name
 @property {string} card_name_error
 @property {?number|int|float} converted_amount
 @property {string} converted_amount_error
 @property {?number|int|float} converted_amount_refunded
 @property {string} converted_amount_refunded_error
 @property {?text|string} converted_currency
 @property {string} converted_currency_error
 @property {?date|string} created
 @property {string} created_error
 @property {?text|string} currency
 @property {string} currency_error
 @property {?text|string} customer_email
 @property {string} customer_email_error
 @property {?text|string} customer_id
 @property {string} customer_id_error
 @property {?text|string} description
 @property {string} description_error
 @property {?number|int|float} fee
 @property {string} fee_error
 @property {?text|string} id
 @property {string} id_error
 @property {?text|string} invoice_id
 @property {string} invoice_id_error
 @property {?text|string} mode
 @property {string} mode_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} statement_description
 @property {string} statement_description_error
 @property {?text|string} statement_descriptor
 @property {string} statement_descriptor_error
 @property {?text|string} status
 @property {string} status_error
 @property {?number|int|float} tax
 @property {string} tax_error
 */
/**
 @typedef {Object.<any>} Stripe_Subscriptions_All
 @property {Stripe_Subscriptions_All_Properties} properties
 @property {Stripe_Subscriptions_All_Has} has
 @property {Stripe_Subscriptions_All_Is} is
 @property {Stripe_Subscriptions_All_Object} object
 */
/**
 @typedef {Object.<any>} Stripe_Subscriptions_All_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} created
 @property {date|string} current_period_end
 @property {date|string} current_period_start
 @property {text|string} customer
 @property {string} items
 @property {string} metadata
 @property {number|int} pkey
 @property {string} plan
 @property {text|string} status
 @property {text|string} stripe_id
 @property {date|string} subscription_created_date
 @property {date|string} subscription_ended_date
 @property {text|string} plan_name
 */
/**
 @typedef {Object.<any>} Stripe_Subscriptions_All_Has
 */
/**
 @typedef {Object.<any>} Stripe_Subscriptions_All_Is
 */
/**
 @typedef {Object.<any>} Stripe_Subscriptions_All_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?date|string} current_period_end
 @property {string} current_period_end_error
 @property {?date|string} current_period_start
 @property {string} current_period_start_error
 @property {?text|string} customer
 @property {string} customer_error
 @property {?string} items
 @property {string} items_error
 @property {?string} metadata
 @property {string} metadata_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?string} plan
 @property {string} plan_error
 @property {?text|string} status
 @property {string} status_error
 @property {?text|string} stripe_id
 @property {string} stripe_id_error
 @property {?date|string} subscription_created_date
 @property {string} subscription_created_date_error
 @property {?date|string} subscription_ended_date
 @property {string} subscription_ended_date_error
 @property {?text|string} plan_name
 @property {string} plan_name_error
 */
/**
 @typedef {Object.<any>} Subscriptions
 @property {Subscriptions_Properties} properties
 @property {Subscriptions_Has} has
 @property {Subscriptions_Is} is
 @property {Subscriptions_Object} object
 */
/**
 @typedef {Object.<any>} Subscriptions_Properties
 @property {text|string} _id
 @property {boolean} active
 @property {text|string} binary_id
 @property {text|string} code
 @property {text|string} description
 @property {text|string} id
 @property {number|int} pkey
 @property {text|string} price
 @property {number|int} sort
 */
/**
 @typedef {Object.<any>} Subscriptions_Has
 */
/**
 @typedef {Object.<any>} Subscriptions_Is
 */
/**
 @typedef {Object.<any>} Subscriptions_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?boolean} active
 @property {string} active_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} code
 @property {string} code_error
 @property {?text|string} description
 @property {string} description_error
 @property {?text|string} id
 @property {string} id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} price
 @property {string} price_error
 @property {?number|int} sort
 @property {string} sort_error
 */
/**
 @typedef {Object.<any>} Transaction_Upload
 @property {Transaction_Upload_Properties} properties
 @property {Transaction_Upload_Has} has
 @property {Transaction_Upload_Is} is
 @property {Transaction_Upload_Object} object
 */
/**
 @typedef {Object.<any>} Transaction_Upload_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {date|string} created
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {text|string} description
 @property {string} document_name
 @property {text|string} document_type
 @property {number|int} pkey
 @property {text|string} sent_to_cleo
 @property {number|int} transaction_entry
 @property {text|string} account_email
 @property {text|string} account_password
 @property {text|string} file_pkey
 */
/**
 @typedef {Object.<any>} Transaction_Upload_Has
 */
/**
 @typedef {Object.<any>} Transaction_Upload_Is
 @property {Customers_Object} customers
 @property {Transactions_Collections_Object} transaction_collections
 */
/**
 @typedef {Object.<any>} Transaction_Upload_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?text|string} description
 @property {string} description_error
 @property {?string} document_name
 @property {string} document_name_error
 @property {?text|string} document_type
 @property {string} document_type_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} sent_to_cleo
 @property {string} sent_to_cleo_error
 @property {?number|int} transaction_entry
 @property {string} transaction_entry_error
 @property {?text|string} account_email
 @property {string} account_email_error
 @property {?text|string} account_password
 @property {string} account_password_error
 @property {?text|string} file_pkey
 @property {string} file_pkey_error
 @property {Customers_Object} customers
 @property {Transactions_Collections_Object} transaction_collections
 */
/**
 @typedef {Object.<any>} Transactions
 @property {Transactions_Properties} properties
 @property {Transactions_Has} has
 @property {Transactions_Is} is
 @property {Transactions_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {number|int} caliber
 @property {text|string} caliber_other
 @property {boolean} cancelled
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {date|string} date
 @property {number|int} dealer
 @property {text|string} dealer_binary_id
 @property {number|int} entry
 @property {text|string} entry_binary_id
 @property {number|int} exporter
 @property {text|string} exporter_binary_id
 @property {number|int} internal
 @property {text|string} internal_binary_id
 @property {number|int} legal_entity
 @property {text|string} legal_entity_binary_id
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} manual_4473
 @property {number|int} manufacturer
 @property {text|string} manufacturer_other
 @property {text|string} model
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} notes
 @property {text|string} pawn_inventory
 @property {text|string} pawn_ticket
 @property {number|int} pkey
 @property {number|int} product
 @property {text|string} product_binary_id
 @property {text|string} product_type
 @property {boolean} returned
 @property {date|string} returned_date
 @property {text|string} serial_number
 @property {text|string} transaction
 @property {number|int} type
 @property {boolean} used_firearm
 */
/**
 @typedef {Object.<any>} Transactions_Has
 @property {Forms_Results_Object[]} forms
 @property {Multiple_Sales_Object[]} multiple_sales
 */
/**
 @typedef {Object.<any>} Transactions_Is
 @property {Calibers_Object} calibers
 @property {Customers_Object} customers
 @property {Dealers_Object} dealers
 @property {Exports_Object} exports
 @property {Legal_Entities_Object} legal_entities
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Transactions_Entries_Object} transaction_entries
 @property {Transactions_Types_Object} transaction_types
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?number|int} caliber
 @property {string} caliber_error
 @property {?text|string} caliber_other
 @property {string} caliber_other_error
 @property {?boolean} cancelled
 @property {string} cancelled_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?number|int} dealer
 @property {string} dealer_error
 @property {?text|string} dealer_binary_id
 @property {string} dealer_binary_id_error
 @property {?number|int} entry
 @property {string} entry_error
 @property {?text|string} entry_binary_id
 @property {string} entry_binary_id_error
 @property {?number|int} exporter
 @property {string} exporter_error
 @property {?text|string} exporter_binary_id
 @property {string} exporter_binary_id_error
 @property {?number|int} internal
 @property {string} internal_error
 @property {?text|string} internal_binary_id
 @property {string} internal_binary_id_error
 @property {?number|int} legal_entity
 @property {string} legal_entity_error
 @property {?text|string} legal_entity_binary_id
 @property {string} legal_entity_binary_id_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} manual_4473
 @property {string} manual_4473_error
 @property {?number|int} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} manufacturer_other
 @property {string} manufacturer_other_error
 @property {?text|string} model
 @property {string} model_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} pawn_inventory
 @property {string} pawn_inventory_error
 @property {?text|string} pawn_ticket
 @property {string} pawn_ticket_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} product_binary_id
 @property {string} product_binary_id_error
 @property {?text|string} product_type
 @property {string} product_type_error
 @property {?boolean} returned
 @property {string} returned_error
 @property {?date|string} returned_date
 @property {string} returned_date_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} transaction
 @property {string} transaction_error
 @property {?number|int} type
 @property {string} type_error
 @property {?boolean} used_firearm
 @property {string} used_firearm_error
 @property {Forms_Results_Object[]} forms
 @property {Multiple_Sales_Object[]} multiple_sales
 @property {Calibers_Object} calibers
 @property {Customers_Object} customers
 @property {Dealers_Object} dealers
 @property {Exports_Object} exports
 @property {Legal_Entities_Object} legal_entities
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Transactions_Entries_Object} transaction_entries
 @property {Transactions_Types_Object} transaction_types
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Collections
 @property {Transactions_Collections_Properties} properties
 @property {Transactions_Collections_Has} has
 @property {Transactions_Collections_Is} is
 @property {Transactions_Collections_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Collections_Properties
 @property {text|string} _id
 @property {date|string} background_checked
 @property {number|int} background_checker
 @property {text|string} background_checker_binary_id
 @property {text|string} binary_id
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {boolean} cancelled
 @property {text|string} change_note
 @property {text|string} cpl_number
 @property {date|string} created
 @property {text|string} created_first_name
 @property {text|string} created_last_name
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {text|string} customer_city
 @property {text|string} customer_city_limits
 @property {text|string} customer_county
 @property {text|string} customer_military_city
 @property {text|string} customer_military_county
 @property {text|string} customer_military_pcs_basename
 @property {text|string} customer_military_pcs_city
 @property {date|string} customer_military_pcs_date
 @property {text|string} customer_military_pcs_order_number
 @property {text|string} customer_military_pcs_state
 @property {text|string} customer_military_state
 @property {text|string} customer_military_street_1
 @property {text|string} customer_military_street_2
 @property {text|string} customer_military_zip
 @property {text|string} customer_name_company
 @property {text|string} customer_name_first
 @property {text|string} customer_name_last
 @property {text|string} customer_name_middle
 @property {text|string} customer_name_suffix
 @property {text|string} customer_state
 @property {text|string} customer_street_1
 @property {text|string} customer_street_2
 @property {text|string} customer_zip
 @property {date|string} date
 @property {number|int} dealer
 @property {text|string} dealer_binary_id
 @property {text|string} dealer_ffl
 @property {text|string} dealer_name_company
 @property {number|int} event
 @property {text|string} event_binary_id
 @property {number|int} exporter
 @property {text|string} exporter_address
 @property {text|string} exporter_binary_id
 @property {text|string} exporter_name
 @property {boolean} ghost
 @property {boolean} has_combined
 @property {text|string} identification_image
 @property {text|string} identification_image_back
 @property {boolean} imported
 @property {number|int} importer
 @property {text|string} importer_binary_id
 @property {text|string} importer_ffl
 @property {text|string} importer_full_address
 @property {text|string} importer_name_display
 @property {text|string} incident_number
 @property {number|int} internal
 @property {text|string} internal_binary_id
 @property {number|int} legal_entity
 @property {text|string} legal_entity_binary_id
 @property {text|string} legal_entity_city
 @property {text|string} legal_entity_county
 @property {text|string} legal_entity_name
 @property {text|string} legal_entity_state
 @property {text|string} legal_entity_street_1
 @property {text|string} legal_entity_street_2
 @property {text|string} legal_entity_zip
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} maker_city
 @property {text|string} maker_state
 @property {text|string} maker_street_1
 @property {text|string} maker_street_2
 @property {text|string} maker_zip
 @property {text|string} manual_4473
 @property {boolean} manufacturing
 @property {text|string} mcoles_number
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} notes
 @property {text|string} pawn_inventory
 @property {boolean} pawn_redemption
 @property {text|string} pawn_ticket
 @property {date|string} permit_expiration_date
 @property {text|string} permit_image
 @property {text|string} permit_image_back
 @property {text|string} permit_number
 @property {number|int} pkey
 @property {boolean} private_party_transfer
 @property {boolean} returned
 @property {date|string} returned_date
 @property {text|string} transaction
 @property {boolean} transfer_internal_sent
 @property {text|string} transfer_notification_email
 @property {number|int} type
 @property {text|string} type_of_notice
 @property {array} caliber_others
 @property {text|string} collection
 @property {text|string} collection_binary_id
 @property {text|string} disposed_to
 @property {text|string} foreign_order_id
 @property {boolean} is_military
 @property {number|int} kiosk
 @property {text|string} kiosk_binary_id
 @property {array} manufacturer_others
 @property {array} models
 @property {text|string} old_dealer_ffl
 @property {array} products
 @property {array} serial_numbers
 @property {string} signature_30
 @property {date|string} signature_30_date
 @property {array} types
 */
/**
 @typedef {Object.<any>} Transactions_Collections_Has
 @property {Forms_Results_Object[]} form_resultss
 @property {Multiple_Sales_Object[]} multiple_saless
 @property {Signatures_Object[]} signaturess
 @property {Transactions_Entries_Object[]} transaction_entriess
 @property {Transactions_Nics_Object[]} transaction_nicss
 @property {Transactions_Questions_Object[]} transaction_questionss
 @property {Transactions_Signatures_Object[]} transaction_signaturess
 */
/**
 @typedef {Object.<any>} Transactions_Collections_Is
 @property {Customers_Object} customers
 @property {Dealers_Object} dealers
 @property {Events_Object} events
 @property {Exports_Object} exports
 @property {Importers_Object} importers
 @property {Kiosks_Object} kiosks
 @property {Legal_Entities_Object} legal_entities
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations_related_by_internal
 @property {Locations_Object} locations_related_by_location
 @property {Transactions_Types_Object} transaction_types
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Collections_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?date|string} background_checked
 @property {string} background_checked_error
 @property {?number|int} background_checker
 @property {string} background_checker_error
 @property {?text|string} background_checker_binary_id
 @property {string} background_checker_binary_id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?boolean} cancelled
 @property {string} cancelled_error
 @property {?text|string} change_note
 @property {string} change_note_error
 @property {?text|string} cpl_number
 @property {string} cpl_number_error
 @property {?date|string} created
 @property {string} created_error
 @property {?text|string} created_first_name
 @property {string} created_first_name_error
 @property {?text|string} created_last_name
 @property {string} created_last_name_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?text|string} customer_city
 @property {string} customer_city_error
 @property {?text|string} customer_city_limits
 @property {string} customer_city_limits_error
 @property {?text|string} customer_county
 @property {string} customer_county_error
 @property {?text|string} customer_military_city
 @property {string} customer_military_city_error
 @property {?text|string} customer_military_county
 @property {string} customer_military_county_error
 @property {?text|string} customer_military_pcs_basename
 @property {string} customer_military_pcs_basename_error
 @property {?text|string} customer_military_pcs_city
 @property {string} customer_military_pcs_city_error
 @property {?date|string} customer_military_pcs_date
 @property {string} customer_military_pcs_date_error
 @property {?text|string} customer_military_pcs_order_number
 @property {string} customer_military_pcs_order_number_error
 @property {?text|string} customer_military_pcs_state
 @property {string} customer_military_pcs_state_error
 @property {?text|string} customer_military_state
 @property {string} customer_military_state_error
 @property {?text|string} customer_military_street_1
 @property {string} customer_military_street_1_error
 @property {?text|string} customer_military_street_2
 @property {string} customer_military_street_2_error
 @property {?text|string} customer_military_zip
 @property {string} customer_military_zip_error
 @property {?text|string} customer_name_company
 @property {string} customer_name_company_error
 @property {?text|string} customer_name_first
 @property {string} customer_name_first_error
 @property {?text|string} customer_name_last
 @property {string} customer_name_last_error
 @property {?text|string} customer_name_middle
 @property {string} customer_name_middle_error
 @property {?text|string} customer_name_suffix
 @property {string} customer_name_suffix_error
 @property {?text|string} customer_state
 @property {string} customer_state_error
 @property {?text|string} customer_street_1
 @property {string} customer_street_1_error
 @property {?text|string} customer_street_2
 @property {string} customer_street_2_error
 @property {?text|string} customer_zip
 @property {string} customer_zip_error
 @property {?date|string} date
 @property {string} date_error
 @property {?number|int} dealer
 @property {string} dealer_error
 @property {?text|string} dealer_binary_id
 @property {string} dealer_binary_id_error
 @property {?text|string} dealer_ffl
 @property {string} dealer_ffl_error
 @property {?text|string} dealer_name_company
 @property {string} dealer_name_company_error
 @property {?number|int} event
 @property {string} event_error
 @property {?text|string} event_binary_id
 @property {string} event_binary_id_error
 @property {?number|int} exporter
 @property {string} exporter_error
 @property {?text|string} exporter_address
 @property {string} exporter_address_error
 @property {?text|string} exporter_binary_id
 @property {string} exporter_binary_id_error
 @property {?text|string} exporter_name
 @property {string} exporter_name_error
 @property {?boolean} ghost
 @property {string} ghost_error
 @property {?boolean} has_combined
 @property {string} has_combined_error
 @property {?text|string} identification_image
 @property {string} identification_image_error
 @property {?text|string} identification_image_back
 @property {string} identification_image_back_error
 @property {?boolean} imported
 @property {string} imported_error
 @property {?number|int} importer
 @property {string} importer_error
 @property {?text|string} importer_binary_id
 @property {string} importer_binary_id_error
 @property {?text|string} importer_ffl
 @property {string} importer_ffl_error
 @property {?text|string} importer_full_address
 @property {string} importer_full_address_error
 @property {?text|string} importer_name_display
 @property {string} importer_name_display_error
 @property {?text|string} incident_number
 @property {string} incident_number_error
 @property {?number|int} internal
 @property {string} internal_error
 @property {?text|string} internal_binary_id
 @property {string} internal_binary_id_error
 @property {?number|int} legal_entity
 @property {string} legal_entity_error
 @property {?text|string} legal_entity_binary_id
 @property {string} legal_entity_binary_id_error
 @property {?text|string} legal_entity_city
 @property {string} legal_entity_city_error
 @property {?text|string} legal_entity_county
 @property {string} legal_entity_county_error
 @property {?text|string} legal_entity_name
 @property {string} legal_entity_name_error
 @property {?text|string} legal_entity_state
 @property {string} legal_entity_state_error
 @property {?text|string} legal_entity_street_1
 @property {string} legal_entity_street_1_error
 @property {?text|string} legal_entity_street_2
 @property {string} legal_entity_street_2_error
 @property {?text|string} legal_entity_zip
 @property {string} legal_entity_zip_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} maker_city
 @property {string} maker_city_error
 @property {?text|string} maker_state
 @property {string} maker_state_error
 @property {?text|string} maker_street_1
 @property {string} maker_street_1_error
 @property {?text|string} maker_street_2
 @property {string} maker_street_2_error
 @property {?text|string} maker_zip
 @property {string} maker_zip_error
 @property {?text|string} manual_4473
 @property {string} manual_4473_error
 @property {?boolean} manufacturing
 @property {string} manufacturing_error
 @property {?text|string} mcoles_number
 @property {string} mcoles_number_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} pawn_inventory
 @property {string} pawn_inventory_error
 @property {?boolean} pawn_redemption
 @property {string} pawn_redemption_error
 @property {?text|string} pawn_ticket
 @property {string} pawn_ticket_error
 @property {?date|string} permit_expiration_date
 @property {string} permit_expiration_date_error
 @property {?text|string} permit_image
 @property {string} permit_image_error
 @property {?text|string} permit_image_back
 @property {string} permit_image_back_error
 @property {?text|string} permit_number
 @property {string} permit_number_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} private_party_transfer
 @property {string} private_party_transfer_error
 @property {?boolean} returned
 @property {string} returned_error
 @property {?date|string} returned_date
 @property {string} returned_date_error
 @property {?text|string} transaction
 @property {string} transaction_error
 @property {?boolean} transfer_internal_sent
 @property {string} transfer_internal_sent_error
 @property {?text|string} transfer_notification_email
 @property {string} transfer_notification_email_error
 @property {?number|int} type
 @property {string} type_error
 @property {?text|string} type_of_notice
 @property {string} type_of_notice_error
 @property {?array} caliber_others
 @property {string} caliber_others_error
 @property {?text|string} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?text|string} disposed_to
 @property {string} disposed_to_error
 @property {?text|string} foreign_order_id
 @property {string} foreign_order_id_error
 @property {?boolean} is_military
 @property {string} is_military_error
 @property {?number|int} kiosk
 @property {string} kiosk_error
 @property {?text|string} kiosk_binary_id
 @property {string} kiosk_binary_id_error
 @property {?array} manufacturer_others
 @property {string} manufacturer_others_error
 @property {?array} models
 @property {string} models_error
 @property {?text|string} old_dealer_ffl
 @property {string} old_dealer_ffl_error
 @property {?array} products
 @property {string} products_error
 @property {?array} serial_numbers
 @property {string} serial_numbers_error
 @property {?string} signature_30
 @property {string} signature_30_error
 @property {?date|string} signature_30_date
 @property {string} signature_30_date_error
 @property {?array} types
 @property {string} types_error
 @property {Forms_Results_Object[]} form_resultss
 @property {Multiple_Sales_Object[]} multiple_saless
 @property {Signatures_Object[]} signaturess
 @property {Transactions_Entries_Object[]} transaction_entriess
 @property {Transactions_Nics_Object[]} transaction_nicss
 @property {Transactions_Questions_Object[]} transaction_questionss
 @property {Transactions_Signatures_Object[]} transaction_signaturess
 @property {Customers_Object} customers
 @property {Dealers_Object} dealers
 @property {Events_Object} events
 @property {Exports_Object} exports
 @property {Importers_Object} importers
 @property {Kiosks_Object} kiosks
 @property {Legal_Entities_Object} legal_entities
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations_related_by_internal
 @property {Locations_Object} locations_related_by_location
 @property {Transactions_Types_Object} transaction_types
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Collections_Forms
 @property {Transactions_Collections_Forms_Properties} properties
 @property {Transactions_Collections_Forms_Has} has
 @property {Transactions_Collections_Forms_Is} is
 @property {Transactions_Collections_Forms_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Collections_Forms_Properties
 @property {text|string} _id
 @property {string} amended
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {number|int} disposition_pending
 @property {text|string} disposition_pending_binary_id
 @property {text|string} filename
 @property {number|int} form
 @property {number|int} form_p12
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} payment
 @property {number|int} pkey
 @property {number|int} product
 @property {text|string} product_binary_id
 @property {number|int} quarter
 @property {string} results
 @property {boolean} sent_atf
 @property {boolean} sent_cleo
 @property {text|string} sent_cleo_email
 @property {text|string} type
 @property {text|string} year
 @property {boolean} has_notes
 @property {boolean} send_email
 */
/**
 @typedef {Object.<any>} Transactions_Collections_Forms_Has
 */
/**
 @typedef {Object.<any>} Transactions_Collections_Forms_Is
 @property {Customers_Object} customers
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Form_P12s_Object} form_p12s
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Transactions_Collections_Forms_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?string} amended
 @property {string} amended_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?number|int} disposition_pending
 @property {string} disposition_pending_error
 @property {?text|string} disposition_pending_binary_id
 @property {string} disposition_pending_binary_id_error
 @property {?text|string} filename
 @property {string} filename_error
 @property {?number|int} form
 @property {string} form_error
 @property {?number|int} form_p12
 @property {string} form_p12_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} payment
 @property {string} payment_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} product_binary_id
 @property {string} product_binary_id_error
 @property {?number|int} quarter
 @property {string} quarter_error
 @property {?string} results
 @property {string} results_error
 @property {?boolean} sent_atf
 @property {string} sent_atf_error
 @property {?boolean} sent_cleo
 @property {string} sent_cleo_error
 @property {?text|string} sent_cleo_email
 @property {string} sent_cleo_email_error
 @property {?text|string} type
 @property {string} type_error
 @property {?text|string} year
 @property {string} year_error
 @property {?boolean} has_notes
 @property {string} has_notes_error
 @property {?boolean} send_email
 @property {string} send_email_error
 @property {Customers_Object} customers
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Form_P12s_Object} form_p12s
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Transactions_Entries
 @property {Transactions_Entries_Properties} properties
 @property {Transactions_Entries_Has} has
 @property {Transactions_Entries_Is} is
 @property {Transactions_Entries_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Entries_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {boolean} cancelled
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {boolean} ignore_multisale
 @property {boolean} pawn_redemption
 @property {number|int} pkey
 @property {number|int} previous
 @property {text|string} previous_binary_id
 @property {number|int} product
 @property {text|string} product_binary_id
 @property {number|int} related
 @property {text|string} related_binary_id
 */
/**
 @typedef {Object.<any>} Transactions_Entries_Has
 */
/**
 @typedef {Object.<any>} Transactions_Entries_Is
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Transactions_Entries_Object} transaction_entries_related_by_previous
 @property {Transactions_Entries_Object} transaction_entries_related_by_related
 */
/**
 @typedef {Object.<any>} Transactions_Entries_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?boolean} cancelled
 @property {string} cancelled_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?boolean} ignore_multisale
 @property {string} ignore_multisale_error
 @property {?boolean} pawn_redemption
 @property {string} pawn_redemption_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} previous
 @property {string} previous_error
 @property {?text|string} previous_binary_id
 @property {string} previous_binary_id_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} product_binary_id
 @property {string} product_binary_id_error
 @property {?number|int} related
 @property {string} related_error
 @property {?text|string} related_binary_id
 @property {string} related_binary_id_error
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Transactions_Entries_Object} transaction_entries_related_by_previous
 @property {Transactions_Entries_Object} transaction_entries_related_by_related
 */
/**
 @typedef {Object.<any>} Acquisitions_Incomings
 @property {Acquisitions_Incomings_Properties} properties
 @property {Acquisitions_Incomings_Has} has
 @property {Acquisitions_Incomings_Is} is
 @property {Acquisitions_Incomings_Object} object
 */
/**
 @typedef {Object.<any>} Acquisitions_Incomings_Properties
 @property {text|string} _id
 @property {text|string} barrel_length
 @property {text|string} binary_id
 @property {number|int} caliber
 @property {text|string} caliber_other
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} customer_email
 @property {text|string} customer_name
 @property {text|string} customer_phone
 @property {date|string} date
 @property {email} email
 @property {text|string} ffl_name
 @property {text|string} ffl_number
 @property {text|string} importer
 @property {text|string} item_description
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {number|int} manufacturer
 @property {text|string} manufacturer_other
 @property {text|string} model
 @property {text|string} order_number
 @property {text|string} overall_length
 @property {text|string} phone
 @property {number|int} pkey
 @property {text|string} serial_number
 @property {text|string} sku
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} type
 @property {boolean} used_firearm
 @property {number|int} vendor
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Acquisitions_Incomings_Has
 */
/**
 @typedef {Object.<any>} Acquisitions_Incomings_Is
 @property {Calibers_Object} calibers
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Vendors_Object} vendors
 */
/**
 @typedef {Object.<any>} Acquisitions_Incomings_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} barrel_length
 @property {string} barrel_length_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} caliber
 @property {string} caliber_error
 @property {?text|string} caliber_other
 @property {string} caliber_other_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} customer_email
 @property {string} customer_email_error
 @property {?text|string} customer_name
 @property {string} customer_name_error
 @property {?text|string} customer_phone
 @property {string} customer_phone_error
 @property {?date|string} date
 @property {string} date_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} ffl_name
 @property {string} ffl_name_error
 @property {?text|string} ffl_number
 @property {string} ffl_number_error
 @property {?text|string} importer
 @property {string} importer_error
 @property {?text|string} item_description
 @property {string} item_description_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?number|int} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} manufacturer_other
 @property {string} manufacturer_other_error
 @property {?text|string} model
 @property {string} model_error
 @property {?text|string} order_number
 @property {string} order_number_error
 @property {?text|string} overall_length
 @property {string} overall_length_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} type
 @property {string} type_error
 @property {?boolean} used_firearm
 @property {string} used_firearm_error
 @property {?number|int} vendor
 @property {string} vendor_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Calibers_Object} calibers
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Vendors_Object} vendors
 */
/**
 @typedef {Object.<any>} Transactions_Logs
 @property {Transactions_Logs_Properties} properties
 @property {Transactions_Logs_Has} has
 @property {Transactions_Logs_Is} is
 @property {Transactions_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Logs_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {date|string} date
 @property {text|string} display_new
 @property {text|string} display_old
 @property {text|string} field
 @property {number|int} fkey
 @property {text|string} fkey_binary_id
 @property {text|string} note
 @property {text|string} o_table
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} user_binary_id
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Transactions_Logs_Has
 */
/**
 @typedef {Object.<any>} Transactions_Logs_Is
 @property {Customers_Object} customers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Transactions_Logs_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} display_new
 @property {string} display_new_error
 @property {?text|string} display_old
 @property {string} display_old_error
 @property {?text|string} field
 @property {string} field_error
 @property {?number|int} fkey
 @property {string} fkey_error
 @property {?text|string} fkey_binary_id
 @property {string} fkey_binary_id_error
 @property {?text|string} note
 @property {string} note_error
 @property {?text|string} o_table
 @property {string} o_table_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Customers_Object} customers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Transactions_Nics
 @property {Transactions_Nics_Properties} properties
 @property {Transactions_Nics_Has} has
 @property {Transactions_Nics_Is} is
 @property {Transactions_Nics_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Nics_Properties
 @property {text|string} _id
 @property {text|string} after_response
 @property {date|string} after_response_date
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {date|string} delayed_date
 @property {text|string} delayed_response
 @property {date|string} delayed_under_21_date
 @property {text|string} examiner_brady
 @property {text|string} examiner_name
 @property {boolean} following_cancelled
 @property {date|string} following_cancelled_date
 @property {boolean} following_denied
 @property {date|string} following_denied_date
 @property {boolean} following_proceed
 @property {date|string} following_proceed_date
 @property {boolean} following_under_21_no_response
 @property {date|string} mdi_date
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {boolean} national_fire_arms_act
 @property {date|string} nics_date
 @property {text|string} nics_number
 @property {text|string} nics_response
 @property {boolean} no_response
 @property {boolean} overturned
 @property {date|string} overturned_date
 @property {date|string} permit_date
 @property {date|string} permit_expiration
 @property {text|string} permit_number
 @property {text|string} permit_state
 @property {text|string} permit_type
 @property {number|int} pkey
 @property {boolean} valid_permit
 */
/**
 @typedef {Object.<any>} Transactions_Nics_Has
 */
/**
 @typedef {Object.<any>} Transactions_Nics_Is
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Transactions_Nics_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} after_response
 @property {string} after_response_error
 @property {?date|string} after_response_date
 @property {string} after_response_date_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?date|string} delayed_date
 @property {string} delayed_date_error
 @property {?text|string} delayed_response
 @property {string} delayed_response_error
 @property {?date|string} delayed_under_21_date
 @property {string} delayed_under_21_date_error
 @property {?text|string} examiner_brady
 @property {string} examiner_brady_error
 @property {?text|string} examiner_name
 @property {string} examiner_name_error
 @property {?boolean} following_cancelled
 @property {string} following_cancelled_error
 @property {?date|string} following_cancelled_date
 @property {string} following_cancelled_date_error
 @property {?boolean} following_denied
 @property {string} following_denied_error
 @property {?date|string} following_denied_date
 @property {string} following_denied_date_error
 @property {?boolean} following_proceed
 @property {string} following_proceed_error
 @property {?date|string} following_proceed_date
 @property {string} following_proceed_date_error
 @property {?boolean} following_under_21_no_response
 @property {string} following_under_21_no_response_error
 @property {?date|string} mdi_date
 @property {string} mdi_date_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?boolean} national_fire_arms_act
 @property {string} national_fire_arms_act_error
 @property {?date|string} nics_date
 @property {string} nics_date_error
 @property {?text|string} nics_number
 @property {string} nics_number_error
 @property {?text|string} nics_response
 @property {string} nics_response_error
 @property {?boolean} no_response
 @property {string} no_response_error
 @property {?boolean} overturned
 @property {string} overturned_error
 @property {?date|string} overturned_date
 @property {string} overturned_date_error
 @property {?date|string} permit_date
 @property {string} permit_date_error
 @property {?date|string} permit_expiration
 @property {string} permit_expiration_error
 @property {?text|string} permit_number
 @property {string} permit_number_error
 @property {?text|string} permit_state
 @property {string} permit_state_error
 @property {?text|string} permit_type
 @property {string} permit_type_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} valid_permit
 @property {string} valid_permit_error
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings
 @property {Dispositions_Pendings_Properties} properties
 @property {Dispositions_Pendings_Has} has
 @property {Dispositions_Pendings_Is} is
 @property {Dispositions_Pendings_Object} object
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Properties
 @property {text|string} _id
 @property {boolean} actual_intention
 @property {boolean} actual_intention_felony
 @property {boolean} actual_transferee
 @property {text|string} after_response
 @property {date|string} after_response_date
 @property {text|string} alien_number
 @property {text|string} alternate_documentation
 @property {date|string} background_checked
 @property {number|int} background_checker
 @property {text|string} background_checker_binary_id
 @property {text|string} binary_id
 @property {text|string} birth_city
 @property {text|string} birth_country
 @property {date|string} birth_date
 @property {text|string} birth_state
 @property {text|string} city
 @property {text|string} city_limits
 @property {text|string} county
 @property {text|string} cpl_number
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {boolean} customer_completed
 @property {date|string} date
 @property {date|string} delayed_date
 @property {text|string} delayed_response
 @property {date|string} delayed_under_21_date
 @property {boolean} dishonorable_discharge
 @property {boolean} dl_scan_toggle
 @property {boolean} domestic_violence
 @property {boolean} drug_user
 @property {boolean} editing
 @property {text|string} email
 @property {boolean} ethnicity_hispanic
 @property {number|int} event
 @property {text|string} event_binary_id
 @property {text|string} examiner_brady
 @property {text|string} examiner_name
 @property {boolean} fall_within_exceptions
 @property {boolean} felony_convicted
 @property {boolean} felony_indictment
 @property {boolean} following_cancelled
 @property {date|string} following_cancelled_date
 @property {boolean} following_denied
 @property {date|string} following_denied_date
 @property {boolean} following_proceed
 @property {date|string} following_proceed_date
 @property {boolean} following_under_21_no_response
 @property {text|string} foreign_citizenship
 @property {number|int} form
 @property {boolean} fugitive
 @property {text|string} gender
 @property {number|int} height_ft
 @property {number|int} height_in
 @property {text|string} identification_authority
 @property {date|string} identification_expiration
 @property {string} identification_image
 @property {string} identification_image_back
 @property {date|string} identification_issue
 @property {text|string} identification_number
 @property {text|string} identification_type
 @property {boolean} ignore_duplicate
 @property {boolean} illegal_alien
 @property {text|string} items
 @property {number|int} kiosk
 @property {text|string} kiosk_binary_id
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} mcoles_number
 @property {date|string} mdi_date
 @property {boolean} mentally_stable
 @property {text|string} military_city
 @property {text|string} military_county
 @property {text|string} military_pcs_basename
 @property {text|string} military_pcs_city
 @property {date|string} military_pcs_date
 @property {text|string} military_pcs_order_number
 @property {text|string} military_pcs_state
 @property {text|string} military_state
 @property {text|string} military_street_1
 @property {text|string} military_street_2
 @property {text|string} military_zip
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_middle
 @property {text|string} name_suffix
 @property {boolean} national_fire_arms_act
 @property {date|string} nics_date
 @property {text|string} nics_number
 @property {text|string} nics_response
 @property {boolean} no_response
 @property {boolean} nonimmigrant_visa
 @property {text|string} nonimmigrant_visa_prohibition
 @property {text|string} notes
 @property {text|string} number
 @property {boolean} overturned
 @property {date|string} overturned_date
 @property {boolean} partial
 @property {boolean} paused
 @property {boolean} pawn_redemption
 @property {number|int} pending
 @property {text|string} pending_binary_id
 @property {date|string} permit_date
 @property {date|string} permit_expiration
 @property {string} permit_image
 @property {string} permit_image_back
 @property {text|string} permit_number
 @property {text|string} permit_state
 @property {text|string} permit_type
 @property {number|int} pkey
 @property {boolean} private_party_transfer
 @property {boolean} race_african_american
 @property {boolean} race_american_indian
 @property {boolean} race_asian
 @property {boolean} race_native_hawaiian
 @property {boolean} race_white
 @property {boolean} renounced_citizenship
 @property {boolean} restraining_order
 @property {string} signature_14
 @property {date|string} signature_14_date
 @property {string} signature_22
 @property {date|string} signature_22_date
 @property {string} signature_35
 @property {date|string} signature_35_date
 @property {text|string} ssn
 @property {text|string} state
 @property {text|string} state_of_residence
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} transaction_purposes
 @property {text|string} upin
 @property {boolean} us_born
 @property {boolean} us_citizen
 @property {boolean} valid_permit
 @property {number|int} weight
 @property {text|string} zip
 @property {array} customers_existing
 @property {boolean} duplicate_customer
 @property {boolean} ignore_actual_transferee
 @property {boolean} ignore_dishonorable_discharge
 @property {boolean} ignore_domestic_violence
 @property {boolean} ignore_drug_user
 @property {boolean} ignore_expired_nics_date
 @property {boolean} ignore_expired_pending_date
 @property {boolean} ignore_fall_within_exceptions
 @property {boolean} ignore_felony_convicted
 @property {boolean} ignore_felony_indictment
 @property {boolean} ignore_fugitive
 @property {boolean} ignore_identification_expired
 @property {boolean} ignore_identification_future_issued
 @property {boolean} ignore_illegal_alien
 @property {boolean} ignore_mentally_stable
 @property {boolean} ignore_nonimmigrant_visa
 @property {boolean} ignore_out_of_state
 @property {boolean} ignore_permit_expired
 @property {boolean} ignore_permit_future_issued
 @property {boolean} ignore_possible_duplicate_customer
 @property {boolean} ignore_renounced_citizenship
 @property {boolean} ignore_restraining_order
 @property {boolean} ignore_under_age
 @property {boolean} ignore_under_eighteen
 @property {boolean} is_military
 @property {text|string} manager_password
 @property {array} products
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Has
 @property {Dispositions_Pendings_Items_Object[]} disposition_pending_itemss
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Is
 @property {Customers_Object} customers
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Events_Object} events
 @property {Kiosks_Object} kiosks
 @property {Locations_Object} locations
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?boolean} actual_intention
 @property {string} actual_intention_error
 @property {?boolean} actual_intention_felony
 @property {string} actual_intention_felony_error
 @property {?boolean} actual_transferee
 @property {string} actual_transferee_error
 @property {?text|string} after_response
 @property {string} after_response_error
 @property {?date|string} after_response_date
 @property {string} after_response_date_error
 @property {?text|string} alien_number
 @property {string} alien_number_error
 @property {?text|string} alternate_documentation
 @property {string} alternate_documentation_error
 @property {?date|string} background_checked
 @property {string} background_checked_error
 @property {?number|int} background_checker
 @property {string} background_checker_error
 @property {?text|string} background_checker_binary_id
 @property {string} background_checker_binary_id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} birth_city
 @property {string} birth_city_error
 @property {?text|string} birth_country
 @property {string} birth_country_error
 @property {?date|string} birth_date
 @property {string} birth_date_error
 @property {?text|string} birth_state
 @property {string} birth_state_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?text|string} county
 @property {string} county_error
 @property {?text|string} cpl_number
 @property {string} cpl_number_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?boolean} customer_completed
 @property {string} customer_completed_error
 @property {?date|string} date
 @property {string} date_error
 @property {?date|string} delayed_date
 @property {string} delayed_date_error
 @property {?text|string} delayed_response
 @property {string} delayed_response_error
 @property {?date|string} delayed_under_21_date
 @property {string} delayed_under_21_date_error
 @property {?boolean} dishonorable_discharge
 @property {string} dishonorable_discharge_error
 @property {?boolean} dl_scan_toggle
 @property {string} dl_scan_toggle_error
 @property {?boolean} domestic_violence
 @property {string} domestic_violence_error
 @property {?boolean} drug_user
 @property {string} drug_user_error
 @property {?boolean} editing
 @property {string} editing_error
 @property {?text|string} email
 @property {string} email_error
 @property {?boolean} ethnicity_hispanic
 @property {string} ethnicity_hispanic_error
 @property {?number|int} event
 @property {string} event_error
 @property {?text|string} event_binary_id
 @property {string} event_binary_id_error
 @property {?text|string} examiner_brady
 @property {string} examiner_brady_error
 @property {?text|string} examiner_name
 @property {string} examiner_name_error
 @property {?boolean} fall_within_exceptions
 @property {string} fall_within_exceptions_error
 @property {?boolean} felony_convicted
 @property {string} felony_convicted_error
 @property {?boolean} felony_indictment
 @property {string} felony_indictment_error
 @property {?boolean} following_cancelled
 @property {string} following_cancelled_error
 @property {?date|string} following_cancelled_date
 @property {string} following_cancelled_date_error
 @property {?boolean} following_denied
 @property {string} following_denied_error
 @property {?date|string} following_denied_date
 @property {string} following_denied_date_error
 @property {?boolean} following_proceed
 @property {string} following_proceed_error
 @property {?date|string} following_proceed_date
 @property {string} following_proceed_date_error
 @property {?boolean} following_under_21_no_response
 @property {string} following_under_21_no_response_error
 @property {?text|string} foreign_citizenship
 @property {string} foreign_citizenship_error
 @property {?number|int} form
 @property {string} form_error
 @property {?boolean} fugitive
 @property {string} fugitive_error
 @property {?text|string} gender
 @property {string} gender_error
 @property {?number|int} height_ft
 @property {string} height_ft_error
 @property {?number|int} height_in
 @property {string} height_in_error
 @property {?text|string} identification_authority
 @property {string} identification_authority_error
 @property {?date|string} identification_expiration
 @property {string} identification_expiration_error
 @property {?string} identification_image
 @property {string} identification_image_error
 @property {?string} identification_image_back
 @property {string} identification_image_back_error
 @property {?date|string} identification_issue
 @property {string} identification_issue_error
 @property {?text|string} identification_number
 @property {string} identification_number_error
 @property {?text|string} identification_type
 @property {string} identification_type_error
 @property {?boolean} ignore_duplicate
 @property {string} ignore_duplicate_error
 @property {?boolean} illegal_alien
 @property {string} illegal_alien_error
 @property {?text|string} items
 @property {string} items_error
 @property {?number|int} kiosk
 @property {string} kiosk_error
 @property {?text|string} kiosk_binary_id
 @property {string} kiosk_binary_id_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} mcoles_number
 @property {string} mcoles_number_error
 @property {?date|string} mdi_date
 @property {string} mdi_date_error
 @property {?boolean} mentally_stable
 @property {string} mentally_stable_error
 @property {?text|string} military_city
 @property {string} military_city_error
 @property {?text|string} military_county
 @property {string} military_county_error
 @property {?text|string} military_pcs_basename
 @property {string} military_pcs_basename_error
 @property {?text|string} military_pcs_city
 @property {string} military_pcs_city_error
 @property {?date|string} military_pcs_date
 @property {string} military_pcs_date_error
 @property {?text|string} military_pcs_order_number
 @property {string} military_pcs_order_number_error
 @property {?text|string} military_pcs_state
 @property {string} military_pcs_state_error
 @property {?text|string} military_state
 @property {string} military_state_error
 @property {?text|string} military_street_1
 @property {string} military_street_1_error
 @property {?text|string} military_street_2
 @property {string} military_street_2_error
 @property {?text|string} military_zip
 @property {string} military_zip_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_middle
 @property {string} name_middle_error
 @property {?text|string} name_suffix
 @property {string} name_suffix_error
 @property {?boolean} national_fire_arms_act
 @property {string} national_fire_arms_act_error
 @property {?date|string} nics_date
 @property {string} nics_date_error
 @property {?text|string} nics_number
 @property {string} nics_number_error
 @property {?text|string} nics_response
 @property {string} nics_response_error
 @property {?boolean} no_response
 @property {string} no_response_error
 @property {?boolean} nonimmigrant_visa
 @property {string} nonimmigrant_visa_error
 @property {?text|string} nonimmigrant_visa_prohibition
 @property {string} nonimmigrant_visa_prohibition_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} number
 @property {string} number_error
 @property {?boolean} overturned
 @property {string} overturned_error
 @property {?date|string} overturned_date
 @property {string} overturned_date_error
 @property {?boolean} partial
 @property {string} partial_error
 @property {?boolean} paused
 @property {string} paused_error
 @property {?boolean} pawn_redemption
 @property {string} pawn_redemption_error
 @property {?number|int} pending
 @property {string} pending_error
 @property {?text|string} pending_binary_id
 @property {string} pending_binary_id_error
 @property {?date|string} permit_date
 @property {string} permit_date_error
 @property {?date|string} permit_expiration
 @property {string} permit_expiration_error
 @property {?string} permit_image
 @property {string} permit_image_error
 @property {?string} permit_image_back
 @property {string} permit_image_back_error
 @property {?text|string} permit_number
 @property {string} permit_number_error
 @property {?text|string} permit_state
 @property {string} permit_state_error
 @property {?text|string} permit_type
 @property {string} permit_type_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} private_party_transfer
 @property {string} private_party_transfer_error
 @property {?boolean} race_african_american
 @property {string} race_african_american_error
 @property {?boolean} race_american_indian
 @property {string} race_american_indian_error
 @property {?boolean} race_asian
 @property {string} race_asian_error
 @property {?boolean} race_native_hawaiian
 @property {string} race_native_hawaiian_error
 @property {?boolean} race_white
 @property {string} race_white_error
 @property {?boolean} renounced_citizenship
 @property {string} renounced_citizenship_error
 @property {?boolean} restraining_order
 @property {string} restraining_order_error
 @property {?string} signature_14
 @property {string} signature_14_error
 @property {?date|string} signature_14_date
 @property {string} signature_14_date_error
 @property {?string} signature_22
 @property {string} signature_22_error
 @property {?date|string} signature_22_date
 @property {string} signature_22_date_error
 @property {?string} signature_35
 @property {string} signature_35_error
 @property {?date|string} signature_35_date
 @property {string} signature_35_date_error
 @property {?text|string} ssn
 @property {string} ssn_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} state_of_residence
 @property {string} state_of_residence_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} transaction_purposes
 @property {string} transaction_purposes_error
 @property {?text|string} upin
 @property {string} upin_error
 @property {?boolean} us_born
 @property {string} us_born_error
 @property {?boolean} us_citizen
 @property {string} us_citizen_error
 @property {?boolean} valid_permit
 @property {string} valid_permit_error
 @property {?number|int} weight
 @property {string} weight_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?array} customers_existing
 @property {string} customers_existing_error
 @property {?boolean} duplicate_customer
 @property {string} duplicate_customer_error
 @property {?boolean} ignore_actual_transferee
 @property {string} ignore_actual_transferee_error
 @property {?boolean} ignore_dishonorable_discharge
 @property {string} ignore_dishonorable_discharge_error
 @property {?boolean} ignore_domestic_violence
 @property {string} ignore_domestic_violence_error
 @property {?boolean} ignore_drug_user
 @property {string} ignore_drug_user_error
 @property {?boolean} ignore_expired_nics_date
 @property {string} ignore_expired_nics_date_error
 @property {?boolean} ignore_expired_pending_date
 @property {string} ignore_expired_pending_date_error
 @property {?boolean} ignore_fall_within_exceptions
 @property {string} ignore_fall_within_exceptions_error
 @property {?boolean} ignore_felony_convicted
 @property {string} ignore_felony_convicted_error
 @property {?boolean} ignore_felony_indictment
 @property {string} ignore_felony_indictment_error
 @property {?boolean} ignore_fugitive
 @property {string} ignore_fugitive_error
 @property {?boolean} ignore_identification_expired
 @property {string} ignore_identification_expired_error
 @property {?boolean} ignore_identification_future_issued
 @property {string} ignore_identification_future_issued_error
 @property {?boolean} ignore_illegal_alien
 @property {string} ignore_illegal_alien_error
 @property {?boolean} ignore_mentally_stable
 @property {string} ignore_mentally_stable_error
 @property {?boolean} ignore_nonimmigrant_visa
 @property {string} ignore_nonimmigrant_visa_error
 @property {?boolean} ignore_out_of_state
 @property {string} ignore_out_of_state_error
 @property {?boolean} ignore_permit_expired
 @property {string} ignore_permit_expired_error
 @property {?boolean} ignore_permit_future_issued
 @property {string} ignore_permit_future_issued_error
 @property {?boolean} ignore_possible_duplicate_customer
 @property {string} ignore_possible_duplicate_customer_error
 @property {?boolean} ignore_renounced_citizenship
 @property {string} ignore_renounced_citizenship_error
 @property {?boolean} ignore_restraining_order
 @property {string} ignore_restraining_order_error
 @property {?boolean} ignore_under_age
 @property {string} ignore_under_age_error
 @property {?boolean} ignore_under_eighteen
 @property {string} ignore_under_eighteen_error
 @property {?boolean} is_military
 @property {string} is_military_error
 @property {?text|string} manager_password
 @property {string} manager_password_error
 @property {?array} products
 @property {string} products_error
 @property {Dispositions_Pendings_Items_Object[]} disposition_pending_itemss
 @property {Customers_Object} customers
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Events_Object} events
 @property {Kiosks_Object} kiosks
 @property {Locations_Object} locations
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Acquisitions_Pendings
 @property {Acquisitions_Pendings_Properties} properties
 @property {Acquisitions_Pendings_Has} has
 @property {Acquisitions_Pendings_Is} is
 @property {Acquisitions_Pendings_Object} object
 */
/**
 @typedef {Object.<any>} Acquisitions_Pendings_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} city
 @property {text|string} city_limits
 @property {date|string} date
 @property {text|string} ein_number
 @property {email} email
 @property {text|string} event_city
 @property {date|string} event_end_date
 @property {text|string} event_name
 @property {date|string} event_start_date
 @property {text|string} event_state
 @property {text|string} event_street_1
 @property {text|string} event_street_2
 @property {text|string} event_zip
 @property {number|int} ffl_class
 @property {text|string} ffl_name
 @property {text|string} ffl_number
 @property {number|int} ffl_type
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} order_number
 @property {text|string} phone
 @property {number|int} pkey
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} zip
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {number|int} dealer
 @property {text|string} dealer_binary_id
 @property {number|int} event
 @property {text|string} event_binary_id
 @property {text|string} notes
 */
/**
 @typedef {Object.<any>} Acquisitions_Pendings_Has
 @property {Acquisitions_Pendings_Products_Object[]} acquisition_pending_productss
 */
/**
 @typedef {Object.<any>} Acquisitions_Pendings_Is
 @property {Dealers_Object} dealers
 @property {Events_Object} events
 @property {Ffls_Classes_Object} ffl_classes
 @property {Ffls_Types_Object} ffl_types
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 */
/**
 @typedef {Object.<any>} Acquisitions_Pendings_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} city_limits
 @property {string} city_limits_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} ein_number
 @property {string} ein_number_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} event_city
 @property {string} event_city_error
 @property {?date|string} event_end_date
 @property {string} event_end_date_error
 @property {?text|string} event_name
 @property {string} event_name_error
 @property {?date|string} event_start_date
 @property {string} event_start_date_error
 @property {?text|string} event_state
 @property {string} event_state_error
 @property {?text|string} event_street_1
 @property {string} event_street_1_error
 @property {?text|string} event_street_2
 @property {string} event_street_2_error
 @property {?text|string} event_zip
 @property {string} event_zip_error
 @property {?number|int} ffl_class
 @property {string} ffl_class_error
 @property {?text|string} ffl_name
 @property {string} ffl_name_error
 @property {?text|string} ffl_number
 @property {string} ffl_number_error
 @property {?number|int} ffl_type
 @property {string} ffl_type_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} order_number
 @property {string} order_number_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?number|int} dealer
 @property {string} dealer_error
 @property {?text|string} dealer_binary_id
 @property {string} dealer_binary_id_error
 @property {?number|int} event
 @property {string} event_error
 @property {?text|string} event_binary_id
 @property {string} event_binary_id_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {Acquisitions_Pendings_Products_Object[]} acquisition_pending_productss
 @property {Dealers_Object} dealers
 @property {Events_Object} events
 @property {Ffls_Classes_Object} ffl_classes
 @property {Ffls_Types_Object} ffl_types
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Forms
 @property {Dispositions_Pendings_Forms_Properties} properties
 @property {Dispositions_Pendings_Forms_Has} has
 @property {Dispositions_Pendings_Forms_Is} is
 @property {Dispositions_Pendings_Forms_Object} object
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Forms_Properties
 @property {text|string} _id
 @property {string} amended
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {number|int} disposition_pending
 @property {text|string} disposition_pending_binary_id
 @property {text|string} filename
 @property {number|int} form
 @property {number|int} form_p12
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} payment
 @property {number|int} pkey
 @property {number|int} product
 @property {text|string} product_binary_id
 @property {number|int} quarter
 @property {string} results
 @property {boolean} sent_atf
 @property {boolean} sent_cleo
 @property {text|string} sent_cleo_email
 @property {text|string} type
 @property {text|string} year
 @property {boolean} has_notes
 @property {boolean} send_email
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Forms_Has
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Forms_Is
 @property {Customers_Object} customers
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Form_P12s_Object} form_p12s
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Forms_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?string} amended
 @property {string} amended_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?number|int} disposition_pending
 @property {string} disposition_pending_error
 @property {?text|string} disposition_pending_binary_id
 @property {string} disposition_pending_binary_id_error
 @property {?text|string} filename
 @property {string} filename_error
 @property {?number|int} form
 @property {string} form_error
 @property {?number|int} form_p12
 @property {string} form_p12_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} payment
 @property {string} payment_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} product_binary_id
 @property {string} product_binary_id_error
 @property {?number|int} quarter
 @property {string} quarter_error
 @property {?string} results
 @property {string} results_error
 @property {?boolean} sent_atf
 @property {string} sent_atf_error
 @property {?boolean} sent_cleo
 @property {string} sent_cleo_error
 @property {?text|string} sent_cleo_email
 @property {string} sent_cleo_email_error
 @property {?text|string} type
 @property {string} type_error
 @property {?text|string} year
 @property {string} year_error
 @property {?boolean} has_notes
 @property {string} has_notes_error
 @property {?boolean} send_email
 @property {string} send_email_error
 @property {Customers_Object} customers
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Form_P12s_Object} form_p12s
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Items
 @property {Dispositions_Pendings_Items_Properties} properties
 @property {Dispositions_Pendings_Items_Has} has
 @property {Dispositions_Pendings_Items_Is} is
 @property {Dispositions_Pendings_Items_Object} object
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Items_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} disposition_pending
 @property {text|string} disposition_pending_binary_id
 @property {boolean} pawn_redemption
 @property {number|int} pkey
 @property {number|int} product
 @property {text|string} product_binary_id
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Items_Has
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Items_Is
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Products_Object} products
 */
/**
 @typedef {Object.<any>} Dispositions_Pendings_Items_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} disposition_pending
 @property {string} disposition_pending_error
 @property {?text|string} disposition_pending_binary_id
 @property {string} disposition_pending_binary_id_error
 @property {?boolean} pawn_redemption
 @property {string} pawn_redemption_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} product_binary_id
 @property {string} product_binary_id_error
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Products_Object} products
 */
/**
 @typedef {Object.<any>} Acquisitions_Pendings_Products
 @property {Acquisitions_Pendings_Products_Properties} properties
 @property {Acquisitions_Pendings_Products_Has} has
 @property {Acquisitions_Pendings_Products_Is} is
 @property {Acquisitions_Pendings_Products_Object} object
 */
/**
 @typedef {Object.<any>} Acquisitions_Pendings_Products_Properties
 @property {text|string} _id
 @property {number|int} acquisition
 @property {text|string} acquisition_binary_id
 @property {text|string} barrel_length
 @property {text|string} binary_id
 @property {number|int} caliber
 @property {text|string} caliber_other
 @property {text|string} importer
 @property {text|string} item_description
 @property {number|int} item_quantity
 @property {number|int} manufacturer
 @property {text|string} manufacturer_other
 @property {text|string} model
 @property {text|string} overall_length
 @property {number|int} pkey
 @property {text|string} serial_number
 @property {boolean} serialized
 @property {text|string} sku
 @property {text|string} type
 @property {boolean} used_firearm
 */
/**
 @typedef {Object.<any>} Acquisitions_Pendings_Products_Has
 */
/**
 @typedef {Object.<any>} Acquisitions_Pendings_Products_Is
 @property {Acquisitions_Pendings_Object} acquisition_pendings
 @property {Calibers_Object} calibers
 @property {Manufacturers_Object} manufacturers
 */
/**
 @typedef {Object.<any>} Acquisitions_Pendings_Products_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int} acquisition
 @property {string} acquisition_error
 @property {?text|string} acquisition_binary_id
 @property {string} acquisition_binary_id_error
 @property {?text|string} barrel_length
 @property {string} barrel_length_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} caliber
 @property {string} caliber_error
 @property {?text|string} caliber_other
 @property {string} caliber_other_error
 @property {?text|string} importer
 @property {string} importer_error
 @property {?text|string} item_description
 @property {string} item_description_error
 @property {?number|int} item_quantity
 @property {string} item_quantity_error
 @property {?number|int} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} manufacturer_other
 @property {string} manufacturer_other_error
 @property {?text|string} model
 @property {string} model_error
 @property {?text|string} overall_length
 @property {string} overall_length_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?boolean} serialized
 @property {string} serialized_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?text|string} type
 @property {string} type_error
 @property {?boolean} used_firearm
 @property {string} used_firearm_error
 @property {Acquisitions_Pendings_Object} acquisition_pendings
 @property {Calibers_Object} calibers
 @property {Manufacturers_Object} manufacturers
 */
/**
 @typedef {Object.<any>} Transactions_Questions
 @property {Transactions_Questions_Properties} properties
 @property {Transactions_Questions_Has} has
 @property {Transactions_Questions_Is} is
 @property {Transactions_Questions_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Questions_Properties
 @property {text|string} _id
 @property {boolean} actual_intention
 @property {boolean} actual_intention_felony
 @property {boolean} actual_transferee
 @property {text|string} alien_or_admission_number
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {text|string} country_of_citizenship
 @property {date|string} created
 @property {boolean} dishonorable_discharge
 @property {boolean} domestic_violence
 @property {boolean} drug_user
 @property {boolean} fall_within_exceptions
 @property {boolean} felony_convicted
 @property {boolean} felony_indictment
 @property {boolean} fugitive
 @property {boolean} illegal_alien
 @property {boolean} mentally_stable
 @property {date|string} modified
 @property {boolean} nonimmigrant_visa
 @property {number|int} pkey
 @property {boolean} renounced_citizenship
 @property {boolean} restraining_order
 @property {boolean} under_twenty_one
 @property {boolean} us_citizen
 */
/**
 @typedef {Object.<any>} Transactions_Questions_Has
 */
/**
 @typedef {Object.<any>} Transactions_Questions_Is
 @property {Transactions_Collections_Object} transaction_collections
 */
/**
 @typedef {Object.<any>} Transactions_Questions_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?boolean} actual_intention
 @property {string} actual_intention_error
 @property {?boolean} actual_intention_felony
 @property {string} actual_intention_felony_error
 @property {?boolean} actual_transferee
 @property {string} actual_transferee_error
 @property {?text|string} alien_or_admission_number
 @property {string} alien_or_admission_number_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?text|string} country_of_citizenship
 @property {string} country_of_citizenship_error
 @property {?date|string} created
 @property {string} created_error
 @property {?boolean} dishonorable_discharge
 @property {string} dishonorable_discharge_error
 @property {?boolean} domestic_violence
 @property {string} domestic_violence_error
 @property {?boolean} drug_user
 @property {string} drug_user_error
 @property {?boolean} fall_within_exceptions
 @property {string} fall_within_exceptions_error
 @property {?boolean} felony_convicted
 @property {string} felony_convicted_error
 @property {?boolean} felony_indictment
 @property {string} felony_indictment_error
 @property {?boolean} fugitive
 @property {string} fugitive_error
 @property {?boolean} illegal_alien
 @property {string} illegal_alien_error
 @property {?boolean} mentally_stable
 @property {string} mentally_stable_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?boolean} nonimmigrant_visa
 @property {string} nonimmigrant_visa_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} renounced_citizenship
 @property {string} renounced_citizenship_error
 @property {?boolean} restraining_order
 @property {string} restraining_order_error
 @property {?boolean} under_twenty_one
 @property {string} under_twenty_one_error
 @property {?boolean} us_citizen
 @property {string} us_citizen_error
 @property {Transactions_Collections_Object} transaction_collections
 */
/**
 @typedef {Object.<any>} Transactions_Signatures
 @property {Transactions_Signatures_Properties} properties
 @property {Transactions_Signatures_Has} has
 @property {Transactions_Signatures_Is} is
 @property {Transactions_Signatures_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Signatures_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {date|string} date
 @property {number|int} pkey
 @property {text|string} signature
 @property {number|int} signature_location
 @property {number|int} user
 @property {text|string} user_binary_id
 */
/**
 @typedef {Object.<any>} Transactions_Signatures_Has
 */
/**
 @typedef {Object.<any>} Transactions_Signatures_Is
 @property {Transactions_Collections_Object} transaction_collections
 @property {Transactions_Signatures_Locations_Object} transaction_signature_locations
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Transactions_Signatures_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} signature
 @property {string} signature_error
 @property {?number|int} signature_location
 @property {string} signature_location_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {Transactions_Collections_Object} transaction_collections
 @property {Transactions_Signatures_Locations_Object} transaction_signature_locations
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Transactions_Signatures_Locations
 @property {Transactions_Signatures_Locations_Properties} properties
 @property {Transactions_Signatures_Locations_Has} has
 @property {Transactions_Signatures_Locations_Is} is
 @property {Transactions_Signatures_Locations_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Signatures_Locations_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Transactions_Signatures_Locations_Has
 */
/**
 @typedef {Object.<any>} Transactions_Signatures_Locations_Is
 */
/**
 @typedef {Object.<any>} Transactions_Signatures_Locations_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Transactions_Types
 @property {Transactions_Types_Properties} properties
 @property {Transactions_Types_Has} has
 @property {Transactions_Types_Is} is
 @property {Transactions_Types_Object} object
 */
/**
 @typedef {Object.<any>} Transactions_Types_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} class
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} type
 */
/**
 @typedef {Object.<any>} Transactions_Types_Has
 */
/**
 @typedef {Object.<any>} Transactions_Types_Is
 */
/**
 @typedef {Object.<any>} Transactions_Types_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} class
 @property {string} class_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} type
 @property {string} type_error
 */
/**
 @typedef {Object.<any>} Turnstile
 @property {Turnstile_Properties} properties
 @property {Turnstile_Has} has
 @property {Turnstile_Is} is
 @property {Turnstile_Object} object
 */
/**
 @typedef {Object.<any>} Turnstile_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Turnstile_Has
 */
/**
 @typedef {Object.<any>} Turnstile_Is
 */
/**
 @typedef {Object.<any>} Turnstile_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Unexpected_Errors
 @property {Unexpected_Errors_Properties} properties
 @property {Unexpected_Errors_Has} has
 @property {Unexpected_Errors_Is} is
 @property {Unexpected_Errors_Object} object
 */
/**
 @typedef {Object.<any>} Unexpected_Errors_Properties
 @property {text|string} _id
 @property {number|int} account
 @property {text|string} binary_id
 @property {text|string} message
 @property {text|string} path
 @property {number|int} pkey
 @property {text|string} stack
 @property {number|int} user
 */
/**
 @typedef {Object.<any>} Unexpected_Errors_Has
 */
/**
 @typedef {Object.<any>} Unexpected_Errors_Is
 */
/**
 @typedef {Object.<any>} Unexpected_Errors_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} message
 @property {string} message_error
 @property {?text|string} path
 @property {string} path_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} stack
 @property {string} stack_error
 @property {?number|int} user
 @property {string} user_error
 */
/**
 @typedef {Object.<any>} Upc_Center
 @property {Upc_Center_Properties} properties
 @property {Upc_Center_Has} has
 @property {Upc_Center_Is} is
 @property {Upc_Center_Object} object
 */
/**
 @typedef {Object.<any>} Upc_Center_Properties
 @property {text|string} _id
 @property {number|int} account
 @property {date|string} acquisition_date
 @property {text|string} barrel_length
 @property {text|string} binary_id
 @property {number|int} bound_book
 @property {text|string} bound_book_binary_id
 @property {number|int} caliber
 @property {text|string} caliber_other
 @property {number|int|float} cost
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {boolean} discontinued
 @property {date|string} disposition_date
 @property {text|string} id
 @property {boolean} imported
 @property {text|string} importer
 @property {text|string} item_description
 @property {boolean} item_restricted
 @property {number|int} loc_greensboro_quantity
 @property {number|int} loc_prescott_quantity
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} mag_capacity
 @property {text|string} mag_capicity
 @property {number|int} manufacturer
 @property {text|string} manufacturer_other
 @property {number|int|float} min_price
 @property {text|string} model
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} overall_length
 @property {text|string} pict_file
 @property {number|int} pkey
 @property {number|int|float} price_list
 @property {number|int|float} price_min
 @property {number|int|float} price_sale
 @property {text|string} product_class
 @property {number|int} quantity
 @property {boolean} semi_auto_w_detach
 @property {text|string} serial_number
 @property {boolean} serializied
 @property {text|string} sku
 @property {number|int} status
 @property {number|int} total_quantity
 @property {text|string} type
 @property {text|string} type_previous
 @property {text|string} upc
 @property {boolean} used_firearm
 */
/**
 @typedef {Object.<any>} Upc_Center_Has
 */
/**
 @typedef {Object.<any>} Upc_Center_Is
 @property {Accounts_Object} accounts
 @property {Calibers_Object} calibers
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Upc_Center_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int} account
 @property {string} account_error
 @property {?date|string} acquisition_date
 @property {string} acquisition_date_error
 @property {?text|string} barrel_length
 @property {string} barrel_length_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} bound_book
 @property {string} bound_book_error
 @property {?text|string} bound_book_binary_id
 @property {string} bound_book_binary_id_error
 @property {?number|int} caliber
 @property {string} caliber_error
 @property {?text|string} caliber_other
 @property {string} caliber_other_error
 @property {?number|int|float} cost
 @property {string} cost_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?boolean} discontinued
 @property {string} discontinued_error
 @property {?date|string} disposition_date
 @property {string} disposition_date_error
 @property {?text|string} id
 @property {string} id_error
 @property {?boolean} imported
 @property {string} imported_error
 @property {?text|string} importer
 @property {string} importer_error
 @property {?text|string} item_description
 @property {string} item_description_error
 @property {?boolean} item_restricted
 @property {string} item_restricted_error
 @property {?number|int} loc_greensboro_quantity
 @property {string} loc_greensboro_quantity_error
 @property {?number|int} loc_prescott_quantity
 @property {string} loc_prescott_quantity_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} mag_capacity
 @property {string} mag_capacity_error
 @property {?text|string} mag_capicity
 @property {string} mag_capicity_error
 @property {?number|int} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} manufacturer_other
 @property {string} manufacturer_other_error
 @property {?number|int|float} min_price
 @property {string} min_price_error
 @property {?text|string} model
 @property {string} model_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} overall_length
 @property {string} overall_length_error
 @property {?text|string} pict_file
 @property {string} pict_file_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price_list
 @property {string} price_list_error
 @property {?number|int|float} price_min
 @property {string} price_min_error
 @property {?number|int|float} price_sale
 @property {string} price_sale_error
 @property {?text|string} product_class
 @property {string} product_class_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?boolean} semi_auto_w_detach
 @property {string} semi_auto_w_detach_error
 @property {?text|string} serial_number
 @property {string} serial_number_error
 @property {?boolean} serializied
 @property {string} serializied_error
 @property {?text|string} sku
 @property {string} sku_error
 @property {?number|int} status
 @property {string} status_error
 @property {?number|int} total_quantity
 @property {string} total_quantity_error
 @property {?text|string} type
 @property {string} type_error
 @property {?text|string} type_previous
 @property {string} type_previous_error
 @property {?text|string} upc
 @property {string} upc_error
 @property {?boolean} used_firearm
 @property {string} used_firearm_error
 @property {Accounts_Object} accounts
 @property {Calibers_Object} calibers
 @property {Locations_Bound_Books_Object} location_bound_books
 @property {Locations_Object} locations
 @property {Manufacturers_Object} manufacturers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Upc_Center_Logs
 @property {Upc_Center_Logs_Properties} properties
 @property {Upc_Center_Logs_Has} has
 @property {Upc_Center_Logs_Is} is
 @property {Upc_Center_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Upc_Center_Logs_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} date
 @property {text|string} display_new
 @property {text|string} display_old
 @property {text|string} field
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} upc_product
 @property {text|string} upc_product_binary_id
 @property {number|int} user
 @property {text|string} user_binary_id
 @property {text|string} value_new
 @property {text|string} value_original
 */
/**
 @typedef {Object.<any>} Upc_Center_Logs_Has
 */
/**
 @typedef {Object.<any>} Upc_Center_Logs_Is
 @property {Upc_Center_Object} upc_center
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Upc_Center_Logs_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} display_new
 @property {string} display_new_error
 @property {?text|string} display_old
 @property {string} display_old_error
 @property {?text|string} field
 @property {string} field_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} upc_product
 @property {string} upc_product_error
 @property {?text|string} upc_product_binary_id
 @property {string} upc_product_binary_id_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} user_binary_id
 @property {string} user_binary_id_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {Upc_Center_Object} upc_center
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Upgrades
 @property {Upgrades_Properties} properties
 @property {Upgrades_Has} has
 @property {Upgrades_Is} is
 @property {Upgrades_Object} object
 */
/**
 @typedef {Object.<any>} Upgrades_Properties
 @property {text|string} _id
 @property {text|string} additional
 @property {text|string} binary_id
 @property {text|string} description
 @property {text|string} name
 @property {text|string} note
 @property {number|int} pkey
 @property {text|string} plan
 @property {text|string} price
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {number|int} upgrade
 @property {text|string} upgrade_type
 */
/**
 @typedef {Object.<any>} Upgrades_Has
 */
/**
 @typedef {Object.<any>} Upgrades_Is
 */
/**
 @typedef {Object.<any>} Upgrades_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} additional
 @property {string} additional_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} description
 @property {string} description_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} plan
 @property {string} plan_error
 @property {?text|string} price
 @property {string} price_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?number|int} upgrade
 @property {string} upgrade_error
 @property {?text|string} upgrade_type
 @property {string} upgrade_type_error
 */
/**
 @typedef {Object.<any>} Users
 @property {Users_Properties} properties
 @property {Users_Has} has
 @property {Users_Is} is
 @property {Users_Object} object
 */
/**
 @typedef {Object.<any>} Users_Properties
 @property {text|string} _id
 @property {number|int} access
 @property {text|string} authy
 @property {boolean} authy_enabled
 @property {text|string} binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {email} email
 @property {boolean} enabled
 @property {date|string} last_logged_in
 @property {text|string} leep_password
 @property {text|string} leep_username
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {number|int} locked_kiosk
 @property {text|string} locked_kiosk_binary_id
 @property {number|int} locked_location
 @property {text|string} locked_location_binary_id
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} modifier_binary_id
 @property {text|string} name_first
 @property {text|string} name_last
 @property {string} password
 @property {boolean} password_expired
 @property {string} password_new
 @property {date|string} password_set
 @property {string} password_temp
 @property {text|string} pin
 @property {number|int} pkey
 @property {number|int} system_locked
 @property {text|string} title
 @property {string} password_repeat
 */
/**
 @typedef {Object.<any>} Users_Has
 */
/**
 @typedef {Object.<any>} Users_Is
 @property {Kiosks_Object} kiosks
 @property {Locations_Object} locations
 @property {Users_Accesses_Object} user_accesses
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Users_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?number|int} access
 @property {string} access_error
 @property {?text|string} authy
 @property {string} authy_error
 @property {?boolean} authy_enabled
 @property {string} authy_enabled_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?email} email
 @property {string} email_error
 @property {?boolean} enabled
 @property {string} enabled_error
 @property {?date|string} last_logged_in
 @property {string} last_logged_in_error
 @property {?text|string} leep_password
 @property {string} leep_password_error
 @property {?text|string} leep_username
 @property {string} leep_username_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?number|int} locked_kiosk
 @property {string} locked_kiosk_error
 @property {?text|string} locked_kiosk_binary_id
 @property {string} locked_kiosk_binary_id_error
 @property {?number|int} locked_location
 @property {string} locked_location_error
 @property {?text|string} locked_location_binary_id
 @property {string} locked_location_binary_id_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} modifier_binary_id
 @property {string} modifier_binary_id_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?string} password
 @property {string} password_error
 @property {?boolean} password_expired
 @property {string} password_expired_error
 @property {?string} password_new
 @property {string} password_new_error
 @property {?date|string} password_set
 @property {string} password_set_error
 @property {?string} password_temp
 @property {string} password_temp_error
 @property {?text|string} pin
 @property {string} pin_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} system_locked
 @property {string} system_locked_error
 @property {?text|string} title
 @property {string} title_error
 @property {?string} password_repeat
 @property {string} password_repeat_error
 @property {Kiosks_Object} kiosks
 @property {Locations_Object} locations
 @property {Users_Accesses_Object} user_accesses
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Vendors
 @property {Vendors_Properties} properties
 @property {Vendors_Has} has
 @property {Vendors_Is} is
 @property {Vendors_Object} object
 */
/**
 @typedef {Object.<any>} Vendors_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} date
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} token
 */
/**
 @typedef {Object.<any>} Vendors_Has
 */
/**
 @typedef {Object.<any>} Vendors_Is
 */
/**
 @typedef {Object.<any>} Vendors_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} token
 @property {string} token_error
 */
/**
 @typedef {Object.<any>} States
 @property {States_Properties} properties
 @property {States_Has} has
 @property {States_Is} is
 @property {States_Object} object
 */
/**
 @typedef {Object.<any>} States_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} short
 */
/**
 @typedef {Object.<any>} States_Has
 */
/**
 @typedef {Object.<any>} States_Is
 */
/**
 @typedef {Object.<any>} States_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} short
 @property {string} short_error
 */
/**
 @typedef {Object.<any>} Nics_Responses
 @property {Nics_Responses_Properties} properties
 @property {Nics_Responses_Has} has
 @property {Nics_Responses_Is} is
 @property {Nics_Responses_Object} object
 */
/**
 @typedef {Object.<any>} Nics_Responses_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Nics_Responses_Has
 */
/**
 @typedef {Object.<any>} Nics_Responses_Is
 */
/**
 @typedef {Object.<any>} Nics_Responses_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Nics_Delays
 @property {Nics_Delays_Properties} properties
 @property {Nics_Delays_Has} has
 @property {Nics_Delays_Is} is
 @property {Nics_Delays_Object} object
 */
/**
 @typedef {Object.<any>} Nics_Delays_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Nics_Delays_Has
 */
/**
 @typedef {Object.<any>} Nics_Delays_Is
 */
/**
 @typedef {Object.<any>} Nics_Delays_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Nics_After
 @property {Nics_After_Properties} properties
 @property {Nics_After_Has} has
 @property {Nics_After_Is} is
 @property {Nics_After_Object} object
 */
/**
 @typedef {Object.<any>} Nics_After_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Nics_After_Has
 */
/**
 @typedef {Object.<any>} Nics_After_Is
 */
/**
 @typedef {Object.<any>} Nics_After_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Manufacturers
 @property {Manufacturers_Properties} properties
 @property {Manufacturers_Has} has
 @property {Manufacturers_Is} is
 @property {Manufacturers_Object} object
 */
/**
 @typedef {Object.<any>} Manufacturers_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {boolean} hidden
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Manufacturers_Has
 */
/**
 @typedef {Object.<any>} Manufacturers_Is
 */
/**
 @typedef {Object.<any>} Manufacturers_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?boolean} hidden
 @property {string} hidden_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Leep_Questions
 @property {Leep_Questions_Properties} properties
 @property {Leep_Questions_Has} has
 @property {Leep_Questions_Is} is
 @property {Leep_Questions_Object} object
 */
/**
 @typedef {Object.<any>} Leep_Questions_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} created
 @property {number|int} pkey
 @property {text|string} question
 */
/**
 @typedef {Object.<any>} Leep_Questions_Has
 */
/**
 @typedef {Object.<any>} Leep_Questions_Is
 */
/**
 @typedef {Object.<any>} Leep_Questions_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} question
 @property {string} question_error
 */
/**
 @typedef {Object.<any>} Importers_Forms
 @property {Importers_Forms_Properties} properties
 @property {Importers_Forms_Has} has
 @property {Importers_Forms_Is} is
 @property {Importers_Forms_Object} object
 */
/**
 @typedef {Object.<any>} Importers_Forms_Properties
 @property {text|string} _id
 @property {string} amended
 @property {text|string} binary_id
 @property {number|int} collection
 @property {text|string} collection_binary_id
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} creator_binary_id
 @property {number|int} customer
 @property {text|string} customer_binary_id
 @property {number|int} disposition_pending
 @property {text|string} disposition_pending_binary_id
 @property {text|string} filename
 @property {number|int} form
 @property {number|int} form_p12
 @property {number|int} location
 @property {text|string} location_binary_id
 @property {text|string} payment
 @property {number|int} pkey
 @property {number|int} product
 @property {text|string} product_binary_id
 @property {number|int} quarter
 @property {string} results
 @property {boolean} sent_atf
 @property {boolean} sent_cleo
 @property {text|string} sent_cleo_email
 @property {text|string} type
 @property {text|string} year
 @property {boolean} has_notes
 @property {boolean} send_email
 */
/**
 @typedef {Object.<any>} Importers_Forms_Has
 */
/**
 @typedef {Object.<any>} Importers_Forms_Is
 @property {Customers_Object} customers
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Form_P12s_Object} form_p12s
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Importers_Forms_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?string} amended
 @property {string} amended_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} collection
 @property {string} collection_error
 @property {?text|string} collection_binary_id
 @property {string} collection_binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} creator_binary_id
 @property {string} creator_binary_id_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_binary_id
 @property {string} customer_binary_id_error
 @property {?number|int} disposition_pending
 @property {string} disposition_pending_error
 @property {?text|string} disposition_pending_binary_id
 @property {string} disposition_pending_binary_id_error
 @property {?text|string} filename
 @property {string} filename_error
 @property {?number|int} form
 @property {string} form_error
 @property {?number|int} form_p12
 @property {string} form_p12_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_binary_id
 @property {string} location_binary_id_error
 @property {?text|string} payment
 @property {string} payment_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} product
 @property {string} product_error
 @property {?text|string} product_binary_id
 @property {string} product_binary_id_error
 @property {?number|int} quarter
 @property {string} quarter_error
 @property {?string} results
 @property {string} results_error
 @property {?boolean} sent_atf
 @property {string} sent_atf_error
 @property {?boolean} sent_cleo
 @property {string} sent_cleo_error
 @property {?text|string} sent_cleo_email
 @property {string} sent_cleo_email_error
 @property {?text|string} type
 @property {string} type_error
 @property {?text|string} year
 @property {string} year_error
 @property {?boolean} has_notes
 @property {string} has_notes_error
 @property {?boolean} send_email
 @property {string} send_email_error
 @property {Customers_Object} customers
 @property {Dispositions_Pendings_Object} disposition_pendings
 @property {Form_P12s_Object} form_p12s
 @property {Forms_Object} forms
 @property {Locations_Object} locations
 @property {Products_Object} products
 @property {Transactions_Collections_Object} transaction_collections
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Forms
 @property {Forms_Properties} properties
 @property {Forms_Has} has
 @property {Forms_Is} is
 @property {Forms_Object} object
 */
/**
 @typedef {Object.<any>} Forms_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} description
 @property {text|string} file
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Forms_Has
 */
/**
 @typedef {Object.<any>} Forms_Is
 */
/**
 @typedef {Object.<any>} Forms_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} description
 @property {string} description_error
 @property {?text|string} file
 @property {string} file_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Ffls_Classes
 @property {Ffls_Classes_Properties} properties
 @property {Ffls_Classes_Has} has
 @property {Ffls_Classes_Is} is
 @property {Ffls_Classes_Object} object
 */
/**
 @typedef {Object.<any>} Ffls_Classes_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} class
 @property {text|string} description
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Ffls_Classes_Has
 */
/**
 @typedef {Object.<any>} Ffls_Classes_Is
 */
/**
 @typedef {Object.<any>} Ffls_Classes_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} class
 @property {string} class_error
 @property {?text|string} description
 @property {string} description_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Ffls
 @property {Ffls_Properties} properties
 @property {Ffls_Has} has
 @property {Ffls_Is} is
 @property {Ffls_Object} object
 */
/**
 @typedef {Object.<any>} Ffls_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} city
 @property {text|string} ffl
 @property {text|string} ffl_clean
 @property {text|string} name_business
 @property {text|string} name_license
 @property {text|string} oct_1
 @property {text|string} oct_2
 @property {text|string} oct_3
 @property {text|string} oct_4
 @property {text|string} oct_5
 @property {text|string} oct_6
 @property {text|string} phone
 @property {number|int} pkey
 @property {text|string} state
 @property {text|string} street
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Ffls_Has
 */
/**
 @typedef {Object.<any>} Ffls_Is
 */
/**
 @typedef {Object.<any>} Ffls_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} ffl
 @property {string} ffl_error
 @property {?text|string} ffl_clean
 @property {string} ffl_clean_error
 @property {?text|string} name_business
 @property {string} name_business_error
 @property {?text|string} name_license
 @property {string} name_license_error
 @property {?text|string} oct_1
 @property {string} oct_1_error
 @property {?text|string} oct_2
 @property {string} oct_2_error
 @property {?text|string} oct_3
 @property {string} oct_3_error
 @property {?text|string} oct_4
 @property {string} oct_4_error
 @property {?text|string} oct_5
 @property {string} oct_5_error
 @property {?text|string} oct_6
 @property {string} oct_6_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street
 @property {string} street_error
 @property {?text|string} zip
 @property {string} zip_error
 */
/**
 @typedef {Object.<any>} Calibers
 @property {Calibers_Properties} properties
 @property {Calibers_Has} has
 @property {Calibers_Is} is
 @property {Calibers_Object} object
 */
/**
 @typedef {Object.<any>} Calibers_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {boolean} hidden
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int} sort
 @property {number|int} type
 */
/**
 @typedef {Object.<any>} Calibers_Has
 */
/**
 @typedef {Object.<any>} Calibers_Is
 */
/**
 @typedef {Object.<any>} Calibers_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?boolean} hidden
 @property {string} hidden_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} sort
 @property {string} sort_error
 @property {?number|int} type
 @property {string} type_error
 */
/**
 @typedef {Object.<any>} Accounts_Data_Usage
 @property {Accounts_Data_Usage_Properties} properties
 @property {Accounts_Data_Usage_Has} has
 @property {Accounts_Data_Usage_Is} is
 @property {Accounts_Data_Usage_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Data_Usage_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {date|string} created
 @property {number|int} data_usage
 @property {number|int} pkey
 @property {number|int} subscription_start_date
 */
/**
 @typedef {Object.<any>} Accounts_Data_Usage_Has
 */
/**
 @typedef {Object.<any>} Accounts_Data_Usage_Is
 */
/**
 @typedef {Object.<any>} Accounts_Data_Usage_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} data_usage
 @property {string} data_usage_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} subscription_start_date
 @property {string} subscription_start_date_error
 */
/**
 @typedef {Object.<any>} Users_Accesses
 @property {Users_Accesses_Properties} properties
 @property {Users_Accesses_Has} has
 @property {Users_Accesses_Is} is
 @property {Users_Accesses_Object} object
 */
/**
 @typedef {Object.<any>} Users_Accesses_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {number|int} level
 @property {text|string} name
 @property {number|int} pkey
 */
/**
 @typedef {Object.<any>} Users_Accesses_Has
 */
/**
 @typedef {Object.<any>} Users_Accesses_Is
 */
/**
 @typedef {Object.<any>} Users_Accesses_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?number|int} level
 @property {string} level_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 */
/**
 @typedef {Object.<any>} Ffls_Types
 @property {Ffls_Types_Properties} properties
 @property {Ffls_Types_Has} has
 @property {Ffls_Types_Is} is
 @property {Ffls_Types_Object} object
 */
/**
 @typedef {Object.<any>} Ffls_Types_Properties
 @property {text|string} _id
 @property {text|string} binary_id
 @property {text|string} description
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} type
 */
/**
 @typedef {Object.<any>} Ffls_Types_Has
 */
/**
 @typedef {Object.<any>} Ffls_Types_Is
 */
/**
 @typedef {Object.<any>} Ffls_Types_Object
 @property {?text|string} _id
 @property {string} _id_error
 @property {?text|string} binary_id
 @property {string} binary_id_error
 @property {?text|string} description
 @property {string} description_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} type
 @property {string} type_error
 */
const Types = {
	Accounts : {
		_name : "Accounts",
	},
	Cypress_Acquisitions : {
		_name : "Cypress_Acquisitions",
	},
	Accounts_Billings : {
		_name : "Accounts_Billings",
	},
	Accounts_Create : {
		_name : "Accounts_Create",
	},
	Cypress_Customers : {
		_name : "Cypress_Customers",
	},
	Accounts_Customizations : {
		_name : "Accounts_Customizations",
	},
	Cypress_Dealers : {
		_name : "Cypress_Dealers",
	},
	Cypress_Events : {
		_name : "Cypress_Events",
	},
	Accounts_Integrations : {
		_name : "Accounts_Integrations",
	},
	Accounts_Ip_Bans : {
		_name : "Accounts_Ip_Bans",
	},
	Accounts_Ip_Whitelists : {
		_name : "Accounts_Ip_Whitelists",
	},
	Admins_Locations : {
		_name : "Admins_Locations",
	},
	Admins_Accounts : {
		_name : "Admins_Accounts",
	},
	Admins_Logins : {
		_name : "Admins_Logins",
	},
	Accounts_Logins : {
		_name : "Accounts_Logins",
	},
	Accounts_Modules : {
		_name : "Accounts_Modules",
	},
	Accounts_Notifications : {
		_name : "Accounts_Notifications",
	},
	Admins_Securities : {
		_name : "Admins_Securities",
	},
	Accounts_Subscriptions : {
		_name : "Accounts_Subscriptions",
	},
	Accounts_Trainings : {
		_name : "Accounts_Trainings",
	},
	Accounts_Two_Step_Auth : {
		_name : "Accounts_Two_Step_Auth",
	},
	Accounts_Upgraded_Logs : {
		_name : "Accounts_Upgraded_Logs",
	},
	Admins_Users : {
		_name : "Admins_Users",
	},
	Admins : {
		_name : "Admins",
	},
	Admins_Charges : {
		_name : "Admins_Charges",
	},
	Admins_Modules : {
		_name : "Admins_Modules",
	},
	Admins_Stripe : {
		_name : "Admins_Stripe",
	},
	Admins_Subscriptions : {
		_name : "Admins_Subscriptions",
	},
	Ammoready_Orders : {
		_name : "Ammoready_Orders",
	},
	Bound_Books : {
		_name : "Bound_Books",
	},
	Bound_Books_Products : {
		_name : "Bound_Books_Products",
	},
	Changes : {
		_name : "Changes",
	},
	Changes_Emails : {
		_name : "Changes_Emails",
	},
	Custom_Modules : {
		_name : "Custom_Modules",
	},
	Custom_Modules_Customs_880 : {
		_name : "Custom_Modules_Customs_880",
	},
	Customers : {
		_name : "Customers",
	},
	Customers_Addresses : {
		_name : "Customers_Addresses",
	},
	Customers_Duplicates : {
		_name : "Customers_Duplicates",
	},
	Customers_Emails : {
		_name : "Customers_Emails",
	},
	Customers_Histories : {
		_name : "Customers_Histories",
	},
	Customers_Identifications : {
		_name : "Customers_Identifications",
	},
	Customers_Identifications_Images : {
		_name : "Customers_Identifications_Images",
	},
	Customers_Logs : {
		_name : "Customers_Logs",
	},
	Customers_Military : {
		_name : "Customers_Military",
	},
	Customers_Nics_Denies : {
		_name : "Customers_Nics_Denies",
	},
	Customers_Numbers : {
		_name : "Customers_Numbers",
	},
	Customers_Permits : {
		_name : "Customers_Permits",
	},
	Customers_Permits_Images : {
		_name : "Customers_Permits_Images",
	},
	Cypress : {
		_name : "Cypress",
	},
	Dashboard : {
		_name : "Dashboard",
	},
	Davidsons : {
		_name : "Davidsons",
	},
	Davidsons_Pendings : {
		_name : "Davidsons_Pendings",
	},
	Davidsons_Products : {
		_name : "Davidsons_Products",
	},
	Dealers : {
		_name : "Dealers",
	},
	Dealers_Duplicates : {
		_name : "Dealers_Duplicates",
	},
	Dealers_Images : {
		_name : "Dealers_Images",
	},
	Dealers_Logs : {
		_name : "Dealers_Logs",
	},
	Dealers_Missing_Email_Logs : {
		_name : "Dealers_Missing_Email_Logs",
	},
	Dispositions_Nics : {
		_name : "Dispositions_Nics",
	},
	Drivers_License_Logs : {
		_name : "Drivers_License_Logs",
	},
	Dropbox : {
		_name : "Dropbox",
	},
	Email_Templates : {
		_name : "Email_Templates",
	},
	Email_Testing : {
		_name : "Email_Testing",
	},
	Events : {
		_name : "Events",
	},
	Events_Logs : {
		_name : "Events_Logs",
	},
	Export : {
		_name : "Export",
	},
	Exports : {
		_name : "Exports",
	},
	Exports_Logs : {
		_name : "Exports_Logs",
	},
	Filesizes : {
		_name : "Filesizes",
	},
	Form_P12s : {
		_name : "Form_P12s",
	},
	Forms_Results : {
		_name : "Forms_Results",
	},
	Gunbroker_Orders : {
		_name : "Gunbroker_Orders",
	},
	Importers : {
		_name : "Importers",
	},
	Importers_Logs : {
		_name : "Importers_Logs",
	},
	Imports : {
		_name : "Imports",
	},
	Inventories : {
		_name : "Inventories",
	},
	Inventories_Items : {
		_name : "Inventories_Items",
	},
	Ioi_Batches : {
		_name : "Ioi_Batches",
	},
	Kiosks : {
		_name : "Kiosks",
	},
	Leep_User_Answers : {
		_name : "Leep_User_Answers",
	},
	Leep_User_Logs : {
		_name : "Leep_User_Logs",
	},
	Legal_Entities : {
		_name : "Legal_Entities",
	},
	Legal_Entities_Logs : {
		_name : "Legal_Entities_Logs",
	},
	Legal_Entities_Trustees : {
		_name : "Legal_Entities_Trustees",
	},
	Location_Banners : {
		_name : "Location_Banners",
	},
	Locations : {
		_name : "Locations",
	},
	Locations_Bound_Books : {
		_name : "Locations_Bound_Books",
	},
	Locations_Bound_Books_Flags : {
		_name : "Locations_Bound_Books_Flags",
	},
	Locations_Bound_Books_Queues : {
		_name : "Locations_Bound_Books_Queues",
	},
	Locations_Images : {
		_name : "Locations_Images",
	},
	Locations_Logs : {
		_name : "Locations_Logs",
	},
	Locations_Modules : {
		_name : "Locations_Modules",
	},
	Locations_Queues : {
		_name : "Locations_Queues",
	},
	Manufactureds : {
		_name : "Manufactureds",
	},
	Manufactureds_Forms : {
		_name : "Manufactureds_Forms",
	},
	Master_Banners : {
		_name : "Master_Banners",
	},
	Mobile_Notifications : {
		_name : "Mobile_Notifications",
	},
	Modules : {
		_name : "Modules",
	},
	Modules_Module_Services : {
		_name : "Modules_Module_Services",
	},
	Multiple_Sales : {
		_name : "Multiple_Sales",
	},
	Multiple_Sales_Entries : {
		_name : "Multiple_Sales_Entries",
	},
	Multiple_Sales_Options : {
		_name : "Multiple_Sales_Options",
	},
	National_Firearms_Acts : {
		_name : "National_Firearms_Acts",
	},
	Pins : {
		_name : "Pins",
	},
	Point_Of_Sales : {
		_name : "Point_Of_Sales",
	},
	Products : {
		_name : "Products",
	},
	Products_Histories : {
		_name : "Products_Histories",
	},
	Products_Ioi_Inspection_Items : {
		_name : "Products_Ioi_Inspection_Items",
	},
	Products_Ioi_Inspections : {
		_name : "Products_Ioi_Inspections",
	},
	Products_Logs : {
		_name : "Products_Logs",
	},
	Products_Point_Of_Sales : {
		_name : "Products_Point_Of_Sales",
	},
	Products_Statuses : {
		_name : "Products_Statuses",
	},
	Products_Types : {
		_name : "Products_Types",
	},
	Signatures : {
		_name : "Signatures",
	},
	Stripe_Charges : {
		_name : "Stripe_Charges",
	},
	Stripe_Subscriptions_All : {
		_name : "Stripe_Subscriptions_All",
	},
	Subscriptions : {
		_name : "Subscriptions",
	},
	Transaction_Upload : {
		_name : "Transaction_Upload",
	},
	Transactions : {
		_name : "Transactions",
	},
	Transactions_Collections : {
		_name : "Transactions_Collections",
	},
	Transactions_Collections_Forms : {
		_name : "Transactions_Collections_Forms",
	},
	Transactions_Entries : {
		_name : "Transactions_Entries",
	},
	Acquisitions_Incomings : {
		_name : "Acquisitions_Incomings",
	},
	Transactions_Logs : {
		_name : "Transactions_Logs",
	},
	Transactions_Nics : {
		_name : "Transactions_Nics",
	},
	Dispositions_Pendings : {
		_name : "Dispositions_Pendings",
	},
	Acquisitions_Pendings : {
		_name : "Acquisitions_Pendings",
	},
	Dispositions_Pendings_Forms : {
		_name : "Dispositions_Pendings_Forms",
	},
	Dispositions_Pendings_Items : {
		_name : "Dispositions_Pendings_Items",
	},
	Acquisitions_Pendings_Products : {
		_name : "Acquisitions_Pendings_Products",
	},
	Transactions_Questions : {
		_name : "Transactions_Questions",
	},
	Transactions_Signatures : {
		_name : "Transactions_Signatures",
	},
	Transactions_Signatures_Locations : {
		_name : "Transactions_Signatures_Locations",
	},
	Transactions_Types : {
		_name : "Transactions_Types",
	},
	Turnstile : {
		_name : "Turnstile",
	},
	Unexpected_Errors : {
		_name : "Unexpected_Errors",
	},
	Upc_Center : {
		_name : "Upc_Center",
	},
	Upc_Center_Logs : {
		_name : "Upc_Center_Logs",
	},
	Upgrades : {
		_name : "Upgrades",
	},
	Users : {
		_name : "Users",
	},
	Vendors : {
		_name : "Vendors",
	},
	States : {
		_name : "States",
	},
	Nics_Responses : {
		_name : "Nics_Responses",
	},
	Nics_Delays : {
		_name : "Nics_Delays",
	},
	Nics_After : {
		_name : "Nics_After",
	},
	Manufacturers : {
		_name : "Manufacturers",
	},
	Leep_Questions : {
		_name : "Leep_Questions",
	},
	Importers_Forms : {
		_name : "Importers_Forms",
	},
	Forms : {
		_name : "Forms",
	},
	Ffls_Classes : {
		_name : "Ffls_Classes",
	},
	Ffls : {
		_name : "Ffls",
	},
	Calibers : {
		_name : "Calibers",
	},
	Accounts_Data_Usage : {
		_name : "Accounts_Data_Usage",
	},
	Users_Accesses : {
		_name : "Users_Accesses",
	},
	Ffls_Types : {
		_name : "Ffls_Types",
	},
};
export default Types;
